import $n, { createContext as Qr, useContext as to, useRef as ve, useEffect as we, forwardRef as qi, useImperativeHandle as Ki, useState as Wi, useCallback as Dh, useMemo as Eh } from "react";
import { jsxs as si, jsx as Dt, Fragment as Ah } from "react/jsx-runtime";
import { createPortal as zh } from "react-dom";
const eo = Qr({}), hs = () => to(eo);
//! moment.js
//! version : 2.29.4
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
var io;
function w() {
  return io.apply(null, arguments);
}
function Ih(i) {
  io = i;
}
function At(i) {
  return i instanceof Array || Object.prototype.toString.call(i) === "[object Array]";
}
function ye(i) {
  return i != null && Object.prototype.toString.call(i) === "[object Object]";
}
function Y(i, s) {
  return Object.prototype.hasOwnProperty.call(i, s);
}
function us(i) {
  if (Object.getOwnPropertyNames)
    return Object.getOwnPropertyNames(i).length === 0;
  var s;
  for (s in i)
    if (Y(i, s))
      return !1;
  return !0;
}
function pt(i) {
  return i === void 0;
}
function ee(i) {
  return typeof i == "number" || Object.prototype.toString.call(i) === "[object Number]";
}
function li(i) {
  return i instanceof Date || Object.prototype.toString.call(i) === "[object Date]";
}
function no(i, s) {
  var r = [], a, u = i.length;
  for (a = 0; a < u; ++a)
    r.push(s(i[a], a));
  return r;
}
function ae(i, s) {
  for (var r in s)
    Y(s, r) && (i[r] = s[r]);
  return Y(s, "toString") && (i.toString = s.toString), Y(s, "valueOf") && (i.valueOf = s.valueOf), i;
}
function Ft(i, s, r, a) {
  return ko(i, s, r, a, !0).utc();
}
function Nh() {
  return {
    empty: !1,
    unusedTokens: [],
    unusedInput: [],
    overflow: -2,
    charsLeftOver: 0,
    nullInput: !1,
    invalidEra: null,
    invalidMonth: null,
    invalidFormat: !1,
    userInvalidated: !1,
    iso: !1,
    parsedDateParts: [],
    era: null,
    meridiem: null,
    rfc2822: !1,
    weekdayMismatch: !1
  };
}
function E(i) {
  return i._pf == null && (i._pf = Nh()), i._pf;
}
var Qn;
Array.prototype.some ? Qn = Array.prototype.some : Qn = function(i) {
  var s = Object(this), r = s.length >>> 0, a;
  for (a = 0; a < r; a++)
    if (a in s && i.call(this, s[a], a, s))
      return !0;
  return !1;
};
function ls(i) {
  if (i._isValid == null) {
    var s = E(i), r = Qn.call(s.parsedDateParts, function(u) {
      return u != null;
    }), a = !isNaN(i._d.getTime()) && s.overflow < 0 && !s.empty && !s.invalidEra && !s.invalidMonth && !s.invalidWeekday && !s.weekdayMismatch && !s.nullInput && !s.invalidFormat && !s.userInvalidated && (!s.meridiem || s.meridiem && r);
    if (i._strict && (a = a && s.charsLeftOver === 0 && s.unusedTokens.length === 0 && s.bigHour === void 0), Object.isFrozen == null || !Object.isFrozen(i))
      i._isValid = a;
    else
      return a;
  }
  return i._isValid;
}
function Xi(i) {
  var s = Ft(NaN);
  return i != null ? ae(E(s), i) : E(s).userInvalidated = !0, s;
}
var Vr = w.momentProperties = [], qn = !1;
function cs(i, s) {
  var r, a, u, c = Vr.length;
  if (pt(s._isAMomentObject) || (i._isAMomentObject = s._isAMomentObject), pt(s._i) || (i._i = s._i), pt(s._f) || (i._f = s._f), pt(s._l) || (i._l = s._l), pt(s._strict) || (i._strict = s._strict), pt(s._tzm) || (i._tzm = s._tzm), pt(s._isUTC) || (i._isUTC = s._isUTC), pt(s._offset) || (i._offset = s._offset), pt(s._pf) || (i._pf = E(s)), pt(s._locale) || (i._locale = s._locale), c > 0)
    for (r = 0; r < c; r++)
      a = Vr[r], u = s[a], pt(u) || (i[a] = u);
  return i;
}
function ci(i) {
  cs(this, i), this._d = new Date(i._d != null ? i._d.getTime() : NaN), this.isValid() || (this._d = /* @__PURE__ */ new Date(NaN)), qn === !1 && (qn = !0, w.updateOffset(this), qn = !1);
}
function zt(i) {
  return i instanceof ci || i != null && i._isAMomentObject != null;
}
function so(i) {
  w.suppressDeprecationWarnings === !1 && typeof console < "u" && console.warn && console.warn("Deprecation warning: " + i);
}
function Tt(i, s) {
  var r = !0;
  return ae(function() {
    if (w.deprecationHandler != null && w.deprecationHandler(null, i), r) {
      var a = [], u, c, d, y = arguments.length;
      for (c = 0; c < y; c++) {
        if (u = "", typeof arguments[c] == "object") {
          u += `
[` + c + "] ";
          for (d in arguments[0])
            Y(arguments[0], d) && (u += d + ": " + arguments[0][d] + ", ");
          u = u.slice(0, -2);
        } else
          u = arguments[c];
        a.push(u);
      }
      so(
        i + `
Arguments: ` + Array.prototype.slice.call(a).join("") + `
` + new Error().stack
      ), r = !1;
    }
    return s.apply(this, arguments);
  }, s);
}
var jr = {};
function ro(i, s) {
  w.deprecationHandler != null && w.deprecationHandler(i, s), jr[i] || (so(s), jr[i] = !0);
}
w.suppressDeprecationWarnings = !1;
w.deprecationHandler = null;
function Ht(i) {
  return typeof Function < "u" && i instanceof Function || Object.prototype.toString.call(i) === "[object Function]";
}
function Rh(i) {
  var s, r;
  for (r in i)
    Y(i, r) && (s = i[r], Ht(s) ? this[r] = s : this["_" + r] = s);
  this._config = i, this._dayOfMonthOrdinalParseLenient = new RegExp(
    (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source
  );
}
function ts(i, s) {
  var r = ae({}, i), a;
  for (a in s)
    Y(s, a) && (ye(i[a]) && ye(s[a]) ? (r[a] = {}, ae(r[a], i[a]), ae(r[a], s[a])) : s[a] != null ? r[a] = s[a] : delete r[a]);
  for (a in i)
    Y(i, a) && !Y(s, a) && ye(i[a]) && (r[a] = ae({}, r[a]));
  return r;
}
function fs(i) {
  i != null && this.set(i);
}
var es;
Object.keys ? es = Object.keys : es = function(i) {
  var s, r = [];
  for (s in i)
    Y(i, s) && r.push(s);
  return r;
};
var Zh = {
  sameDay: "[Today at] LT",
  nextDay: "[Tomorrow at] LT",
  nextWeek: "dddd [at] LT",
  lastDay: "[Yesterday at] LT",
  lastWeek: "[Last] dddd [at] LT",
  sameElse: "L"
};
function Bh(i, s, r) {
  var a = this._calendar[i] || this._calendar.sameElse;
  return Ht(a) ? a.call(s, r) : a;
}
function Wt(i, s, r) {
  var a = "" + Math.abs(i), u = s - a.length, c = i >= 0;
  return (c ? r ? "+" : "" : "-") + Math.pow(10, Math.max(0, u)).toString().substr(1) + a;
}
var ds = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, Ni = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, Kn = {}, Ie = {};
function b(i, s, r, a) {
  var u = a;
  typeof a == "string" && (u = function() {
    return this[a]();
  }), i && (Ie[i] = u), s && (Ie[s[0]] = function() {
    return Wt(u.apply(this, arguments), s[1], s[2]);
  }), r && (Ie[r] = function() {
    return this.localeData().ordinal(
      u.apply(this, arguments),
      i
    );
  });
}
function Yh(i) {
  return i.match(/\[[\s\S]/) ? i.replace(/^\[|\]$/g, "") : i.replace(/\\/g, "");
}
function Wh(i) {
  var s = i.match(ds), r, a;
  for (r = 0, a = s.length; r < a; r++)
    Ie[s[r]] ? s[r] = Ie[s[r]] : s[r] = Yh(s[r]);
  return function(u) {
    var c = "", d;
    for (d = 0; d < a; d++)
      c += Ht(s[d]) ? s[d].call(u, i) : s[d];
    return c;
  };
}
function Zi(i, s) {
  return i.isValid() ? (s = oo(s, i.localeData()), Kn[s] = Kn[s] || Wh(s), Kn[s](i)) : i.localeData().invalidDate();
}
function oo(i, s) {
  var r = 5;
  function a(u) {
    return s.longDateFormat(u) || u;
  }
  for (Ni.lastIndex = 0; r >= 0 && Ni.test(i); )
    i = i.replace(
      Ni,
      a
    ), Ni.lastIndex = 0, r -= 1;
  return i;
}
var Fh = {
  LTS: "h:mm:ss A",
  LT: "h:mm A",
  L: "MM/DD/YYYY",
  LL: "MMMM D, YYYY",
  LLL: "MMMM D, YYYY h:mm A",
  LLLL: "dddd, MMMM D, YYYY h:mm A"
};
function Hh(i) {
  var s = this._longDateFormat[i], r = this._longDateFormat[i.toUpperCase()];
  return s || !r ? s : (this._longDateFormat[i] = r.match(ds).map(function(a) {
    return a === "MMMM" || a === "MM" || a === "DD" || a === "dddd" ? a.slice(1) : a;
  }).join(""), this._longDateFormat[i]);
}
var Uh = "Invalid date";
function Gh() {
  return this._invalidDate;
}
var Vh = "%d", jh = /\d{1,2}/;
function qh(i) {
  return this._ordinal.replace("%d", i);
}
var Kh = {
  future: "in %s",
  past: "%s ago",
  s: "a few seconds",
  ss: "%d seconds",
  m: "a minute",
  mm: "%d minutes",
  h: "an hour",
  hh: "%d hours",
  d: "a day",
  dd: "%d days",
  w: "a week",
  ww: "%d weeks",
  M: "a month",
  MM: "%d months",
  y: "a year",
  yy: "%d years"
};
function Xh(i, s, r, a) {
  var u = this._relativeTime[r];
  return Ht(u) ? u(i, s, r, a) : u.replace(/%d/i, i);
}
function Jh(i, s) {
  var r = this._relativeTime[i > 0 ? "future" : "past"];
  return Ht(r) ? r(s) : r.replace(/%s/i, s);
}
var ri = {};
function ut(i, s) {
  var r = i.toLowerCase();
  ri[r] = ri[r + "s"] = ri[s] = i;
}
function St(i) {
  return typeof i == "string" ? ri[i] || ri[i.toLowerCase()] : void 0;
}
function _s(i) {
  var s = {}, r, a;
  for (a in i)
    Y(i, a) && (r = St(a), r && (s[r] = i[a]));
  return s;
}
var ao = {};
function lt(i, s) {
  ao[i] = s;
}
function $h(i) {
  var s = [], r;
  for (r in i)
    Y(i, r) && s.push({ unit: r, priority: ao[r] });
  return s.sort(function(a, u) {
    return a.priority - u.priority;
  }), s;
}
function Ji(i) {
  return i % 4 === 0 && i % 100 !== 0 || i % 400 === 0;
}
function bt(i) {
  return i < 0 ? Math.ceil(i) || 0 : Math.floor(i);
}
function I(i) {
  var s = +i, r = 0;
  return s !== 0 && isFinite(s) && (r = bt(s)), r;
}
function Ze(i, s) {
  return function(r) {
    return r != null ? (ho(this, i, r), w.updateOffset(this, s), this) : Fi(this, i);
  };
}
function Fi(i, s) {
  return i.isValid() ? i._d["get" + (i._isUTC ? "UTC" : "") + s]() : NaN;
}
function ho(i, s, r) {
  i.isValid() && !isNaN(r) && (s === "FullYear" && Ji(i.year()) && i.month() === 1 && i.date() === 29 ? (r = I(r), i._d["set" + (i._isUTC ? "UTC" : "") + s](
    r,
    i.month(),
    sn(r, i.month())
  )) : i._d["set" + (i._isUTC ? "UTC" : "") + s](r));
}
function Qh(i) {
  return i = St(i), Ht(this[i]) ? this[i]() : this;
}
function tu(i, s) {
  if (typeof i == "object") {
    i = _s(i);
    var r = $h(i), a, u = r.length;
    for (a = 0; a < u; a++)
      this[r[a].unit](i[r[a].unit]);
  } else if (i = St(i), Ht(this[i]))
    return this[i](s);
  return this;
}
var uo = /\d/, yt = /\d\d/, lo = /\d{3}/, ms = /\d{4}/, $i = /[+-]?\d{6}/, K = /\d\d?/, co = /\d\d\d\d?/, fo = /\d\d\d\d\d\d?/, Qi = /\d{1,3}/, ps = /\d{1,4}/, tn = /[+-]?\d{1,6}/, Be = /\d+/, en = /[+-]?\d+/, eu = /Z|[+-]\d\d:?\d\d/gi, nn = /Z|[+-]\d\d(?::?\d\d)?/gi, iu = /[+-]?\d+(\.\d{1,3})?/, fi = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, Hi;
Hi = {};
function P(i, s, r) {
  Hi[i] = Ht(s) ? s : function(a, u) {
    return a && r ? r : s;
  };
}
function nu(i, s) {
  return Y(Hi, i) ? Hi[i](s._strict, s._locale) : new RegExp(su(i));
}
function su(i) {
  return vt(
    i.replace("\\", "").replace(
      /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
      function(s, r, a, u, c) {
        return r || a || u || c;
      }
    )
  );
}
function vt(i) {
  return i.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
}
var is = {};
function V(i, s) {
  var r, a = s, u;
  for (typeof i == "string" && (i = [i]), ee(s) && (a = function(c, d) {
    d[s] = I(c);
  }), u = i.length, r = 0; r < u; r++)
    is[i[r]] = a;
}
function di(i, s) {
  V(i, function(r, a, u, c) {
    u._w = u._w || {}, s(r, u._w, u, c);
  });
}
function ru(i, s, r) {
  s != null && Y(is, i) && is[i](s, r._a, r, i);
}
var ht = 0, $t = 1, Yt = 2, st = 3, Et = 4, Qt = 5, ge = 6, ou = 7, au = 8;
function hu(i, s) {
  return (i % s + s) % s;
}
var tt;
Array.prototype.indexOf ? tt = Array.prototype.indexOf : tt = function(i) {
  var s;
  for (s = 0; s < this.length; ++s)
    if (this[s] === i)
      return s;
  return -1;
};
function sn(i, s) {
  if (isNaN(i) || isNaN(s))
    return NaN;
  var r = hu(s, 12);
  return i += (s - r) / 12, r === 1 ? Ji(i) ? 29 : 28 : 31 - r % 7 % 2;
}
b("M", ["MM", 2], "Mo", function() {
  return this.month() + 1;
});
b("MMM", 0, 0, function(i) {
  return this.localeData().monthsShort(this, i);
});
b("MMMM", 0, 0, function(i) {
  return this.localeData().months(this, i);
});
ut("month", "M");
lt("month", 8);
P("M", K);
P("MM", K, yt);
P("MMM", function(i, s) {
  return s.monthsShortRegex(i);
});
P("MMMM", function(i, s) {
  return s.monthsRegex(i);
});
V(["M", "MM"], function(i, s) {
  s[$t] = I(i) - 1;
});
V(["MMM", "MMMM"], function(i, s, r, a) {
  var u = r._locale.monthsParse(i, a, r._strict);
  u != null ? s[$t] = u : E(r).invalidMonth = i;
});
var uu = "January_February_March_April_May_June_July_August_September_October_November_December".split(
  "_"
), _o = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), mo = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, lu = fi, cu = fi;
function fu(i, s) {
  return i ? At(this._months) ? this._months[i.month()] : this._months[(this._months.isFormat || mo).test(s) ? "format" : "standalone"][i.month()] : At(this._months) ? this._months : this._months.standalone;
}
function du(i, s) {
  return i ? At(this._monthsShort) ? this._monthsShort[i.month()] : this._monthsShort[mo.test(s) ? "format" : "standalone"][i.month()] : At(this._monthsShort) ? this._monthsShort : this._monthsShort.standalone;
}
function _u(i, s, r) {
  var a, u, c, d = i.toLocaleLowerCase();
  if (!this._monthsParse)
    for (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], a = 0; a < 12; ++a)
      c = Ft([2e3, a]), this._shortMonthsParse[a] = this.monthsShort(
        c,
        ""
      ).toLocaleLowerCase(), this._longMonthsParse[a] = this.months(c, "").toLocaleLowerCase();
  return r ? s === "MMM" ? (u = tt.call(this._shortMonthsParse, d), u !== -1 ? u : null) : (u = tt.call(this._longMonthsParse, d), u !== -1 ? u : null) : s === "MMM" ? (u = tt.call(this._shortMonthsParse, d), u !== -1 ? u : (u = tt.call(this._longMonthsParse, d), u !== -1 ? u : null)) : (u = tt.call(this._longMonthsParse, d), u !== -1 ? u : (u = tt.call(this._shortMonthsParse, d), u !== -1 ? u : null));
}
function mu(i, s, r) {
  var a, u, c;
  if (this._monthsParseExact)
    return _u.call(this, i, s, r);
  for (this._monthsParse || (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = []), a = 0; a < 12; a++) {
    if (u = Ft([2e3, a]), r && !this._longMonthsParse[a] && (this._longMonthsParse[a] = new RegExp(
      "^" + this.months(u, "").replace(".", "") + "$",
      "i"
    ), this._shortMonthsParse[a] = new RegExp(
      "^" + this.monthsShort(u, "").replace(".", "") + "$",
      "i"
    )), !r && !this._monthsParse[a] && (c = "^" + this.months(u, "") + "|^" + this.monthsShort(u, ""), this._monthsParse[a] = new RegExp(c.replace(".", ""), "i")), r && s === "MMMM" && this._longMonthsParse[a].test(i))
      return a;
    if (r && s === "MMM" && this._shortMonthsParse[a].test(i))
      return a;
    if (!r && this._monthsParse[a].test(i))
      return a;
  }
}
function po(i, s) {
  var r;
  if (!i.isValid())
    return i;
  if (typeof s == "string") {
    if (/^\d+$/.test(s))
      s = I(s);
    else if (s = i.localeData().monthsParse(s), !ee(s))
      return i;
  }
  return r = Math.min(i.date(), sn(i.year(), s)), i._d["set" + (i._isUTC ? "UTC" : "") + "Month"](s, r), i;
}
function go(i) {
  return i != null ? (po(this, i), w.updateOffset(this, !0), this) : Fi(this, "Month");
}
function pu() {
  return sn(this.year(), this.month());
}
function gu(i) {
  return this._monthsParseExact ? (Y(this, "_monthsRegex") || vo.call(this), i ? this._monthsShortStrictRegex : this._monthsShortRegex) : (Y(this, "_monthsShortRegex") || (this._monthsShortRegex = lu), this._monthsShortStrictRegex && i ? this._monthsShortStrictRegex : this._monthsShortRegex);
}
function vu(i) {
  return this._monthsParseExact ? (Y(this, "_monthsRegex") || vo.call(this), i ? this._monthsStrictRegex : this._monthsRegex) : (Y(this, "_monthsRegex") || (this._monthsRegex = cu), this._monthsStrictRegex && i ? this._monthsStrictRegex : this._monthsRegex);
}
function vo() {
  function i(d, y) {
    return y.length - d.length;
  }
  var s = [], r = [], a = [], u, c;
  for (u = 0; u < 12; u++)
    c = Ft([2e3, u]), s.push(this.monthsShort(c, "")), r.push(this.months(c, "")), a.push(this.months(c, "")), a.push(this.monthsShort(c, ""));
  for (s.sort(i), r.sort(i), a.sort(i), u = 0; u < 12; u++)
    s[u] = vt(s[u]), r[u] = vt(r[u]);
  for (u = 0; u < 24; u++)
    a[u] = vt(a[u]);
  this._monthsRegex = new RegExp("^(" + a.join("|") + ")", "i"), this._monthsShortRegex = this._monthsRegex, this._monthsStrictRegex = new RegExp(
    "^(" + r.join("|") + ")",
    "i"
  ), this._monthsShortStrictRegex = new RegExp(
    "^(" + s.join("|") + ")",
    "i"
  );
}
b("Y", 0, 0, function() {
  var i = this.year();
  return i <= 9999 ? Wt(i, 4) : "+" + i;
});
b(0, ["YY", 2], 0, function() {
  return this.year() % 100;
});
b(0, ["YYYY", 4], 0, "year");
b(0, ["YYYYY", 5], 0, "year");
b(0, ["YYYYYY", 6, !0], 0, "year");
ut("year", "y");
lt("year", 1);
P("Y", en);
P("YY", K, yt);
P("YYYY", ps, ms);
P("YYYYY", tn, $i);
P("YYYYYY", tn, $i);
V(["YYYYY", "YYYYYY"], ht);
V("YYYY", function(i, s) {
  s[ht] = i.length === 2 ? w.parseTwoDigitYear(i) : I(i);
});
V("YY", function(i, s) {
  s[ht] = w.parseTwoDigitYear(i);
});
V("Y", function(i, s) {
  s[ht] = parseInt(i, 10);
});
function oi(i) {
  return Ji(i) ? 366 : 365;
}
w.parseTwoDigitYear = function(i) {
  return I(i) + (I(i) > 68 ? 1900 : 2e3);
};
var yo = Ze("FullYear", !0);
function yu() {
  return Ji(this.year());
}
function wu(i, s, r, a, u, c, d) {
  var y;
  return i < 100 && i >= 0 ? (y = new Date(i + 400, s, r, a, u, c, d), isFinite(y.getFullYear()) && y.setFullYear(i)) : y = new Date(i, s, r, a, u, c, d), y;
}
function ai(i) {
  var s, r;
  return i < 100 && i >= 0 ? (r = Array.prototype.slice.call(arguments), r[0] = i + 400, s = new Date(Date.UTC.apply(null, r)), isFinite(s.getUTCFullYear()) && s.setUTCFullYear(i)) : s = new Date(Date.UTC.apply(null, arguments)), s;
}
function Ui(i, s, r) {
  var a = 7 + s - r, u = (7 + ai(i, 0, a).getUTCDay() - s) % 7;
  return -u + a - 1;
}
function wo(i, s, r, a, u) {
  var c = (7 + r - a) % 7, d = Ui(i, a, u), y = 1 + 7 * (s - 1) + c + d, g, k;
  return y <= 0 ? (g = i - 1, k = oi(g) + y) : y > oi(i) ? (g = i + 1, k = y - oi(i)) : (g = i, k = y), {
    year: g,
    dayOfYear: k
  };
}
function hi(i, s, r) {
  var a = Ui(i.year(), s, r), u = Math.floor((i.dayOfYear() - a - 1) / 7) + 1, c, d;
  return u < 1 ? (d = i.year() - 1, c = u + te(d, s, r)) : u > te(i.year(), s, r) ? (c = u - te(i.year(), s, r), d = i.year() + 1) : (d = i.year(), c = u), {
    week: c,
    year: d
  };
}
function te(i, s, r) {
  var a = Ui(i, s, r), u = Ui(i + 1, s, r);
  return (oi(i) - a + u) / 7;
}
b("w", ["ww", 2], "wo", "week");
b("W", ["WW", 2], "Wo", "isoWeek");
ut("week", "w");
ut("isoWeek", "W");
lt("week", 5);
lt("isoWeek", 5);
P("w", K);
P("ww", K, yt);
P("W", K);
P("WW", K, yt);
di(
  ["w", "ww", "W", "WW"],
  function(i, s, r, a) {
    s[a.substr(0, 1)] = I(i);
  }
);
function xu(i) {
  return hi(i, this._week.dow, this._week.doy).week;
}
var Pu = {
  dow: 0,
  // Sunday is the first day of the week.
  doy: 6
  // The week that contains Jan 6th is the first week of the year.
};
function Lu() {
  return this._week.dow;
}
function Mu() {
  return this._week.doy;
}
function bu(i) {
  var s = this.localeData().week(this);
  return i == null ? s : this.add((i - s) * 7, "d");
}
function Tu(i) {
  var s = hi(this, 1, 4).week;
  return i == null ? s : this.add((i - s) * 7, "d");
}
b("d", 0, "do", "day");
b("dd", 0, 0, function(i) {
  return this.localeData().weekdaysMin(this, i);
});
b("ddd", 0, 0, function(i) {
  return this.localeData().weekdaysShort(this, i);
});
b("dddd", 0, 0, function(i) {
  return this.localeData().weekdays(this, i);
});
b("e", 0, 0, "weekday");
b("E", 0, 0, "isoWeekday");
ut("day", "d");
ut("weekday", "e");
ut("isoWeekday", "E");
lt("day", 11);
lt("weekday", 11);
lt("isoWeekday", 11);
P("d", K);
P("e", K);
P("E", K);
P("dd", function(i, s) {
  return s.weekdaysMinRegex(i);
});
P("ddd", function(i, s) {
  return s.weekdaysShortRegex(i);
});
P("dddd", function(i, s) {
  return s.weekdaysRegex(i);
});
di(["dd", "ddd", "dddd"], function(i, s, r, a) {
  var u = r._locale.weekdaysParse(i, a, r._strict);
  u != null ? s.d = u : E(r).invalidWeekday = i;
});
di(["d", "e", "E"], function(i, s, r, a) {
  s[a] = I(i);
});
function Su(i, s) {
  return typeof i != "string" ? i : isNaN(i) ? (i = s.weekdaysParse(i), typeof i == "number" ? i : null) : parseInt(i, 10);
}
function ku(i, s) {
  return typeof i == "string" ? s.weekdaysParse(i) % 7 || 7 : isNaN(i) ? null : i;
}
function gs(i, s) {
  return i.slice(s, 7).concat(i.slice(0, s));
}
var Ou = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), xo = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), Cu = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), Du = fi, Eu = fi, Au = fi;
function zu(i, s) {
  var r = At(this._weekdays) ? this._weekdays : this._weekdays[i && i !== !0 && this._weekdays.isFormat.test(s) ? "format" : "standalone"];
  return i === !0 ? gs(r, this._week.dow) : i ? r[i.day()] : r;
}
function Iu(i) {
  return i === !0 ? gs(this._weekdaysShort, this._week.dow) : i ? this._weekdaysShort[i.day()] : this._weekdaysShort;
}
function Nu(i) {
  return i === !0 ? gs(this._weekdaysMin, this._week.dow) : i ? this._weekdaysMin[i.day()] : this._weekdaysMin;
}
function Ru(i, s, r) {
  var a, u, c, d = i.toLocaleLowerCase();
  if (!this._weekdaysParse)
    for (this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], a = 0; a < 7; ++a)
      c = Ft([2e3, 1]).day(a), this._minWeekdaysParse[a] = this.weekdaysMin(
        c,
        ""
      ).toLocaleLowerCase(), this._shortWeekdaysParse[a] = this.weekdaysShort(
        c,
        ""
      ).toLocaleLowerCase(), this._weekdaysParse[a] = this.weekdays(c, "").toLocaleLowerCase();
  return r ? s === "dddd" ? (u = tt.call(this._weekdaysParse, d), u !== -1 ? u : null) : s === "ddd" ? (u = tt.call(this._shortWeekdaysParse, d), u !== -1 ? u : null) : (u = tt.call(this._minWeekdaysParse, d), u !== -1 ? u : null) : s === "dddd" ? (u = tt.call(this._weekdaysParse, d), u !== -1 || (u = tt.call(this._shortWeekdaysParse, d), u !== -1) ? u : (u = tt.call(this._minWeekdaysParse, d), u !== -1 ? u : null)) : s === "ddd" ? (u = tt.call(this._shortWeekdaysParse, d), u !== -1 || (u = tt.call(this._weekdaysParse, d), u !== -1) ? u : (u = tt.call(this._minWeekdaysParse, d), u !== -1 ? u : null)) : (u = tt.call(this._minWeekdaysParse, d), u !== -1 || (u = tt.call(this._weekdaysParse, d), u !== -1) ? u : (u = tt.call(this._shortWeekdaysParse, d), u !== -1 ? u : null));
}
function Zu(i, s, r) {
  var a, u, c;
  if (this._weekdaysParseExact)
    return Ru.call(this, i, s, r);
  for (this._weekdaysParse || (this._weekdaysParse = [], this._minWeekdaysParse = [], this._shortWeekdaysParse = [], this._fullWeekdaysParse = []), a = 0; a < 7; a++) {
    if (u = Ft([2e3, 1]).day(a), r && !this._fullWeekdaysParse[a] && (this._fullWeekdaysParse[a] = new RegExp(
      "^" + this.weekdays(u, "").replace(".", "\\.?") + "$",
      "i"
    ), this._shortWeekdaysParse[a] = new RegExp(
      "^" + this.weekdaysShort(u, "").replace(".", "\\.?") + "$",
      "i"
    ), this._minWeekdaysParse[a] = new RegExp(
      "^" + this.weekdaysMin(u, "").replace(".", "\\.?") + "$",
      "i"
    )), this._weekdaysParse[a] || (c = "^" + this.weekdays(u, "") + "|^" + this.weekdaysShort(u, "") + "|^" + this.weekdaysMin(u, ""), this._weekdaysParse[a] = new RegExp(c.replace(".", ""), "i")), r && s === "dddd" && this._fullWeekdaysParse[a].test(i))
      return a;
    if (r && s === "ddd" && this._shortWeekdaysParse[a].test(i))
      return a;
    if (r && s === "dd" && this._minWeekdaysParse[a].test(i))
      return a;
    if (!r && this._weekdaysParse[a].test(i))
      return a;
  }
}
function Bu(i) {
  if (!this.isValid())
    return i != null ? this : NaN;
  var s = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
  return i != null ? (i = Su(i, this.localeData()), this.add(i - s, "d")) : s;
}
function Yu(i) {
  if (!this.isValid())
    return i != null ? this : NaN;
  var s = (this.day() + 7 - this.localeData()._week.dow) % 7;
  return i == null ? s : this.add(i - s, "d");
}
function Wu(i) {
  if (!this.isValid())
    return i != null ? this : NaN;
  if (i != null) {
    var s = ku(i, this.localeData());
    return this.day(this.day() % 7 ? s : s - 7);
  } else
    return this.day() || 7;
}
function Fu(i) {
  return this._weekdaysParseExact ? (Y(this, "_weekdaysRegex") || vs.call(this), i ? this._weekdaysStrictRegex : this._weekdaysRegex) : (Y(this, "_weekdaysRegex") || (this._weekdaysRegex = Du), this._weekdaysStrictRegex && i ? this._weekdaysStrictRegex : this._weekdaysRegex);
}
function Hu(i) {
  return this._weekdaysParseExact ? (Y(this, "_weekdaysRegex") || vs.call(this), i ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex) : (Y(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = Eu), this._weekdaysShortStrictRegex && i ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex);
}
function Uu(i) {
  return this._weekdaysParseExact ? (Y(this, "_weekdaysRegex") || vs.call(this), i ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex) : (Y(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = Au), this._weekdaysMinStrictRegex && i ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex);
}
function vs() {
  function i(F, D) {
    return D.length - F.length;
  }
  var s = [], r = [], a = [], u = [], c, d, y, g, k;
  for (c = 0; c < 7; c++)
    d = Ft([2e3, 1]).day(c), y = vt(this.weekdaysMin(d, "")), g = vt(this.weekdaysShort(d, "")), k = vt(this.weekdays(d, "")), s.push(y), r.push(g), a.push(k), u.push(y), u.push(g), u.push(k);
  s.sort(i), r.sort(i), a.sort(i), u.sort(i), this._weekdaysRegex = new RegExp("^(" + u.join("|") + ")", "i"), this._weekdaysShortRegex = this._weekdaysRegex, this._weekdaysMinRegex = this._weekdaysRegex, this._weekdaysStrictRegex = new RegExp(
    "^(" + a.join("|") + ")",
    "i"
  ), this._weekdaysShortStrictRegex = new RegExp(
    "^(" + r.join("|") + ")",
    "i"
  ), this._weekdaysMinStrictRegex = new RegExp(
    "^(" + s.join("|") + ")",
    "i"
  );
}
function ys() {
  return this.hours() % 12 || 12;
}
function Gu() {
  return this.hours() || 24;
}
b("H", ["HH", 2], 0, "hour");
b("h", ["hh", 2], 0, ys);
b("k", ["kk", 2], 0, Gu);
b("hmm", 0, 0, function() {
  return "" + ys.apply(this) + Wt(this.minutes(), 2);
});
b("hmmss", 0, 0, function() {
  return "" + ys.apply(this) + Wt(this.minutes(), 2) + Wt(this.seconds(), 2);
});
b("Hmm", 0, 0, function() {
  return "" + this.hours() + Wt(this.minutes(), 2);
});
b("Hmmss", 0, 0, function() {
  return "" + this.hours() + Wt(this.minutes(), 2) + Wt(this.seconds(), 2);
});
function Po(i, s) {
  b(i, 0, 0, function() {
    return this.localeData().meridiem(
      this.hours(),
      this.minutes(),
      s
    );
  });
}
Po("a", !0);
Po("A", !1);
ut("hour", "h");
lt("hour", 13);
function Lo(i, s) {
  return s._meridiemParse;
}
P("a", Lo);
P("A", Lo);
P("H", K);
P("h", K);
P("k", K);
P("HH", K, yt);
P("hh", K, yt);
P("kk", K, yt);
P("hmm", co);
P("hmmss", fo);
P("Hmm", co);
P("Hmmss", fo);
V(["H", "HH"], st);
V(["k", "kk"], function(i, s, r) {
  var a = I(i);
  s[st] = a === 24 ? 0 : a;
});
V(["a", "A"], function(i, s, r) {
  r._isPm = r._locale.isPM(i), r._meridiem = i;
});
V(["h", "hh"], function(i, s, r) {
  s[st] = I(i), E(r).bigHour = !0;
});
V("hmm", function(i, s, r) {
  var a = i.length - 2;
  s[st] = I(i.substr(0, a)), s[Et] = I(i.substr(a)), E(r).bigHour = !0;
});
V("hmmss", function(i, s, r) {
  var a = i.length - 4, u = i.length - 2;
  s[st] = I(i.substr(0, a)), s[Et] = I(i.substr(a, 2)), s[Qt] = I(i.substr(u)), E(r).bigHour = !0;
});
V("Hmm", function(i, s, r) {
  var a = i.length - 2;
  s[st] = I(i.substr(0, a)), s[Et] = I(i.substr(a));
});
V("Hmmss", function(i, s, r) {
  var a = i.length - 4, u = i.length - 2;
  s[st] = I(i.substr(0, a)), s[Et] = I(i.substr(a, 2)), s[Qt] = I(i.substr(u));
});
function Vu(i) {
  return (i + "").toLowerCase().charAt(0) === "p";
}
var ju = /[ap]\.?m?\.?/i, qu = Ze("Hours", !0);
function Ku(i, s, r) {
  return i > 11 ? r ? "pm" : "PM" : r ? "am" : "AM";
}
var Mo = {
  calendar: Zh,
  longDateFormat: Fh,
  invalidDate: Uh,
  ordinal: Vh,
  dayOfMonthOrdinalParse: jh,
  relativeTime: Kh,
  months: uu,
  monthsShort: _o,
  week: Pu,
  weekdays: Ou,
  weekdaysMin: Cu,
  weekdaysShort: xo,
  meridiemParse: ju
}, X = {}, ii = {}, ui;
function Xu(i, s) {
  var r, a = Math.min(i.length, s.length);
  for (r = 0; r < a; r += 1)
    if (i[r] !== s[r])
      return r;
  return a;
}
function qr(i) {
  return i && i.toLowerCase().replace("_", "-");
}
function Ju(i) {
  for (var s = 0, r, a, u, c; s < i.length; ) {
    for (c = qr(i[s]).split("-"), r = c.length, a = qr(i[s + 1]), a = a ? a.split("-") : null; r > 0; ) {
      if (u = rn(c.slice(0, r).join("-")), u)
        return u;
      if (a && a.length >= r && Xu(c, a) >= r - 1)
        break;
      r--;
    }
    s++;
  }
  return ui;
}
function $u(i) {
  return i.match("^[^/\\\\]*$") != null;
}
function rn(i) {
  var s = null, r;
  if (X[i] === void 0 && typeof module < "u" && module && module.exports && $u(i))
    try {
      s = ui._abbr, r = require, r("./locale/" + i), ue(s);
    } catch {
      X[i] = null;
    }
  return X[i];
}
function ue(i, s) {
  var r;
  return i && (pt(s) ? r = ie(i) : r = ws(i, s), r ? ui = r : typeof console < "u" && console.warn && console.warn(
    "Locale " + i + " not found. Did you forget to load it?"
  )), ui._abbr;
}
function ws(i, s) {
  if (s !== null) {
    var r, a = Mo;
    if (s.abbr = i, X[i] != null)
      ro(
        "defineLocaleOverride",
        "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."
      ), a = X[i]._config;
    else if (s.parentLocale != null)
      if (X[s.parentLocale] != null)
        a = X[s.parentLocale]._config;
      else if (r = rn(s.parentLocale), r != null)
        a = r._config;
      else
        return ii[s.parentLocale] || (ii[s.parentLocale] = []), ii[s.parentLocale].push({
          name: i,
          config: s
        }), null;
    return X[i] = new fs(ts(a, s)), ii[i] && ii[i].forEach(function(u) {
      ws(u.name, u.config);
    }), ue(i), X[i];
  } else
    return delete X[i], null;
}
function Qu(i, s) {
  if (s != null) {
    var r, a, u = Mo;
    X[i] != null && X[i].parentLocale != null ? X[i].set(ts(X[i]._config, s)) : (a = rn(i), a != null && (u = a._config), s = ts(u, s), a == null && (s.abbr = i), r = new fs(s), r.parentLocale = X[i], X[i] = r), ue(i);
  } else
    X[i] != null && (X[i].parentLocale != null ? (X[i] = X[i].parentLocale, i === ue() && ue(i)) : X[i] != null && delete X[i]);
  return X[i];
}
function ie(i) {
  var s;
  if (i && i._locale && i._locale._abbr && (i = i._locale._abbr), !i)
    return ui;
  if (!At(i)) {
    if (s = rn(i), s)
      return s;
    i = [i];
  }
  return Ju(i);
}
function tl() {
  return es(X);
}
function xs(i) {
  var s, r = i._a;
  return r && E(i).overflow === -2 && (s = r[$t] < 0 || r[$t] > 11 ? $t : r[Yt] < 1 || r[Yt] > sn(r[ht], r[$t]) ? Yt : r[st] < 0 || r[st] > 24 || r[st] === 24 && (r[Et] !== 0 || r[Qt] !== 0 || r[ge] !== 0) ? st : r[Et] < 0 || r[Et] > 59 ? Et : r[Qt] < 0 || r[Qt] > 59 ? Qt : r[ge] < 0 || r[ge] > 999 ? ge : -1, E(i)._overflowDayOfYear && (s < ht || s > Yt) && (s = Yt), E(i)._overflowWeeks && s === -1 && (s = ou), E(i)._overflowWeekday && s === -1 && (s = au), E(i).overflow = s), i;
}
var el = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, il = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, nl = /Z|[+-]\d\d(?::?\d\d)?/, Ri = [
  ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
  ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
  ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
  ["GGGG-[W]WW", /\d{4}-W\d\d/, !1],
  ["YYYY-DDD", /\d{4}-\d{3}/],
  ["YYYY-MM", /\d{4}-\d\d/, !1],
  ["YYYYYYMMDD", /[+-]\d{10}/],
  ["YYYYMMDD", /\d{8}/],
  ["GGGG[W]WWE", /\d{4}W\d{3}/],
  ["GGGG[W]WW", /\d{4}W\d{2}/, !1],
  ["YYYYDDD", /\d{7}/],
  ["YYYYMM", /\d{6}/, !1],
  ["YYYY", /\d{4}/, !1]
], Xn = [
  ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
  ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
  ["HH:mm:ss", /\d\d:\d\d:\d\d/],
  ["HH:mm", /\d\d:\d\d/],
  ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
  ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
  ["HHmmss", /\d\d\d\d\d\d/],
  ["HHmm", /\d\d\d\d/],
  ["HH", /\d\d/]
], sl = /^\/?Date\((-?\d+)/i, rl = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, ol = {
  UT: 0,
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function bo(i) {
  var s, r, a = i._i, u = el.exec(a) || il.exec(a), c, d, y, g, k = Ri.length, F = Xn.length;
  if (u) {
    for (E(i).iso = !0, s = 0, r = k; s < r; s++)
      if (Ri[s][1].exec(u[1])) {
        d = Ri[s][0], c = Ri[s][2] !== !1;
        break;
      }
    if (d == null) {
      i._isValid = !1;
      return;
    }
    if (u[3]) {
      for (s = 0, r = F; s < r; s++)
        if (Xn[s][1].exec(u[3])) {
          y = (u[2] || " ") + Xn[s][0];
          break;
        }
      if (y == null) {
        i._isValid = !1;
        return;
      }
    }
    if (!c && y != null) {
      i._isValid = !1;
      return;
    }
    if (u[4])
      if (nl.exec(u[4]))
        g = "Z";
      else {
        i._isValid = !1;
        return;
      }
    i._f = d + (y || "") + (g || ""), Ls(i);
  } else
    i._isValid = !1;
}
function al(i, s, r, a, u, c) {
  var d = [
    hl(i),
    _o.indexOf(s),
    parseInt(r, 10),
    parseInt(a, 10),
    parseInt(u, 10)
  ];
  return c && d.push(parseInt(c, 10)), d;
}
function hl(i) {
  var s = parseInt(i, 10);
  return s <= 49 ? 2e3 + s : s <= 999 ? 1900 + s : s;
}
function ul(i) {
  return i.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
}
function ll(i, s, r) {
  if (i) {
    var a = xo.indexOf(i), u = new Date(
      s[0],
      s[1],
      s[2]
    ).getDay();
    if (a !== u)
      return E(r).weekdayMismatch = !0, r._isValid = !1, !1;
  }
  return !0;
}
function cl(i, s, r) {
  if (i)
    return ol[i];
  if (s)
    return 0;
  var a = parseInt(r, 10), u = a % 100, c = (a - u) / 100;
  return c * 60 + u;
}
function To(i) {
  var s = rl.exec(ul(i._i)), r;
  if (s) {
    if (r = al(
      s[4],
      s[3],
      s[2],
      s[5],
      s[6],
      s[7]
    ), !ll(s[1], r, i))
      return;
    i._a = r, i._tzm = cl(s[8], s[9], s[10]), i._d = ai.apply(null, i._a), i._d.setUTCMinutes(i._d.getUTCMinutes() - i._tzm), E(i).rfc2822 = !0;
  } else
    i._isValid = !1;
}
function fl(i) {
  var s = sl.exec(i._i);
  if (s !== null) {
    i._d = /* @__PURE__ */ new Date(+s[1]);
    return;
  }
  if (bo(i), i._isValid === !1)
    delete i._isValid;
  else
    return;
  if (To(i), i._isValid === !1)
    delete i._isValid;
  else
    return;
  i._strict ? i._isValid = !1 : w.createFromInputFallback(i);
}
w.createFromInputFallback = Tt(
  "value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",
  function(i) {
    i._d = /* @__PURE__ */ new Date(i._i + (i._useUTC ? " UTC" : ""));
  }
);
function Ee(i, s, r) {
  return i ?? s ?? r;
}
function dl(i) {
  var s = new Date(w.now());
  return i._useUTC ? [
    s.getUTCFullYear(),
    s.getUTCMonth(),
    s.getUTCDate()
  ] : [s.getFullYear(), s.getMonth(), s.getDate()];
}
function Ps(i) {
  var s, r, a = [], u, c, d;
  if (!i._d) {
    for (u = dl(i), i._w && i._a[Yt] == null && i._a[$t] == null && _l(i), i._dayOfYear != null && (d = Ee(i._a[ht], u[ht]), (i._dayOfYear > oi(d) || i._dayOfYear === 0) && (E(i)._overflowDayOfYear = !0), r = ai(d, 0, i._dayOfYear), i._a[$t] = r.getUTCMonth(), i._a[Yt] = r.getUTCDate()), s = 0; s < 3 && i._a[s] == null; ++s)
      i._a[s] = a[s] = u[s];
    for (; s < 7; s++)
      i._a[s] = a[s] = i._a[s] == null ? s === 2 ? 1 : 0 : i._a[s];
    i._a[st] === 24 && i._a[Et] === 0 && i._a[Qt] === 0 && i._a[ge] === 0 && (i._nextDay = !0, i._a[st] = 0), i._d = (i._useUTC ? ai : wu).apply(
      null,
      a
    ), c = i._useUTC ? i._d.getUTCDay() : i._d.getDay(), i._tzm != null && i._d.setUTCMinutes(i._d.getUTCMinutes() - i._tzm), i._nextDay && (i._a[st] = 24), i._w && typeof i._w.d < "u" && i._w.d !== c && (E(i).weekdayMismatch = !0);
  }
}
function _l(i) {
  var s, r, a, u, c, d, y, g, k;
  s = i._w, s.GG != null || s.W != null || s.E != null ? (c = 1, d = 4, r = Ee(
    s.GG,
    i._a[ht],
    hi(q(), 1, 4).year
  ), a = Ee(s.W, 1), u = Ee(s.E, 1), (u < 1 || u > 7) && (g = !0)) : (c = i._locale._week.dow, d = i._locale._week.doy, k = hi(q(), c, d), r = Ee(s.gg, i._a[ht], k.year), a = Ee(s.w, k.week), s.d != null ? (u = s.d, (u < 0 || u > 6) && (g = !0)) : s.e != null ? (u = s.e + c, (s.e < 0 || s.e > 6) && (g = !0)) : u = c), a < 1 || a > te(r, c, d) ? E(i)._overflowWeeks = !0 : g != null ? E(i)._overflowWeekday = !0 : (y = wo(r, a, u, c, d), i._a[ht] = y.year, i._dayOfYear = y.dayOfYear);
}
w.ISO_8601 = function() {
};
w.RFC_2822 = function() {
};
function Ls(i) {
  if (i._f === w.ISO_8601) {
    bo(i);
    return;
  }
  if (i._f === w.RFC_2822) {
    To(i);
    return;
  }
  i._a = [], E(i).empty = !0;
  var s = "" + i._i, r, a, u, c, d, y = s.length, g = 0, k, F;
  for (u = oo(i._f, i._locale).match(ds) || [], F = u.length, r = 0; r < F; r++)
    c = u[r], a = (s.match(nu(c, i)) || [])[0], a && (d = s.substr(0, s.indexOf(a)), d.length > 0 && E(i).unusedInput.push(d), s = s.slice(
      s.indexOf(a) + a.length
    ), g += a.length), Ie[c] ? (a ? E(i).empty = !1 : E(i).unusedTokens.push(c), ru(c, a, i)) : i._strict && !a && E(i).unusedTokens.push(c);
  E(i).charsLeftOver = y - g, s.length > 0 && E(i).unusedInput.push(s), i._a[st] <= 12 && E(i).bigHour === !0 && i._a[st] > 0 && (E(i).bigHour = void 0), E(i).parsedDateParts = i._a.slice(0), E(i).meridiem = i._meridiem, i._a[st] = ml(
    i._locale,
    i._a[st],
    i._meridiem
  ), k = E(i).era, k !== null && (i._a[ht] = i._locale.erasConvertYear(k, i._a[ht])), Ps(i), xs(i);
}
function ml(i, s, r) {
  var a;
  return r == null ? s : i.meridiemHour != null ? i.meridiemHour(s, r) : (i.isPM != null && (a = i.isPM(r), a && s < 12 && (s += 12), !a && s === 12 && (s = 0)), s);
}
function pl(i) {
  var s, r, a, u, c, d, y = !1, g = i._f.length;
  if (g === 0) {
    E(i).invalidFormat = !0, i._d = /* @__PURE__ */ new Date(NaN);
    return;
  }
  for (u = 0; u < g; u++)
    c = 0, d = !1, s = cs({}, i), i._useUTC != null && (s._useUTC = i._useUTC), s._f = i._f[u], Ls(s), ls(s) && (d = !0), c += E(s).charsLeftOver, c += E(s).unusedTokens.length * 10, E(s).score = c, y ? c < a && (a = c, r = s) : (a == null || c < a || d) && (a = c, r = s, d && (y = !0));
  ae(i, r || s);
}
function gl(i) {
  if (!i._d) {
    var s = _s(i._i), r = s.day === void 0 ? s.date : s.day;
    i._a = no(
      [s.year, s.month, r, s.hour, s.minute, s.second, s.millisecond],
      function(a) {
        return a && parseInt(a, 10);
      }
    ), Ps(i);
  }
}
function vl(i) {
  var s = new ci(xs(So(i)));
  return s._nextDay && (s.add(1, "d"), s._nextDay = void 0), s;
}
function So(i) {
  var s = i._i, r = i._f;
  return i._locale = i._locale || ie(i._l), s === null || r === void 0 && s === "" ? Xi({ nullInput: !0 }) : (typeof s == "string" && (i._i = s = i._locale.preparse(s)), zt(s) ? new ci(xs(s)) : (li(s) ? i._d = s : At(r) ? pl(i) : r ? Ls(i) : yl(i), ls(i) || (i._d = null), i));
}
function yl(i) {
  var s = i._i;
  pt(s) ? i._d = new Date(w.now()) : li(s) ? i._d = new Date(s.valueOf()) : typeof s == "string" ? fl(i) : At(s) ? (i._a = no(s.slice(0), function(r) {
    return parseInt(r, 10);
  }), Ps(i)) : ye(s) ? gl(i) : ee(s) ? i._d = new Date(s) : w.createFromInputFallback(i);
}
function ko(i, s, r, a, u) {
  var c = {};
  return (s === !0 || s === !1) && (a = s, s = void 0), (r === !0 || r === !1) && (a = r, r = void 0), (ye(i) && us(i) || At(i) && i.length === 0) && (i = void 0), c._isAMomentObject = !0, c._useUTC = c._isUTC = u, c._l = r, c._i = i, c._f = s, c._strict = a, vl(c);
}
function q(i, s, r, a) {
  return ko(i, s, r, a, !1);
}
var wl = Tt(
  "moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var i = q.apply(null, arguments);
    return this.isValid() && i.isValid() ? i < this ? this : i : Xi();
  }
), xl = Tt(
  "moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var i = q.apply(null, arguments);
    return this.isValid() && i.isValid() ? i > this ? this : i : Xi();
  }
);
function Oo(i, s) {
  var r, a;
  if (s.length === 1 && At(s[0]) && (s = s[0]), !s.length)
    return q();
  for (r = s[0], a = 1; a < s.length; ++a)
    (!s[a].isValid() || s[a][i](r)) && (r = s[a]);
  return r;
}
function Pl() {
  var i = [].slice.call(arguments, 0);
  return Oo("isBefore", i);
}
function Ll() {
  var i = [].slice.call(arguments, 0);
  return Oo("isAfter", i);
}
var Ml = function() {
  return Date.now ? Date.now() : +/* @__PURE__ */ new Date();
}, ni = [
  "year",
  "quarter",
  "month",
  "week",
  "day",
  "hour",
  "minute",
  "second",
  "millisecond"
];
function bl(i) {
  var s, r = !1, a, u = ni.length;
  for (s in i)
    if (Y(i, s) && !(tt.call(ni, s) !== -1 && (i[s] == null || !isNaN(i[s]))))
      return !1;
  for (a = 0; a < u; ++a)
    if (i[ni[a]]) {
      if (r)
        return !1;
      parseFloat(i[ni[a]]) !== I(i[ni[a]]) && (r = !0);
    }
  return !0;
}
function Tl() {
  return this._isValid;
}
function Sl() {
  return It(NaN);
}
function on(i) {
  var s = _s(i), r = s.year || 0, a = s.quarter || 0, u = s.month || 0, c = s.week || s.isoWeek || 0, d = s.day || 0, y = s.hour || 0, g = s.minute || 0, k = s.second || 0, F = s.millisecond || 0;
  this._isValid = bl(s), this._milliseconds = +F + k * 1e3 + // 1000
  g * 6e4 + // 1000 * 60
  y * 1e3 * 60 * 60, this._days = +d + c * 7, this._months = +u + a * 3 + r * 12, this._data = {}, this._locale = ie(), this._bubble();
}
function Bi(i) {
  return i instanceof on;
}
function ns(i) {
  return i < 0 ? Math.round(-1 * i) * -1 : Math.round(i);
}
function kl(i, s, r) {
  var a = Math.min(i.length, s.length), u = Math.abs(i.length - s.length), c = 0, d;
  for (d = 0; d < a; d++)
    (r && i[d] !== s[d] || !r && I(i[d]) !== I(s[d])) && c++;
  return c + u;
}
function Co(i, s) {
  b(i, 0, 0, function() {
    var r = this.utcOffset(), a = "+";
    return r < 0 && (r = -r, a = "-"), a + Wt(~~(r / 60), 2) + s + Wt(~~r % 60, 2);
  });
}
Co("Z", ":");
Co("ZZ", "");
P("Z", nn);
P("ZZ", nn);
V(["Z", "ZZ"], function(i, s, r) {
  r._useUTC = !0, r._tzm = Ms(nn, i);
});
var Ol = /([\+\-]|\d\d)/gi;
function Ms(i, s) {
  var r = (s || "").match(i), a, u, c;
  return r === null ? null : (a = r[r.length - 1] || [], u = (a + "").match(Ol) || ["-", 0, 0], c = +(u[1] * 60) + I(u[2]), c === 0 ? 0 : u[0] === "+" ? c : -c);
}
function bs(i, s) {
  var r, a;
  return s._isUTC ? (r = s.clone(), a = (zt(i) || li(i) ? i.valueOf() : q(i).valueOf()) - r.valueOf(), r._d.setTime(r._d.valueOf() + a), w.updateOffset(r, !1), r) : q(i).local();
}
function ss(i) {
  return -Math.round(i._d.getTimezoneOffset());
}
w.updateOffset = function() {
};
function Cl(i, s, r) {
  var a = this._offset || 0, u;
  if (!this.isValid())
    return i != null ? this : NaN;
  if (i != null) {
    if (typeof i == "string") {
      if (i = Ms(nn, i), i === null)
        return this;
    } else
      Math.abs(i) < 16 && !r && (i = i * 60);
    return !this._isUTC && s && (u = ss(this)), this._offset = i, this._isUTC = !0, u != null && this.add(u, "m"), a !== i && (!s || this._changeInProgress ? Ao(
      this,
      It(i - a, "m"),
      1,
      !1
    ) : this._changeInProgress || (this._changeInProgress = !0, w.updateOffset(this, !0), this._changeInProgress = null)), this;
  } else
    return this._isUTC ? a : ss(this);
}
function Dl(i, s) {
  return i != null ? (typeof i != "string" && (i = -i), this.utcOffset(i, s), this) : -this.utcOffset();
}
function El(i) {
  return this.utcOffset(0, i);
}
function Al(i) {
  return this._isUTC && (this.utcOffset(0, i), this._isUTC = !1, i && this.subtract(ss(this), "m")), this;
}
function zl() {
  if (this._tzm != null)
    this.utcOffset(this._tzm, !1, !0);
  else if (typeof this._i == "string") {
    var i = Ms(eu, this._i);
    i != null ? this.utcOffset(i) : this.utcOffset(0, !0);
  }
  return this;
}
function Il(i) {
  return this.isValid() ? (i = i ? q(i).utcOffset() : 0, (this.utcOffset() - i) % 60 === 0) : !1;
}
function Nl() {
  return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
}
function Rl() {
  if (!pt(this._isDSTShifted))
    return this._isDSTShifted;
  var i = {}, s;
  return cs(i, this), i = So(i), i._a ? (s = i._isUTC ? Ft(i._a) : q(i._a), this._isDSTShifted = this.isValid() && kl(i._a, s.toArray()) > 0) : this._isDSTShifted = !1, this._isDSTShifted;
}
function Zl() {
  return this.isValid() ? !this._isUTC : !1;
}
function Bl() {
  return this.isValid() ? this._isUTC : !1;
}
function Do() {
  return this.isValid() ? this._isUTC && this._offset === 0 : !1;
}
var Yl = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, Wl = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
function It(i, s) {
  var r = i, a = null, u, c, d;
  return Bi(i) ? r = {
    ms: i._milliseconds,
    d: i._days,
    M: i._months
  } : ee(i) || !isNaN(+i) ? (r = {}, s ? r[s] = +i : r.milliseconds = +i) : (a = Yl.exec(i)) ? (u = a[1] === "-" ? -1 : 1, r = {
    y: 0,
    d: I(a[Yt]) * u,
    h: I(a[st]) * u,
    m: I(a[Et]) * u,
    s: I(a[Qt]) * u,
    ms: I(ns(a[ge] * 1e3)) * u
    // the millisecond decimal point is included in the match
  }) : (a = Wl.exec(i)) ? (u = a[1] === "-" ? -1 : 1, r = {
    y: pe(a[2], u),
    M: pe(a[3], u),
    w: pe(a[4], u),
    d: pe(a[5], u),
    h: pe(a[6], u),
    m: pe(a[7], u),
    s: pe(a[8], u)
  }) : r == null ? r = {} : typeof r == "object" && ("from" in r || "to" in r) && (d = Fl(
    q(r.from),
    q(r.to)
  ), r = {}, r.ms = d.milliseconds, r.M = d.months), c = new on(r), Bi(i) && Y(i, "_locale") && (c._locale = i._locale), Bi(i) && Y(i, "_isValid") && (c._isValid = i._isValid), c;
}
It.fn = on.prototype;
It.invalid = Sl;
function pe(i, s) {
  var r = i && parseFloat(i.replace(",", "."));
  return (isNaN(r) ? 0 : r) * s;
}
function Kr(i, s) {
  var r = {};
  return r.months = s.month() - i.month() + (s.year() - i.year()) * 12, i.clone().add(r.months, "M").isAfter(s) && --r.months, r.milliseconds = +s - +i.clone().add(r.months, "M"), r;
}
function Fl(i, s) {
  var r;
  return i.isValid() && s.isValid() ? (s = bs(s, i), i.isBefore(s) ? r = Kr(i, s) : (r = Kr(s, i), r.milliseconds = -r.milliseconds, r.months = -r.months), r) : { milliseconds: 0, months: 0 };
}
function Eo(i, s) {
  return function(r, a) {
    var u, c;
    return a !== null && !isNaN(+a) && (ro(
      s,
      "moment()." + s + "(period, number) is deprecated. Please use moment()." + s + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."
    ), c = r, r = a, a = c), u = It(r, a), Ao(this, u, i), this;
  };
}
function Ao(i, s, r, a) {
  var u = s._milliseconds, c = ns(s._days), d = ns(s._months);
  i.isValid() && (a = a ?? !0, d && po(i, Fi(i, "Month") + d * r), c && ho(i, "Date", Fi(i, "Date") + c * r), u && i._d.setTime(i._d.valueOf() + u * r), a && w.updateOffset(i, c || d));
}
var Hl = Eo(1, "add"), Ul = Eo(-1, "subtract");
function zo(i) {
  return typeof i == "string" || i instanceof String;
}
function Gl(i) {
  return zt(i) || li(i) || zo(i) || ee(i) || jl(i) || Vl(i) || i === null || i === void 0;
}
function Vl(i) {
  var s = ye(i) && !us(i), r = !1, a = [
    "years",
    "year",
    "y",
    "months",
    "month",
    "M",
    "days",
    "day",
    "d",
    "dates",
    "date",
    "D",
    "hours",
    "hour",
    "h",
    "minutes",
    "minute",
    "m",
    "seconds",
    "second",
    "s",
    "milliseconds",
    "millisecond",
    "ms"
  ], u, c, d = a.length;
  for (u = 0; u < d; u += 1)
    c = a[u], r = r || Y(i, c);
  return s && r;
}
function jl(i) {
  var s = At(i), r = !1;
  return s && (r = i.filter(function(a) {
    return !ee(a) && zo(i);
  }).length === 0), s && r;
}
function ql(i) {
  var s = ye(i) && !us(i), r = !1, a = [
    "sameDay",
    "nextDay",
    "lastDay",
    "nextWeek",
    "lastWeek",
    "sameElse"
  ], u, c;
  for (u = 0; u < a.length; u += 1)
    c = a[u], r = r || Y(i, c);
  return s && r;
}
function Kl(i, s) {
  var r = i.diff(s, "days", !0);
  return r < -6 ? "sameElse" : r < -1 ? "lastWeek" : r < 0 ? "lastDay" : r < 1 ? "sameDay" : r < 2 ? "nextDay" : r < 7 ? "nextWeek" : "sameElse";
}
function Xl(i, s) {
  arguments.length === 1 && (arguments[0] ? Gl(arguments[0]) ? (i = arguments[0], s = void 0) : ql(arguments[0]) && (s = arguments[0], i = void 0) : (i = void 0, s = void 0));
  var r = i || q(), a = bs(r, this).startOf("day"), u = w.calendarFormat(this, a) || "sameElse", c = s && (Ht(s[u]) ? s[u].call(this, r) : s[u]);
  return this.format(
    c || this.localeData().calendar(u, this, q(r))
  );
}
function Jl() {
  return new ci(this);
}
function $l(i, s) {
  var r = zt(i) ? i : q(i);
  return this.isValid() && r.isValid() ? (s = St(s) || "millisecond", s === "millisecond" ? this.valueOf() > r.valueOf() : r.valueOf() < this.clone().startOf(s).valueOf()) : !1;
}
function Ql(i, s) {
  var r = zt(i) ? i : q(i);
  return this.isValid() && r.isValid() ? (s = St(s) || "millisecond", s === "millisecond" ? this.valueOf() < r.valueOf() : this.clone().endOf(s).valueOf() < r.valueOf()) : !1;
}
function tc(i, s, r, a) {
  var u = zt(i) ? i : q(i), c = zt(s) ? s : q(s);
  return this.isValid() && u.isValid() && c.isValid() ? (a = a || "()", (a[0] === "(" ? this.isAfter(u, r) : !this.isBefore(u, r)) && (a[1] === ")" ? this.isBefore(c, r) : !this.isAfter(c, r))) : !1;
}
function ec(i, s) {
  var r = zt(i) ? i : q(i), a;
  return this.isValid() && r.isValid() ? (s = St(s) || "millisecond", s === "millisecond" ? this.valueOf() === r.valueOf() : (a = r.valueOf(), this.clone().startOf(s).valueOf() <= a && a <= this.clone().endOf(s).valueOf())) : !1;
}
function ic(i, s) {
  return this.isSame(i, s) || this.isAfter(i, s);
}
function nc(i, s) {
  return this.isSame(i, s) || this.isBefore(i, s);
}
function sc(i, s, r) {
  var a, u, c;
  if (!this.isValid())
    return NaN;
  if (a = bs(i, this), !a.isValid())
    return NaN;
  switch (u = (a.utcOffset() - this.utcOffset()) * 6e4, s = St(s), s) {
    case "year":
      c = Yi(this, a) / 12;
      break;
    case "month":
      c = Yi(this, a);
      break;
    case "quarter":
      c = Yi(this, a) / 3;
      break;
    case "second":
      c = (this - a) / 1e3;
      break;
    case "minute":
      c = (this - a) / 6e4;
      break;
    case "hour":
      c = (this - a) / 36e5;
      break;
    case "day":
      c = (this - a - u) / 864e5;
      break;
    case "week":
      c = (this - a - u) / 6048e5;
      break;
    default:
      c = this - a;
  }
  return r ? c : bt(c);
}
function Yi(i, s) {
  if (i.date() < s.date())
    return -Yi(s, i);
  var r = (s.year() - i.year()) * 12 + (s.month() - i.month()), a = i.clone().add(r, "months"), u, c;
  return s - a < 0 ? (u = i.clone().add(r - 1, "months"), c = (s - a) / (a - u)) : (u = i.clone().add(r + 1, "months"), c = (s - a) / (u - a)), -(r + c) || 0;
}
w.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
w.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
function rc() {
  return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
}
function oc(i) {
  if (!this.isValid())
    return null;
  var s = i !== !0, r = s ? this.clone().utc() : this;
  return r.year() < 0 || r.year() > 9999 ? Zi(
    r,
    s ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"
  ) : Ht(Date.prototype.toISOString) ? s ? this.toDate().toISOString() : new Date(this.valueOf() + this.utcOffset() * 60 * 1e3).toISOString().replace("Z", Zi(r, "Z")) : Zi(
    r,
    s ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ"
  );
}
function ac() {
  if (!this.isValid())
    return "moment.invalid(/* " + this._i + " */)";
  var i = "moment", s = "", r, a, u, c;
  return this.isLocal() || (i = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone", s = "Z"), r = "[" + i + '("]', a = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY", u = "-MM-DD[T]HH:mm:ss.SSS", c = s + '[")]', this.format(r + a + u + c);
}
function hc(i) {
  i || (i = this.isUtc() ? w.defaultFormatUtc : w.defaultFormat);
  var s = Zi(this, i);
  return this.localeData().postformat(s);
}
function uc(i, s) {
  return this.isValid() && (zt(i) && i.isValid() || q(i).isValid()) ? It({ to: this, from: i }).locale(this.locale()).humanize(!s) : this.localeData().invalidDate();
}
function lc(i) {
  return this.from(q(), i);
}
function cc(i, s) {
  return this.isValid() && (zt(i) && i.isValid() || q(i).isValid()) ? It({ from: this, to: i }).locale(this.locale()).humanize(!s) : this.localeData().invalidDate();
}
function fc(i) {
  return this.to(q(), i);
}
function Io(i) {
  var s;
  return i === void 0 ? this._locale._abbr : (s = ie(i), s != null && (this._locale = s), this);
}
var No = Tt(
  "moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",
  function(i) {
    return i === void 0 ? this.localeData() : this.locale(i);
  }
);
function Ro() {
  return this._locale;
}
var Gi = 1e3, Ne = 60 * Gi, Vi = 60 * Ne, Zo = (365 * 400 + 97) * 24 * Vi;
function Re(i, s) {
  return (i % s + s) % s;
}
function Bo(i, s, r) {
  return i < 100 && i >= 0 ? new Date(i + 400, s, r) - Zo : new Date(i, s, r).valueOf();
}
function Yo(i, s, r) {
  return i < 100 && i >= 0 ? Date.UTC(i + 400, s, r) - Zo : Date.UTC(i, s, r);
}
function dc(i) {
  var s, r;
  if (i = St(i), i === void 0 || i === "millisecond" || !this.isValid())
    return this;
  switch (r = this._isUTC ? Yo : Bo, i) {
    case "year":
      s = r(this.year(), 0, 1);
      break;
    case "quarter":
      s = r(
        this.year(),
        this.month() - this.month() % 3,
        1
      );
      break;
    case "month":
      s = r(this.year(), this.month(), 1);
      break;
    case "week":
      s = r(
        this.year(),
        this.month(),
        this.date() - this.weekday()
      );
      break;
    case "isoWeek":
      s = r(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1)
      );
      break;
    case "day":
    case "date":
      s = r(this.year(), this.month(), this.date());
      break;
    case "hour":
      s = this._d.valueOf(), s -= Re(
        s + (this._isUTC ? 0 : this.utcOffset() * Ne),
        Vi
      );
      break;
    case "minute":
      s = this._d.valueOf(), s -= Re(s, Ne);
      break;
    case "second":
      s = this._d.valueOf(), s -= Re(s, Gi);
      break;
  }
  return this._d.setTime(s), w.updateOffset(this, !0), this;
}
function _c(i) {
  var s, r;
  if (i = St(i), i === void 0 || i === "millisecond" || !this.isValid())
    return this;
  switch (r = this._isUTC ? Yo : Bo, i) {
    case "year":
      s = r(this.year() + 1, 0, 1) - 1;
      break;
    case "quarter":
      s = r(
        this.year(),
        this.month() - this.month() % 3 + 3,
        1
      ) - 1;
      break;
    case "month":
      s = r(this.year(), this.month() + 1, 1) - 1;
      break;
    case "week":
      s = r(
        this.year(),
        this.month(),
        this.date() - this.weekday() + 7
      ) - 1;
      break;
    case "isoWeek":
      s = r(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1) + 7
      ) - 1;
      break;
    case "day":
    case "date":
      s = r(this.year(), this.month(), this.date() + 1) - 1;
      break;
    case "hour":
      s = this._d.valueOf(), s += Vi - Re(
        s + (this._isUTC ? 0 : this.utcOffset() * Ne),
        Vi
      ) - 1;
      break;
    case "minute":
      s = this._d.valueOf(), s += Ne - Re(s, Ne) - 1;
      break;
    case "second":
      s = this._d.valueOf(), s += Gi - Re(s, Gi) - 1;
      break;
  }
  return this._d.setTime(s), w.updateOffset(this, !0), this;
}
function mc() {
  return this._d.valueOf() - (this._offset || 0) * 6e4;
}
function pc() {
  return Math.floor(this.valueOf() / 1e3);
}
function gc() {
  return new Date(this.valueOf());
}
function vc() {
  var i = this;
  return [
    i.year(),
    i.month(),
    i.date(),
    i.hour(),
    i.minute(),
    i.second(),
    i.millisecond()
  ];
}
function yc() {
  var i = this;
  return {
    years: i.year(),
    months: i.month(),
    date: i.date(),
    hours: i.hours(),
    minutes: i.minutes(),
    seconds: i.seconds(),
    milliseconds: i.milliseconds()
  };
}
function wc() {
  return this.isValid() ? this.toISOString() : null;
}
function xc() {
  return ls(this);
}
function Pc() {
  return ae({}, E(this));
}
function Lc() {
  return E(this).overflow;
}
function Mc() {
  return {
    input: this._i,
    format: this._f,
    locale: this._locale,
    isUTC: this._isUTC,
    strict: this._strict
  };
}
b("N", 0, 0, "eraAbbr");
b("NN", 0, 0, "eraAbbr");
b("NNN", 0, 0, "eraAbbr");
b("NNNN", 0, 0, "eraName");
b("NNNNN", 0, 0, "eraNarrow");
b("y", ["y", 1], "yo", "eraYear");
b("y", ["yy", 2], 0, "eraYear");
b("y", ["yyy", 3], 0, "eraYear");
b("y", ["yyyy", 4], 0, "eraYear");
P("N", Ts);
P("NN", Ts);
P("NNN", Ts);
P("NNNN", Ic);
P("NNNNN", Nc);
V(
  ["N", "NN", "NNN", "NNNN", "NNNNN"],
  function(i, s, r, a) {
    var u = r._locale.erasParse(i, a, r._strict);
    u ? E(r).era = u : E(r).invalidEra = i;
  }
);
P("y", Be);
P("yy", Be);
P("yyy", Be);
P("yyyy", Be);
P("yo", Rc);
V(["y", "yy", "yyy", "yyyy"], ht);
V(["yo"], function(i, s, r, a) {
  var u;
  r._locale._eraYearOrdinalRegex && (u = i.match(r._locale._eraYearOrdinalRegex)), r._locale.eraYearOrdinalParse ? s[ht] = r._locale.eraYearOrdinalParse(i, u) : s[ht] = parseInt(i, 10);
});
function bc(i, s) {
  var r, a, u, c = this._eras || ie("en")._eras;
  for (r = 0, a = c.length; r < a; ++r) {
    switch (typeof c[r].since) {
      case "string":
        u = w(c[r].since).startOf("day"), c[r].since = u.valueOf();
        break;
    }
    switch (typeof c[r].until) {
      case "undefined":
        c[r].until = 1 / 0;
        break;
      case "string":
        u = w(c[r].until).startOf("day").valueOf(), c[r].until = u.valueOf();
        break;
    }
  }
  return c;
}
function Tc(i, s, r) {
  var a, u, c = this.eras(), d, y, g;
  for (i = i.toUpperCase(), a = 0, u = c.length; a < u; ++a)
    if (d = c[a].name.toUpperCase(), y = c[a].abbr.toUpperCase(), g = c[a].narrow.toUpperCase(), r)
      switch (s) {
        case "N":
        case "NN":
        case "NNN":
          if (y === i)
            return c[a];
          break;
        case "NNNN":
          if (d === i)
            return c[a];
          break;
        case "NNNNN":
          if (g === i)
            return c[a];
          break;
      }
    else if ([d, y, g].indexOf(i) >= 0)
      return c[a];
}
function Sc(i, s) {
  var r = i.since <= i.until ? 1 : -1;
  return s === void 0 ? w(i.since).year() : w(i.since).year() + (s - i.offset) * r;
}
function kc() {
  var i, s, r, a = this.localeData().eras();
  for (i = 0, s = a.length; i < s; ++i)
    if (r = this.clone().startOf("day").valueOf(), a[i].since <= r && r <= a[i].until || a[i].until <= r && r <= a[i].since)
      return a[i].name;
  return "";
}
function Oc() {
  var i, s, r, a = this.localeData().eras();
  for (i = 0, s = a.length; i < s; ++i)
    if (r = this.clone().startOf("day").valueOf(), a[i].since <= r && r <= a[i].until || a[i].until <= r && r <= a[i].since)
      return a[i].narrow;
  return "";
}
function Cc() {
  var i, s, r, a = this.localeData().eras();
  for (i = 0, s = a.length; i < s; ++i)
    if (r = this.clone().startOf("day").valueOf(), a[i].since <= r && r <= a[i].until || a[i].until <= r && r <= a[i].since)
      return a[i].abbr;
  return "";
}
function Dc() {
  var i, s, r, a, u = this.localeData().eras();
  for (i = 0, s = u.length; i < s; ++i)
    if (r = u[i].since <= u[i].until ? 1 : -1, a = this.clone().startOf("day").valueOf(), u[i].since <= a && a <= u[i].until || u[i].until <= a && a <= u[i].since)
      return (this.year() - w(u[i].since).year()) * r + u[i].offset;
  return this.year();
}
function Ec(i) {
  return Y(this, "_erasNameRegex") || Ss.call(this), i ? this._erasNameRegex : this._erasRegex;
}
function Ac(i) {
  return Y(this, "_erasAbbrRegex") || Ss.call(this), i ? this._erasAbbrRegex : this._erasRegex;
}
function zc(i) {
  return Y(this, "_erasNarrowRegex") || Ss.call(this), i ? this._erasNarrowRegex : this._erasRegex;
}
function Ts(i, s) {
  return s.erasAbbrRegex(i);
}
function Ic(i, s) {
  return s.erasNameRegex(i);
}
function Nc(i, s) {
  return s.erasNarrowRegex(i);
}
function Rc(i, s) {
  return s._eraYearOrdinalRegex || Be;
}
function Ss() {
  var i = [], s = [], r = [], a = [], u, c, d = this.eras();
  for (u = 0, c = d.length; u < c; ++u)
    s.push(vt(d[u].name)), i.push(vt(d[u].abbr)), r.push(vt(d[u].narrow)), a.push(vt(d[u].name)), a.push(vt(d[u].abbr)), a.push(vt(d[u].narrow));
  this._erasRegex = new RegExp("^(" + a.join("|") + ")", "i"), this._erasNameRegex = new RegExp("^(" + s.join("|") + ")", "i"), this._erasAbbrRegex = new RegExp("^(" + i.join("|") + ")", "i"), this._erasNarrowRegex = new RegExp(
    "^(" + r.join("|") + ")",
    "i"
  );
}
b(0, ["gg", 2], 0, function() {
  return this.weekYear() % 100;
});
b(0, ["GG", 2], 0, function() {
  return this.isoWeekYear() % 100;
});
function an(i, s) {
  b(0, [i, i.length], 0, s);
}
an("gggg", "weekYear");
an("ggggg", "weekYear");
an("GGGG", "isoWeekYear");
an("GGGGG", "isoWeekYear");
ut("weekYear", "gg");
ut("isoWeekYear", "GG");
lt("weekYear", 1);
lt("isoWeekYear", 1);
P("G", en);
P("g", en);
P("GG", K, yt);
P("gg", K, yt);
P("GGGG", ps, ms);
P("gggg", ps, ms);
P("GGGGG", tn, $i);
P("ggggg", tn, $i);
di(
  ["gggg", "ggggg", "GGGG", "GGGGG"],
  function(i, s, r, a) {
    s[a.substr(0, 2)] = I(i);
  }
);
di(["gg", "GG"], function(i, s, r, a) {
  s[a] = w.parseTwoDigitYear(i);
});
function Zc(i) {
  return Wo.call(
    this,
    i,
    this.week(),
    this.weekday(),
    this.localeData()._week.dow,
    this.localeData()._week.doy
  );
}
function Bc(i) {
  return Wo.call(
    this,
    i,
    this.isoWeek(),
    this.isoWeekday(),
    1,
    4
  );
}
function Yc() {
  return te(this.year(), 1, 4);
}
function Wc() {
  return te(this.isoWeekYear(), 1, 4);
}
function Fc() {
  var i = this.localeData()._week;
  return te(this.year(), i.dow, i.doy);
}
function Hc() {
  var i = this.localeData()._week;
  return te(this.weekYear(), i.dow, i.doy);
}
function Wo(i, s, r, a, u) {
  var c;
  return i == null ? hi(this, a, u).year : (c = te(i, a, u), s > c && (s = c), Uc.call(this, i, s, r, a, u));
}
function Uc(i, s, r, a, u) {
  var c = wo(i, s, r, a, u), d = ai(c.year, 0, c.dayOfYear);
  return this.year(d.getUTCFullYear()), this.month(d.getUTCMonth()), this.date(d.getUTCDate()), this;
}
b("Q", 0, "Qo", "quarter");
ut("quarter", "Q");
lt("quarter", 7);
P("Q", uo);
V("Q", function(i, s) {
  s[$t] = (I(i) - 1) * 3;
});
function Gc(i) {
  return i == null ? Math.ceil((this.month() + 1) / 3) : this.month((i - 1) * 3 + this.month() % 3);
}
b("D", ["DD", 2], "Do", "date");
ut("date", "D");
lt("date", 9);
P("D", K);
P("DD", K, yt);
P("Do", function(i, s) {
  return i ? s._dayOfMonthOrdinalParse || s._ordinalParse : s._dayOfMonthOrdinalParseLenient;
});
V(["D", "DD"], Yt);
V("Do", function(i, s) {
  s[Yt] = I(i.match(K)[0]);
});
var Fo = Ze("Date", !0);
b("DDD", ["DDDD", 3], "DDDo", "dayOfYear");
ut("dayOfYear", "DDD");
lt("dayOfYear", 4);
P("DDD", Qi);
P("DDDD", lo);
V(["DDD", "DDDD"], function(i, s, r) {
  r._dayOfYear = I(i);
});
function Vc(i) {
  var s = Math.round(
    (this.clone().startOf("day") - this.clone().startOf("year")) / 864e5
  ) + 1;
  return i == null ? s : this.add(i - s, "d");
}
b("m", ["mm", 2], 0, "minute");
ut("minute", "m");
lt("minute", 14);
P("m", K);
P("mm", K, yt);
V(["m", "mm"], Et);
var jc = Ze("Minutes", !1);
b("s", ["ss", 2], 0, "second");
ut("second", "s");
lt("second", 15);
P("s", K);
P("ss", K, yt);
V(["s", "ss"], Qt);
var qc = Ze("Seconds", !1);
b("S", 0, 0, function() {
  return ~~(this.millisecond() / 100);
});
b(0, ["SS", 2], 0, function() {
  return ~~(this.millisecond() / 10);
});
b(0, ["SSS", 3], 0, "millisecond");
b(0, ["SSSS", 4], 0, function() {
  return this.millisecond() * 10;
});
b(0, ["SSSSS", 5], 0, function() {
  return this.millisecond() * 100;
});
b(0, ["SSSSSS", 6], 0, function() {
  return this.millisecond() * 1e3;
});
b(0, ["SSSSSSS", 7], 0, function() {
  return this.millisecond() * 1e4;
});
b(0, ["SSSSSSSS", 8], 0, function() {
  return this.millisecond() * 1e5;
});
b(0, ["SSSSSSSSS", 9], 0, function() {
  return this.millisecond() * 1e6;
});
ut("millisecond", "ms");
lt("millisecond", 16);
P("S", Qi, uo);
P("SS", Qi, yt);
P("SSS", Qi, lo);
var he, Ho;
for (he = "SSSS"; he.length <= 9; he += "S")
  P(he, Be);
function Kc(i, s) {
  s[ge] = I(("0." + i) * 1e3);
}
for (he = "S"; he.length <= 9; he += "S")
  V(he, Kc);
Ho = Ze("Milliseconds", !1);
b("z", 0, 0, "zoneAbbr");
b("zz", 0, 0, "zoneName");
function Xc() {
  return this._isUTC ? "UTC" : "";
}
function Jc() {
  return this._isUTC ? "Coordinated Universal Time" : "";
}
var v = ci.prototype;
v.add = Hl;
v.calendar = Xl;
v.clone = Jl;
v.diff = sc;
v.endOf = _c;
v.format = hc;
v.from = uc;
v.fromNow = lc;
v.to = cc;
v.toNow = fc;
v.get = Qh;
v.invalidAt = Lc;
v.isAfter = $l;
v.isBefore = Ql;
v.isBetween = tc;
v.isSame = ec;
v.isSameOrAfter = ic;
v.isSameOrBefore = nc;
v.isValid = xc;
v.lang = No;
v.locale = Io;
v.localeData = Ro;
v.max = xl;
v.min = wl;
v.parsingFlags = Pc;
v.set = tu;
v.startOf = dc;
v.subtract = Ul;
v.toArray = vc;
v.toObject = yc;
v.toDate = gc;
v.toISOString = oc;
v.inspect = ac;
typeof Symbol < "u" && Symbol.for != null && (v[Symbol.for("nodejs.util.inspect.custom")] = function() {
  return "Moment<" + this.format() + ">";
});
v.toJSON = wc;
v.toString = rc;
v.unix = pc;
v.valueOf = mc;
v.creationData = Mc;
v.eraName = kc;
v.eraNarrow = Oc;
v.eraAbbr = Cc;
v.eraYear = Dc;
v.year = yo;
v.isLeapYear = yu;
v.weekYear = Zc;
v.isoWeekYear = Bc;
v.quarter = v.quarters = Gc;
v.month = go;
v.daysInMonth = pu;
v.week = v.weeks = bu;
v.isoWeek = v.isoWeeks = Tu;
v.weeksInYear = Fc;
v.weeksInWeekYear = Hc;
v.isoWeeksInYear = Yc;
v.isoWeeksInISOWeekYear = Wc;
v.date = Fo;
v.day = v.days = Bu;
v.weekday = Yu;
v.isoWeekday = Wu;
v.dayOfYear = Vc;
v.hour = v.hours = qu;
v.minute = v.minutes = jc;
v.second = v.seconds = qc;
v.millisecond = v.milliseconds = Ho;
v.utcOffset = Cl;
v.utc = El;
v.local = Al;
v.parseZone = zl;
v.hasAlignedHourOffset = Il;
v.isDST = Nl;
v.isLocal = Zl;
v.isUtcOffset = Bl;
v.isUtc = Do;
v.isUTC = Do;
v.zoneAbbr = Xc;
v.zoneName = Jc;
v.dates = Tt(
  "dates accessor is deprecated. Use date instead.",
  Fo
);
v.months = Tt(
  "months accessor is deprecated. Use month instead",
  go
);
v.years = Tt(
  "years accessor is deprecated. Use year instead",
  yo
);
v.zone = Tt(
  "moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",
  Dl
);
v.isDSTShifted = Tt(
  "isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",
  Rl
);
function $c(i) {
  return q(i * 1e3);
}
function Qc() {
  return q.apply(null, arguments).parseZone();
}
function Uo(i) {
  return i;
}
var W = fs.prototype;
W.calendar = Bh;
W.longDateFormat = Hh;
W.invalidDate = Gh;
W.ordinal = qh;
W.preparse = Uo;
W.postformat = Uo;
W.relativeTime = Xh;
W.pastFuture = Jh;
W.set = Rh;
W.eras = bc;
W.erasParse = Tc;
W.erasConvertYear = Sc;
W.erasAbbrRegex = Ac;
W.erasNameRegex = Ec;
W.erasNarrowRegex = zc;
W.months = fu;
W.monthsShort = du;
W.monthsParse = mu;
W.monthsRegex = vu;
W.monthsShortRegex = gu;
W.week = xu;
W.firstDayOfYear = Mu;
W.firstDayOfWeek = Lu;
W.weekdays = zu;
W.weekdaysMin = Nu;
W.weekdaysShort = Iu;
W.weekdaysParse = Zu;
W.weekdaysRegex = Fu;
W.weekdaysShortRegex = Hu;
W.weekdaysMinRegex = Uu;
W.isPM = Vu;
W.meridiem = Ku;
function ji(i, s, r, a) {
  var u = ie(), c = Ft().set(a, s);
  return u[r](c, i);
}
function Go(i, s, r) {
  if (ee(i) && (s = i, i = void 0), i = i || "", s != null)
    return ji(i, s, r, "month");
  var a, u = [];
  for (a = 0; a < 12; a++)
    u[a] = ji(i, a, r, "month");
  return u;
}
function ks(i, s, r, a) {
  typeof i == "boolean" ? (ee(s) && (r = s, s = void 0), s = s || "") : (s = i, r = s, i = !1, ee(s) && (r = s, s = void 0), s = s || "");
  var u = ie(), c = i ? u._week.dow : 0, d, y = [];
  if (r != null)
    return ji(s, (r + c) % 7, a, "day");
  for (d = 0; d < 7; d++)
    y[d] = ji(s, (d + c) % 7, a, "day");
  return y;
}
function tf(i, s) {
  return Go(i, s, "months");
}
function ef(i, s) {
  return Go(i, s, "monthsShort");
}
function nf(i, s, r) {
  return ks(i, s, r, "weekdays");
}
function sf(i, s, r) {
  return ks(i, s, r, "weekdaysShort");
}
function rf(i, s, r) {
  return ks(i, s, r, "weekdaysMin");
}
ue("en", {
  eras: [
    {
      since: "0001-01-01",
      until: 1 / 0,
      offset: 1,
      name: "Anno Domini",
      narrow: "AD",
      abbr: "AD"
    },
    {
      since: "0000-12-31",
      until: -1 / 0,
      offset: 1,
      name: "Before Christ",
      narrow: "BC",
      abbr: "BC"
    }
  ],
  dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
  ordinal: function(i) {
    var s = i % 10, r = I(i % 100 / 10) === 1 ? "th" : s === 1 ? "st" : s === 2 ? "nd" : s === 3 ? "rd" : "th";
    return i + r;
  }
});
w.lang = Tt(
  "moment.lang is deprecated. Use moment.locale instead.",
  ue
);
w.langData = Tt(
  "moment.langData is deprecated. Use moment.localeData instead.",
  ie
);
var Xt = Math.abs;
function of() {
  var i = this._data;
  return this._milliseconds = Xt(this._milliseconds), this._days = Xt(this._days), this._months = Xt(this._months), i.milliseconds = Xt(i.milliseconds), i.seconds = Xt(i.seconds), i.minutes = Xt(i.minutes), i.hours = Xt(i.hours), i.months = Xt(i.months), i.years = Xt(i.years), this;
}
function Vo(i, s, r, a) {
  var u = It(s, r);
  return i._milliseconds += a * u._milliseconds, i._days += a * u._days, i._months += a * u._months, i._bubble();
}
function af(i, s) {
  return Vo(this, i, s, 1);
}
function hf(i, s) {
  return Vo(this, i, s, -1);
}
function Xr(i) {
  return i < 0 ? Math.floor(i) : Math.ceil(i);
}
function uf() {
  var i = this._milliseconds, s = this._days, r = this._months, a = this._data, u, c, d, y, g;
  return i >= 0 && s >= 0 && r >= 0 || i <= 0 && s <= 0 && r <= 0 || (i += Xr(rs(r) + s) * 864e5, s = 0, r = 0), a.milliseconds = i % 1e3, u = bt(i / 1e3), a.seconds = u % 60, c = bt(u / 60), a.minutes = c % 60, d = bt(c / 60), a.hours = d % 24, s += bt(d / 24), g = bt(jo(s)), r += g, s -= Xr(rs(g)), y = bt(r / 12), r %= 12, a.days = s, a.months = r, a.years = y, this;
}
function jo(i) {
  return i * 4800 / 146097;
}
function rs(i) {
  return i * 146097 / 4800;
}
function lf(i) {
  if (!this.isValid())
    return NaN;
  var s, r, a = this._milliseconds;
  if (i = St(i), i === "month" || i === "quarter" || i === "year")
    switch (s = this._days + a / 864e5, r = this._months + jo(s), i) {
      case "month":
        return r;
      case "quarter":
        return r / 3;
      case "year":
        return r / 12;
    }
  else
    switch (s = this._days + Math.round(rs(this._months)), i) {
      case "week":
        return s / 7 + a / 6048e5;
      case "day":
        return s + a / 864e5;
      case "hour":
        return s * 24 + a / 36e5;
      case "minute":
        return s * 1440 + a / 6e4;
      case "second":
        return s * 86400 + a / 1e3;
      case "millisecond":
        return Math.floor(s * 864e5) + a;
      default:
        throw new Error("Unknown unit " + i);
    }
}
function cf() {
  return this.isValid() ? this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + I(this._months / 12) * 31536e6 : NaN;
}
function ne(i) {
  return function() {
    return this.as(i);
  };
}
var ff = ne("ms"), df = ne("s"), _f = ne("m"), mf = ne("h"), pf = ne("d"), gf = ne("w"), vf = ne("M"), yf = ne("Q"), wf = ne("y");
function xf() {
  return It(this);
}
function Pf(i) {
  return i = St(i), this.isValid() ? this[i + "s"]() : NaN;
}
function xe(i) {
  return function() {
    return this.isValid() ? this._data[i] : NaN;
  };
}
var Lf = xe("milliseconds"), Mf = xe("seconds"), bf = xe("minutes"), Tf = xe("hours"), Sf = xe("days"), kf = xe("months"), Of = xe("years");
function Cf() {
  return bt(this.days() / 7);
}
var Jt = Math.round, Ae = {
  ss: 44,
  // a few seconds to seconds
  s: 45,
  // seconds to minute
  m: 45,
  // minutes to hour
  h: 22,
  // hours to day
  d: 26,
  // days to month/week
  w: null,
  // weeks to month
  M: 11
  // months to year
};
function Df(i, s, r, a, u) {
  return u.relativeTime(s || 1, !!r, i, a);
}
function Ef(i, s, r, a) {
  var u = It(i).abs(), c = Jt(u.as("s")), d = Jt(u.as("m")), y = Jt(u.as("h")), g = Jt(u.as("d")), k = Jt(u.as("M")), F = Jt(u.as("w")), D = Jt(u.as("y")), H = c <= r.ss && ["s", c] || c < r.s && ["ss", c] || d <= 1 && ["m"] || d < r.m && ["mm", d] || y <= 1 && ["h"] || y < r.h && ["hh", y] || g <= 1 && ["d"] || g < r.d && ["dd", g];
  return r.w != null && (H = H || F <= 1 && ["w"] || F < r.w && ["ww", F]), H = H || k <= 1 && ["M"] || k < r.M && ["MM", k] || D <= 1 && ["y"] || ["yy", D], H[2] = s, H[3] = +i > 0, H[4] = a, Df.apply(null, H);
}
function Af(i) {
  return i === void 0 ? Jt : typeof i == "function" ? (Jt = i, !0) : !1;
}
function zf(i, s) {
  return Ae[i] === void 0 ? !1 : s === void 0 ? Ae[i] : (Ae[i] = s, i === "s" && (Ae.ss = s - 1), !0);
}
function If(i, s) {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var r = !1, a = Ae, u, c;
  return typeof i == "object" && (s = i, i = !1), typeof i == "boolean" && (r = i), typeof s == "object" && (a = Object.assign({}, Ae, s), s.s != null && s.ss == null && (a.ss = s.s - 1)), u = this.localeData(), c = Ef(this, !r, a, u), r && (c = u.pastFuture(+this, c)), u.postformat(c);
}
var Jn = Math.abs;
function De(i) {
  return (i > 0) - (i < 0) || +i;
}
function hn() {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var i = Jn(this._milliseconds) / 1e3, s = Jn(this._days), r = Jn(this._months), a, u, c, d, y = this.asSeconds(), g, k, F, D;
  return y ? (a = bt(i / 60), u = bt(a / 60), i %= 60, a %= 60, c = bt(r / 12), r %= 12, d = i ? i.toFixed(3).replace(/\.?0+$/, "") : "", g = y < 0 ? "-" : "", k = De(this._months) !== De(y) ? "-" : "", F = De(this._days) !== De(y) ? "-" : "", D = De(this._milliseconds) !== De(y) ? "-" : "", g + "P" + (c ? k + c + "Y" : "") + (r ? k + r + "M" : "") + (s ? F + s + "D" : "") + (u || a || i ? "T" : "") + (u ? D + u + "H" : "") + (a ? D + a + "M" : "") + (i ? D + d + "S" : "")) : "P0D";
}
var Z = on.prototype;
Z.isValid = Tl;
Z.abs = of;
Z.add = af;
Z.subtract = hf;
Z.as = lf;
Z.asMilliseconds = ff;
Z.asSeconds = df;
Z.asMinutes = _f;
Z.asHours = mf;
Z.asDays = pf;
Z.asWeeks = gf;
Z.asMonths = vf;
Z.asQuarters = yf;
Z.asYears = wf;
Z.valueOf = cf;
Z._bubble = uf;
Z.clone = xf;
Z.get = Pf;
Z.milliseconds = Lf;
Z.seconds = Mf;
Z.minutes = bf;
Z.hours = Tf;
Z.days = Sf;
Z.weeks = Cf;
Z.months = kf;
Z.years = Of;
Z.humanize = If;
Z.toISOString = hn;
Z.toString = hn;
Z.toJSON = hn;
Z.locale = Io;
Z.localeData = Ro;
Z.toIsoString = Tt(
  "toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",
  hn
);
Z.lang = No;
b("X", 0, 0, "unix");
b("x", 0, 0, "valueOf");
P("x", en);
P("X", iu);
V("X", function(i, s, r) {
  r._d = new Date(parseFloat(i) * 1e3);
});
V("x", function(i, s, r) {
  r._d = new Date(I(i));
});
//! moment.js
w.version = "2.29.4";
Ih(q);
w.fn = v;
w.min = Pl;
w.max = Ll;
w.now = Ml;
w.utc = Ft;
w.unix = $c;
w.months = tf;
w.isDate = li;
w.locale = ue;
w.invalid = Xi;
w.duration = It;
w.isMoment = zt;
w.weekdays = nf;
w.parseZone = Qc;
w.localeData = ie;
w.isDuration = Bi;
w.monthsShort = ef;
w.weekdaysMin = rf;
w.defineLocale = ws;
w.updateLocale = Qu;
w.locales = tl;
w.weekdaysShort = sf;
w.normalizeUnits = St;
w.relativeTimeRounding = Af;
w.relativeTimeThreshold = zf;
w.calendarFormat = Kl;
w.prototype = v;
w.HTML5_FMT = {
  DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
  // <input type="datetime-local" />
  DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
  // <input type="datetime-local" step="1" />
  DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
  // <input type="datetime-local" step="0.001" />
  DATE: "YYYY-MM-DD",
  // <input type="date" />
  TIME: "HH:mm",
  // <input type="time" />
  TIME_SECONDS: "HH:mm:ss",
  // <input type="time" step="1" />
  TIME_MS: "HH:mm:ss.SSS",
  // <input type="time" step="0.001" />
  WEEK: "GGGG-[W]WW",
  // <input type="week" />
  MONTH: "YYYY-MM"
  // <input type="month" />
};
const Nf = (i) => {
  let s = null;
  i.distance && (i.distance = parseFloat(i.distance), i.distance > 1e3 && i.unit === "m" ? (i.distance = Math.floor(i.distance / 1e3), i.unit = "km") : i.distance = Math.floor(i.distance), s = `${i.distance} ${i.unit}`);
  let r = null;
  if (i.duration)
    if (typeof i.duration == "string")
      r = i.duration;
    else {
      const a = qo(i.duration);
      r = `${a.days} ${a.hours} ${a.minutes} ${a.seconds}`;
    }
  return {
    duration: r,
    distance: s
  };
}, qo = (i) => {
  const s = w.duration(i, "seconds"), r = s.days(), a = s.hours(), u = s.minutes(), c = s.seconds();
  return {
    days: r > 0 ? `${r} días` : "",
    hours: a > 0 ? `${a} hrs` : "",
    minutes: u > 0 ? `${u} mins` : "",
    seconds: c > 0 ? `${c} s` : ""
  };
}, Rf = (i) => {
  const s = [];
  return i.forEach((r) => {
    const a = [r[1], r[0]];
    r[2] && (a[2] = r[2]), s.push(a);
  }), s;
};
var Zf = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Ko(i) {
  return i && i.__esModule && Object.prototype.hasOwnProperty.call(i, "default") ? i.default : i;
}
var os = { exports: {} };
/* @preserve
 * Leaflet 1.9.4, a JS library for interactive maps. https://leafletjs.com
 * (c) 2010-2023 Vladimir Agafonkin, (c) 2010-2011 CloudMade
 */
(function(i, s) {
  (function(r, a) {
    a(s);
  })(Zf, function(r) {
    var a = "1.9.4";
    function u(t) {
      var e, n, o, h;
      for (n = 1, o = arguments.length; n < o; n++) {
        h = arguments[n];
        for (e in h)
          t[e] = h[e];
      }
      return t;
    }
    var c = Object.create || function() {
      function t() {
      }
      return function(e) {
        return t.prototype = e, new t();
      };
    }();
    function d(t, e) {
      var n = Array.prototype.slice;
      if (t.bind)
        return t.bind.apply(t, n.call(arguments, 1));
      var o = n.call(arguments, 2);
      return function() {
        return t.apply(e, o.length ? o.concat(n.call(arguments)) : arguments);
      };
    }
    var y = 0;
    function g(t) {
      return "_leaflet_id" in t || (t._leaflet_id = ++y), t._leaflet_id;
    }
    function k(t, e, n) {
      var o, h, l, f;
      return f = function() {
        o = !1, h && (l.apply(n, h), h = !1);
      }, l = function() {
        o ? h = arguments : (t.apply(n, arguments), setTimeout(f, e), o = !0);
      }, l;
    }
    function F(t, e, n) {
      var o = e[1], h = e[0], l = o - h;
      return t === o && n ? t : ((t - h) % l + l) % l + h;
    }
    function D() {
      return !1;
    }
    function H(t, e) {
      if (e === !1)
        return t;
      var n = Math.pow(10, e === void 0 ? 6 : e);
      return Math.round(t * n) / n;
    }
    function rt(t) {
      return t.trim ? t.trim() : t.replace(/^\s+|\s+$/g, "");
    }
    function wt(t) {
      return rt(t).split(/\s+/);
    }
    function U(t, e) {
      Object.prototype.hasOwnProperty.call(t, "options") || (t.options = t.options ? c(t.options) : {});
      for (var n in e)
        t.options[n] = e[n];
      return t.options;
    }
    function _i(t, e, n) {
      var o = [];
      for (var h in t)
        o.push(encodeURIComponent(n ? h.toUpperCase() : h) + "=" + encodeURIComponent(t[h]));
      return (!e || e.indexOf("?") === -1 ? "?" : "&") + o.join("&");
    }
    var mi = /\{ *([\w_ -]+) *\}/g;
    function le(t, e) {
      return t.replace(mi, function(n, o) {
        var h = e[o];
        if (h === void 0)
          throw new Error("No value provided for variable " + n);
        return typeof h == "function" && (h = h(e)), h;
      });
    }
    var kt = Array.isArray || function(t) {
      return Object.prototype.toString.call(t) === "[object Array]";
    };
    function cn(t, e) {
      for (var n = 0; n < t.length; n++)
        if (t[n] === e)
          return n;
      return -1;
    }
    var pi = "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=";
    function fn(t) {
      return window["webkit" + t] || window["moz" + t] || window["ms" + t];
    }
    var Es = 0;
    function As(t) {
      var e = +/* @__PURE__ */ new Date(), n = Math.max(0, 16 - (e - Es));
      return Es = e + n, window.setTimeout(t, n);
    }
    var dn = window.requestAnimationFrame || fn("RequestAnimationFrame") || As, zs = window.cancelAnimationFrame || fn("CancelAnimationFrame") || fn("CancelRequestAnimationFrame") || function(t) {
      window.clearTimeout(t);
    };
    function ft(t, e, n) {
      if (n && dn === As)
        t.call(e);
      else
        return dn.call(window, d(t, e));
    }
    function xt(t) {
      t && zs.call(window, t);
    }
    var ra = {
      __proto__: null,
      extend: u,
      create: c,
      bind: d,
      get lastId() {
        return y;
      },
      stamp: g,
      throttle: k,
      wrapNum: F,
      falseFn: D,
      formatNum: H,
      trim: rt,
      splitWords: wt,
      setOptions: U,
      getParamString: _i,
      template: le,
      isArray: kt,
      indexOf: cn,
      emptyImageUrl: pi,
      requestFn: dn,
      cancelFn: zs,
      requestAnimFrame: ft,
      cancelAnimFrame: xt
    };
    function Ut() {
    }
    Ut.extend = function(t) {
      var e = function() {
        U(this), this.initialize && this.initialize.apply(this, arguments), this.callInitHooks();
      }, n = e.__super__ = this.prototype, o = c(n);
      o.constructor = e, e.prototype = o;
      for (var h in this)
        Object.prototype.hasOwnProperty.call(this, h) && h !== "prototype" && h !== "__super__" && (e[h] = this[h]);
      return t.statics && u(e, t.statics), t.includes && (oa(t.includes), u.apply(null, [o].concat(t.includes))), u(o, t), delete o.statics, delete o.includes, o.options && (o.options = n.options ? c(n.options) : {}, u(o.options, t.options)), o._initHooks = [], o.callInitHooks = function() {
        if (!this._initHooksCalled) {
          n.callInitHooks && n.callInitHooks.call(this), this._initHooksCalled = !0;
          for (var l = 0, f = o._initHooks.length; l < f; l++)
            o._initHooks[l].call(this);
        }
      }, e;
    }, Ut.include = function(t) {
      var e = this.prototype.options;
      return u(this.prototype, t), t.options && (this.prototype.options = e, this.mergeOptions(t.options)), this;
    }, Ut.mergeOptions = function(t) {
      return u(this.prototype.options, t), this;
    }, Ut.addInitHook = function(t) {
      var e = Array.prototype.slice.call(arguments, 1), n = typeof t == "function" ? t : function() {
        this[t].apply(this, e);
      };
      return this.prototype._initHooks = this.prototype._initHooks || [], this.prototype._initHooks.push(n), this;
    };
    function oa(t) {
      if (!(typeof L > "u" || !L || !L.Mixin)) {
        t = kt(t) ? t : [t];
        for (var e = 0; e < t.length; e++)
          t[e] === L.Mixin.Events && console.warn("Deprecated include of L.Mixin.Events: this property will be removed in future releases, please inherit from L.Evented instead.", new Error().stack);
      }
    }
    var gt = {
      /* @method on(type: String, fn: Function, context?: Object): this
       * Adds a listener function (`fn`) to a particular event type of the object. You can optionally specify the context of the listener (object the this keyword will point to). You can also pass several space-separated types (e.g. `'click dblclick'`).
       *
       * @alternative
       * @method on(eventMap: Object): this
       * Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
       */
      on: function(t, e, n) {
        if (typeof t == "object")
          for (var o in t)
            this._on(o, t[o], e);
        else {
          t = wt(t);
          for (var h = 0, l = t.length; h < l; h++)
            this._on(t[h], e, n);
        }
        return this;
      },
      /* @method off(type: String, fn?: Function, context?: Object): this
       * Removes a previously added listener function. If no function is specified, it will remove all the listeners of that particular event from the object. Note that if you passed a custom context to `on`, you must pass the same context to `off` in order to remove the listener.
       *
       * @alternative
       * @method off(eventMap: Object): this
       * Removes a set of type/listener pairs.
       *
       * @alternative
       * @method off: this
       * Removes all listeners to all events on the object. This includes implicitly attached events.
       */
      off: function(t, e, n) {
        if (!arguments.length)
          delete this._events;
        else if (typeof t == "object")
          for (var o in t)
            this._off(o, t[o], e);
        else {
          t = wt(t);
          for (var h = arguments.length === 1, l = 0, f = t.length; l < f; l++)
            h ? this._off(t[l]) : this._off(t[l], e, n);
        }
        return this;
      },
      // attach listener (without syntactic sugar now)
      _on: function(t, e, n, o) {
        if (typeof e != "function") {
          console.warn("wrong listener type: " + typeof e);
          return;
        }
        if (this._listens(t, e, n) === !1) {
          n === this && (n = void 0);
          var h = { fn: e, ctx: n };
          o && (h.once = !0), this._events = this._events || {}, this._events[t] = this._events[t] || [], this._events[t].push(h);
        }
      },
      _off: function(t, e, n) {
        var o, h, l;
        if (this._events && (o = this._events[t], !!o)) {
          if (arguments.length === 1) {
            if (this._firingCount)
              for (h = 0, l = o.length; h < l; h++)
                o[h].fn = D;
            delete this._events[t];
            return;
          }
          if (typeof e != "function") {
            console.warn("wrong listener type: " + typeof e);
            return;
          }
          var f = this._listens(t, e, n);
          if (f !== !1) {
            var _ = o[f];
            this._firingCount && (_.fn = D, this._events[t] = o = o.slice()), o.splice(f, 1);
          }
        }
      },
      // @method fire(type: String, data?: Object, propagate?: Boolean): this
      // Fires an event of the specified type. You can optionally provide a data
      // object — the first argument of the listener function will contain its
      // properties. The event can optionally be propagated to event parents.
      fire: function(t, e, n) {
        if (!this.listens(t, n))
          return this;
        var o = u({}, e, {
          type: t,
          target: this,
          sourceTarget: e && e.sourceTarget || this
        });
        if (this._events) {
          var h = this._events[t];
          if (h) {
            this._firingCount = this._firingCount + 1 || 1;
            for (var l = 0, f = h.length; l < f; l++) {
              var _ = h[l], m = _.fn;
              _.once && this.off(t, m, _.ctx), m.call(_.ctx || this, o);
            }
            this._firingCount--;
          }
        }
        return n && this._propagateEvent(o), this;
      },
      // @method listens(type: String, propagate?: Boolean): Boolean
      // @method listens(type: String, fn: Function, context?: Object, propagate?: Boolean): Boolean
      // Returns `true` if a particular event type has any listeners attached to it.
      // The verification can optionally be propagated, it will return `true` if parents have the listener attached to it.
      listens: function(t, e, n, o) {
        typeof t != "string" && console.warn('"string" type argument expected');
        var h = e;
        typeof e != "function" && (o = !!e, h = void 0, n = void 0);
        var l = this._events && this._events[t];
        if (l && l.length && this._listens(t, h, n) !== !1)
          return !0;
        if (o) {
          for (var f in this._eventParents)
            if (this._eventParents[f].listens(t, e, n, o))
              return !0;
        }
        return !1;
      },
      // returns the index (number) or false
      _listens: function(t, e, n) {
        if (!this._events)
          return !1;
        var o = this._events[t] || [];
        if (!e)
          return !!o.length;
        n === this && (n = void 0);
        for (var h = 0, l = o.length; h < l; h++)
          if (o[h].fn === e && o[h].ctx === n)
            return h;
        return !1;
      },
      // @method once(…): this
      // Behaves as [`on(…)`](#evented-on), except the listener will only get fired once and then removed.
      once: function(t, e, n) {
        if (typeof t == "object")
          for (var o in t)
            this._on(o, t[o], e, !0);
        else {
          t = wt(t);
          for (var h = 0, l = t.length; h < l; h++)
            this._on(t[h], e, n, !0);
        }
        return this;
      },
      // @method addEventParent(obj: Evented): this
      // Adds an event parent - an `Evented` that will receive propagated events
      addEventParent: function(t) {
        return this._eventParents = this._eventParents || {}, this._eventParents[g(t)] = t, this;
      },
      // @method removeEventParent(obj: Evented): this
      // Removes an event parent, so it will stop receiving propagated events
      removeEventParent: function(t) {
        return this._eventParents && delete this._eventParents[g(t)], this;
      },
      _propagateEvent: function(t) {
        for (var e in this._eventParents)
          this._eventParents[e].fire(t.type, u({
            layer: t.target,
            propagatedFrom: t.target
          }, t), !0);
      }
    };
    gt.addEventListener = gt.on, gt.removeEventListener = gt.clearAllEventListeners = gt.off, gt.addOneTimeEventListener = gt.once, gt.fireEvent = gt.fire, gt.hasEventListeners = gt.listens;
    var We = Ut.extend(gt);
    function O(t, e, n) {
      this.x = n ? Math.round(t) : t, this.y = n ? Math.round(e) : e;
    }
    var Is = Math.trunc || function(t) {
      return t > 0 ? Math.floor(t) : Math.ceil(t);
    };
    O.prototype = {
      // @method clone(): Point
      // Returns a copy of the current point.
      clone: function() {
        return new O(this.x, this.y);
      },
      // @method add(otherPoint: Point): Point
      // Returns the result of addition of the current and the given points.
      add: function(t) {
        return this.clone()._add(S(t));
      },
      _add: function(t) {
        return this.x += t.x, this.y += t.y, this;
      },
      // @method subtract(otherPoint: Point): Point
      // Returns the result of subtraction of the given point from the current.
      subtract: function(t) {
        return this.clone()._subtract(S(t));
      },
      _subtract: function(t) {
        return this.x -= t.x, this.y -= t.y, this;
      },
      // @method divideBy(num: Number): Point
      // Returns the result of division of the current point by the given number.
      divideBy: function(t) {
        return this.clone()._divideBy(t);
      },
      _divideBy: function(t) {
        return this.x /= t, this.y /= t, this;
      },
      // @method multiplyBy(num: Number): Point
      // Returns the result of multiplication of the current point by the given number.
      multiplyBy: function(t) {
        return this.clone()._multiplyBy(t);
      },
      _multiplyBy: function(t) {
        return this.x *= t, this.y *= t, this;
      },
      // @method scaleBy(scale: Point): Point
      // Multiply each coordinate of the current point by each coordinate of
      // `scale`. In linear algebra terms, multiply the point by the
      // [scaling matrix](https://en.wikipedia.org/wiki/Scaling_%28geometry%29#Matrix_representation)
      // defined by `scale`.
      scaleBy: function(t) {
        return new O(this.x * t.x, this.y * t.y);
      },
      // @method unscaleBy(scale: Point): Point
      // Inverse of `scaleBy`. Divide each coordinate of the current point by
      // each coordinate of `scale`.
      unscaleBy: function(t) {
        return new O(this.x / t.x, this.y / t.y);
      },
      // @method round(): Point
      // Returns a copy of the current point with rounded coordinates.
      round: function() {
        return this.clone()._round();
      },
      _round: function() {
        return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
      },
      // @method floor(): Point
      // Returns a copy of the current point with floored coordinates (rounded down).
      floor: function() {
        return this.clone()._floor();
      },
      _floor: function() {
        return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this;
      },
      // @method ceil(): Point
      // Returns a copy of the current point with ceiled coordinates (rounded up).
      ceil: function() {
        return this.clone()._ceil();
      },
      _ceil: function() {
        return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this;
      },
      // @method trunc(): Point
      // Returns a copy of the current point with truncated coordinates (rounded towards zero).
      trunc: function() {
        return this.clone()._trunc();
      },
      _trunc: function() {
        return this.x = Is(this.x), this.y = Is(this.y), this;
      },
      // @method distanceTo(otherPoint: Point): Number
      // Returns the cartesian distance between the current and the given points.
      distanceTo: function(t) {
        t = S(t);
        var e = t.x - this.x, n = t.y - this.y;
        return Math.sqrt(e * e + n * n);
      },
      // @method equals(otherPoint: Point): Boolean
      // Returns `true` if the given point has the same coordinates.
      equals: function(t) {
        return t = S(t), t.x === this.x && t.y === this.y;
      },
      // @method contains(otherPoint: Point): Boolean
      // Returns `true` if both coordinates of the given point are less than the corresponding current point coordinates (in absolute values).
      contains: function(t) {
        return t = S(t), Math.abs(t.x) <= Math.abs(this.x) && Math.abs(t.y) <= Math.abs(this.y);
      },
      // @method toString(): String
      // Returns a string representation of the point for debugging purposes.
      toString: function() {
        return "Point(" + H(this.x) + ", " + H(this.y) + ")";
      }
    };
    function S(t, e, n) {
      return t instanceof O ? t : kt(t) ? new O(t[0], t[1]) : t == null ? t : typeof t == "object" && "x" in t && "y" in t ? new O(t.x, t.y) : new O(t, e, n);
    }
    function J(t, e) {
      if (t)
        for (var n = e ? [t, e] : t, o = 0, h = n.length; o < h; o++)
          this.extend(n[o]);
    }
    J.prototype = {
      // @method extend(point: Point): this
      // Extends the bounds to contain the given point.
      // @alternative
      // @method extend(otherBounds: Bounds): this
      // Extend the bounds to contain the given bounds
      extend: function(t) {
        var e, n;
        if (!t)
          return this;
        if (t instanceof O || typeof t[0] == "number" || "x" in t)
          e = n = S(t);
        else if (t = dt(t), e = t.min, n = t.max, !e || !n)
          return this;
        return !this.min && !this.max ? (this.min = e.clone(), this.max = n.clone()) : (this.min.x = Math.min(e.x, this.min.x), this.max.x = Math.max(n.x, this.max.x), this.min.y = Math.min(e.y, this.min.y), this.max.y = Math.max(n.y, this.max.y)), this;
      },
      // @method getCenter(round?: Boolean): Point
      // Returns the center point of the bounds.
      getCenter: function(t) {
        return S(
          (this.min.x + this.max.x) / 2,
          (this.min.y + this.max.y) / 2,
          t
        );
      },
      // @method getBottomLeft(): Point
      // Returns the bottom-left point of the bounds.
      getBottomLeft: function() {
        return S(this.min.x, this.max.y);
      },
      // @method getTopRight(): Point
      // Returns the top-right point of the bounds.
      getTopRight: function() {
        return S(this.max.x, this.min.y);
      },
      // @method getTopLeft(): Point
      // Returns the top-left point of the bounds (i.e. [`this.min`](#bounds-min)).
      getTopLeft: function() {
        return this.min;
      },
      // @method getBottomRight(): Point
      // Returns the bottom-right point of the bounds (i.e. [`this.max`](#bounds-max)).
      getBottomRight: function() {
        return this.max;
      },
      // @method getSize(): Point
      // Returns the size of the given bounds
      getSize: function() {
        return this.max.subtract(this.min);
      },
      // @method contains(otherBounds: Bounds): Boolean
      // Returns `true` if the rectangle contains the given one.
      // @alternative
      // @method contains(point: Point): Boolean
      // Returns `true` if the rectangle contains the given point.
      contains: function(t) {
        var e, n;
        return typeof t[0] == "number" || t instanceof O ? t = S(t) : t = dt(t), t instanceof J ? (e = t.min, n = t.max) : e = n = t, e.x >= this.min.x && n.x <= this.max.x && e.y >= this.min.y && n.y <= this.max.y;
      },
      // @method intersects(otherBounds: Bounds): Boolean
      // Returns `true` if the rectangle intersects the given bounds. Two bounds
      // intersect if they have at least one point in common.
      intersects: function(t) {
        t = dt(t);
        var e = this.min, n = this.max, o = t.min, h = t.max, l = h.x >= e.x && o.x <= n.x, f = h.y >= e.y && o.y <= n.y;
        return l && f;
      },
      // @method overlaps(otherBounds: Bounds): Boolean
      // Returns `true` if the rectangle overlaps the given bounds. Two bounds
      // overlap if their intersection is an area.
      overlaps: function(t) {
        t = dt(t);
        var e = this.min, n = this.max, o = t.min, h = t.max, l = h.x > e.x && o.x < n.x, f = h.y > e.y && o.y < n.y;
        return l && f;
      },
      // @method isValid(): Boolean
      // Returns `true` if the bounds are properly initialized.
      isValid: function() {
        return !!(this.min && this.max);
      },
      // @method pad(bufferRatio: Number): Bounds
      // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
      // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
      // Negative values will retract the bounds.
      pad: function(t) {
        var e = this.min, n = this.max, o = Math.abs(e.x - n.x) * t, h = Math.abs(e.y - n.y) * t;
        return dt(
          S(e.x - o, e.y - h),
          S(n.x + o, n.y + h)
        );
      },
      // @method equals(otherBounds: Bounds): Boolean
      // Returns `true` if the rectangle is equivalent to the given bounds.
      equals: function(t) {
        return t ? (t = dt(t), this.min.equals(t.getTopLeft()) && this.max.equals(t.getBottomRight())) : !1;
      }
    };
    function dt(t, e) {
      return !t || t instanceof J ? t : new J(t, e);
    }
    function _t(t, e) {
      if (t)
        for (var n = e ? [t, e] : t, o = 0, h = n.length; o < h; o++)
          this.extend(n[o]);
    }
    _t.prototype = {
      // @method extend(latlng: LatLng): this
      // Extend the bounds to contain the given point
      // @alternative
      // @method extend(otherBounds: LatLngBounds): this
      // Extend the bounds to contain the given bounds
      extend: function(t) {
        var e = this._southWest, n = this._northEast, o, h;
        if (t instanceof G)
          o = t, h = t;
        else if (t instanceof _t) {
          if (o = t._southWest, h = t._northEast, !o || !h)
            return this;
        } else
          return t ? this.extend(N(t) || et(t)) : this;
        return !e && !n ? (this._southWest = new G(o.lat, o.lng), this._northEast = new G(h.lat, h.lng)) : (e.lat = Math.min(o.lat, e.lat), e.lng = Math.min(o.lng, e.lng), n.lat = Math.max(h.lat, n.lat), n.lng = Math.max(h.lng, n.lng)), this;
      },
      // @method pad(bufferRatio: Number): LatLngBounds
      // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
      // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
      // Negative values will retract the bounds.
      pad: function(t) {
        var e = this._southWest, n = this._northEast, o = Math.abs(e.lat - n.lat) * t, h = Math.abs(e.lng - n.lng) * t;
        return new _t(
          new G(e.lat - o, e.lng - h),
          new G(n.lat + o, n.lng + h)
        );
      },
      // @method getCenter(): LatLng
      // Returns the center point of the bounds.
      getCenter: function() {
        return new G(
          (this._southWest.lat + this._northEast.lat) / 2,
          (this._southWest.lng + this._northEast.lng) / 2
        );
      },
      // @method getSouthWest(): LatLng
      // Returns the south-west point of the bounds.
      getSouthWest: function() {
        return this._southWest;
      },
      // @method getNorthEast(): LatLng
      // Returns the north-east point of the bounds.
      getNorthEast: function() {
        return this._northEast;
      },
      // @method getNorthWest(): LatLng
      // Returns the north-west point of the bounds.
      getNorthWest: function() {
        return new G(this.getNorth(), this.getWest());
      },
      // @method getSouthEast(): LatLng
      // Returns the south-east point of the bounds.
      getSouthEast: function() {
        return new G(this.getSouth(), this.getEast());
      },
      // @method getWest(): Number
      // Returns the west longitude of the bounds
      getWest: function() {
        return this._southWest.lng;
      },
      // @method getSouth(): Number
      // Returns the south latitude of the bounds
      getSouth: function() {
        return this._southWest.lat;
      },
      // @method getEast(): Number
      // Returns the east longitude of the bounds
      getEast: function() {
        return this._northEast.lng;
      },
      // @method getNorth(): Number
      // Returns the north latitude of the bounds
      getNorth: function() {
        return this._northEast.lat;
      },
      // @method contains(otherBounds: LatLngBounds): Boolean
      // Returns `true` if the rectangle contains the given one.
      // @alternative
      // @method contains (latlng: LatLng): Boolean
      // Returns `true` if the rectangle contains the given point.
      contains: function(t) {
        typeof t[0] == "number" || t instanceof G || "lat" in t ? t = N(t) : t = et(t);
        var e = this._southWest, n = this._northEast, o, h;
        return t instanceof _t ? (o = t.getSouthWest(), h = t.getNorthEast()) : o = h = t, o.lat >= e.lat && h.lat <= n.lat && o.lng >= e.lng && h.lng <= n.lng;
      },
      // @method intersects(otherBounds: LatLngBounds): Boolean
      // Returns `true` if the rectangle intersects the given bounds. Two bounds intersect if they have at least one point in common.
      intersects: function(t) {
        t = et(t);
        var e = this._southWest, n = this._northEast, o = t.getSouthWest(), h = t.getNorthEast(), l = h.lat >= e.lat && o.lat <= n.lat, f = h.lng >= e.lng && o.lng <= n.lng;
        return l && f;
      },
      // @method overlaps(otherBounds: LatLngBounds): Boolean
      // Returns `true` if the rectangle overlaps the given bounds. Two bounds overlap if their intersection is an area.
      overlaps: function(t) {
        t = et(t);
        var e = this._southWest, n = this._northEast, o = t.getSouthWest(), h = t.getNorthEast(), l = h.lat > e.lat && o.lat < n.lat, f = h.lng > e.lng && o.lng < n.lng;
        return l && f;
      },
      // @method toBBoxString(): String
      // Returns a string with bounding box coordinates in a 'southwest_lng,southwest_lat,northeast_lng,northeast_lat' format. Useful for sending requests to web services that return geo data.
      toBBoxString: function() {
        return [this.getWest(), this.getSouth(), this.getEast(), this.getNorth()].join(",");
      },
      // @method equals(otherBounds: LatLngBounds, maxMargin?: Number): Boolean
      // Returns `true` if the rectangle is equivalent (within a small margin of error) to the given bounds. The margin of error can be overridden by setting `maxMargin` to a small number.
      equals: function(t, e) {
        return t ? (t = et(t), this._southWest.equals(t.getSouthWest(), e) && this._northEast.equals(t.getNorthEast(), e)) : !1;
      },
      // @method isValid(): Boolean
      // Returns `true` if the bounds are properly initialized.
      isValid: function() {
        return !!(this._southWest && this._northEast);
      }
    };
    function et(t, e) {
      return t instanceof _t ? t : new _t(t, e);
    }
    function G(t, e, n) {
      if (isNaN(t) || isNaN(e))
        throw new Error("Invalid LatLng object: (" + t + ", " + e + ")");
      this.lat = +t, this.lng = +e, n !== void 0 && (this.alt = +n);
    }
    G.prototype = {
      // @method equals(otherLatLng: LatLng, maxMargin?: Number): Boolean
      // Returns `true` if the given `LatLng` point is at the same position (within a small margin of error). The margin of error can be overridden by setting `maxMargin` to a small number.
      equals: function(t, e) {
        if (!t)
          return !1;
        t = N(t);
        var n = Math.max(
          Math.abs(this.lat - t.lat),
          Math.abs(this.lng - t.lng)
        );
        return n <= (e === void 0 ? 1e-9 : e);
      },
      // @method toString(): String
      // Returns a string representation of the point (for debugging purposes).
      toString: function(t) {
        return "LatLng(" + H(this.lat, t) + ", " + H(this.lng, t) + ")";
      },
      // @method distanceTo(otherLatLng: LatLng): Number
      // Returns the distance (in meters) to the given `LatLng` calculated using the [Spherical Law of Cosines](https://en.wikipedia.org/wiki/Spherical_law_of_cosines).
      distanceTo: function(t) {
        return se.distance(this, N(t));
      },
      // @method wrap(): LatLng
      // Returns a new `LatLng` object with the longitude wrapped so it's always between -180 and +180 degrees.
      wrap: function() {
        return se.wrapLatLng(this);
      },
      // @method toBounds(sizeInMeters: Number): LatLngBounds
      // Returns a new `LatLngBounds` object in which each boundary is `sizeInMeters/2` meters apart from the `LatLng`.
      toBounds: function(t) {
        var e = 180 * t / 40075017, n = e / Math.cos(Math.PI / 180 * this.lat);
        return et(
          [this.lat - e, this.lng - n],
          [this.lat + e, this.lng + n]
        );
      },
      clone: function() {
        return new G(this.lat, this.lng, this.alt);
      }
    };
    function N(t, e, n) {
      return t instanceof G ? t : kt(t) && typeof t[0] != "object" ? t.length === 3 ? new G(t[0], t[1], t[2]) : t.length === 2 ? new G(t[0], t[1]) : null : t == null ? t : typeof t == "object" && "lat" in t ? new G(t.lat, "lng" in t ? t.lng : t.lon, t.alt) : e === void 0 ? null : new G(t, e, n);
    }
    var Gt = {
      // @method latLngToPoint(latlng: LatLng, zoom: Number): Point
      // Projects geographical coordinates into pixel coordinates for a given zoom.
      latLngToPoint: function(t, e) {
        var n = this.projection.project(t), o = this.scale(e);
        return this.transformation._transform(n, o);
      },
      // @method pointToLatLng(point: Point, zoom: Number): LatLng
      // The inverse of `latLngToPoint`. Projects pixel coordinates on a given
      // zoom into geographical coordinates.
      pointToLatLng: function(t, e) {
        var n = this.scale(e), o = this.transformation.untransform(t, n);
        return this.projection.unproject(o);
      },
      // @method project(latlng: LatLng): Point
      // Projects geographical coordinates into coordinates in units accepted for
      // this CRS (e.g. meters for EPSG:3857, for passing it to WMS services).
      project: function(t) {
        return this.projection.project(t);
      },
      // @method unproject(point: Point): LatLng
      // Given a projected coordinate returns the corresponding LatLng.
      // The inverse of `project`.
      unproject: function(t) {
        return this.projection.unproject(t);
      },
      // @method scale(zoom: Number): Number
      // Returns the scale used when transforming projected coordinates into
      // pixel coordinates for a particular zoom. For example, it returns
      // `256 * 2^zoom` for Mercator-based CRS.
      scale: function(t) {
        return 256 * Math.pow(2, t);
      },
      // @method zoom(scale: Number): Number
      // Inverse of `scale()`, returns the zoom level corresponding to a scale
      // factor of `scale`.
      zoom: function(t) {
        return Math.log(t / 256) / Math.LN2;
      },
      // @method getProjectedBounds(zoom: Number): Bounds
      // Returns the projection's bounds scaled and transformed for the provided `zoom`.
      getProjectedBounds: function(t) {
        if (this.infinite)
          return null;
        var e = this.projection.bounds, n = this.scale(t), o = this.transformation.transform(e.min, n), h = this.transformation.transform(e.max, n);
        return new J(o, h);
      },
      // @method distance(latlng1: LatLng, latlng2: LatLng): Number
      // Returns the distance between two geographical coordinates.
      // @property code: String
      // Standard code name of the CRS passed into WMS services (e.g. `'EPSG:3857'`)
      //
      // @property wrapLng: Number[]
      // An array of two numbers defining whether the longitude (horizontal) coordinate
      // axis wraps around a given range and how. Defaults to `[-180, 180]` in most
      // geographical CRSs. If `undefined`, the longitude axis does not wrap around.
      //
      // @property wrapLat: Number[]
      // Like `wrapLng`, but for the latitude (vertical) axis.
      // wrapLng: [min, max],
      // wrapLat: [min, max],
      // @property infinite: Boolean
      // If true, the coordinate space will be unbounded (infinite in both axes)
      infinite: !1,
      // @method wrapLatLng(latlng: LatLng): LatLng
      // Returns a `LatLng` where lat and lng has been wrapped according to the
      // CRS's `wrapLat` and `wrapLng` properties, if they are outside the CRS's bounds.
      wrapLatLng: function(t) {
        var e = this.wrapLng ? F(t.lng, this.wrapLng, !0) : t.lng, n = this.wrapLat ? F(t.lat, this.wrapLat, !0) : t.lat, o = t.alt;
        return new G(n, e, o);
      },
      // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
      // Returns a `LatLngBounds` with the same size as the given one, ensuring
      // that its center is within the CRS's bounds.
      // Only accepts actual `L.LatLngBounds` instances, not arrays.
      wrapLatLngBounds: function(t) {
        var e = t.getCenter(), n = this.wrapLatLng(e), o = e.lat - n.lat, h = e.lng - n.lng;
        if (o === 0 && h === 0)
          return t;
        var l = t.getSouthWest(), f = t.getNorthEast(), _ = new G(l.lat - o, l.lng - h), m = new G(f.lat - o, f.lng - h);
        return new _t(_, m);
      }
    }, se = u({}, Gt, {
      wrapLng: [-180, 180],
      // Mean Earth Radius, as recommended for use by
      // the International Union of Geodesy and Geophysics,
      // see https://rosettacode.org/wiki/Haversine_formula
      R: 6371e3,
      // distance between two geographical points using spherical law of cosines approximation
      distance: function(t, e) {
        var n = Math.PI / 180, o = t.lat * n, h = e.lat * n, l = Math.sin((e.lat - t.lat) * n / 2), f = Math.sin((e.lng - t.lng) * n / 2), _ = l * l + Math.cos(o) * Math.cos(h) * f * f, m = 2 * Math.atan2(Math.sqrt(_), Math.sqrt(1 - _));
        return this.R * m;
      }
    }), Ns = 6378137, _n = {
      R: Ns,
      MAX_LATITUDE: 85.0511287798,
      project: function(t) {
        var e = Math.PI / 180, n = this.MAX_LATITUDE, o = Math.max(Math.min(n, t.lat), -n), h = Math.sin(o * e);
        return new O(
          this.R * t.lng * e,
          this.R * Math.log((1 + h) / (1 - h)) / 2
        );
      },
      unproject: function(t) {
        var e = 180 / Math.PI;
        return new G(
          (2 * Math.atan(Math.exp(t.y / this.R)) - Math.PI / 2) * e,
          t.x * e / this.R
        );
      },
      bounds: function() {
        var t = Ns * Math.PI;
        return new J([-t, -t], [t, t]);
      }()
    };
    function mn(t, e, n, o) {
      if (kt(t)) {
        this._a = t[0], this._b = t[1], this._c = t[2], this._d = t[3];
        return;
      }
      this._a = t, this._b = e, this._c = n, this._d = o;
    }
    mn.prototype = {
      // @method transform(point: Point, scale?: Number): Point
      // Returns a transformed point, optionally multiplied by the given scale.
      // Only accepts actual `L.Point` instances, not arrays.
      transform: function(t, e) {
        return this._transform(t.clone(), e);
      },
      // destructive transform (faster)
      _transform: function(t, e) {
        return e = e || 1, t.x = e * (this._a * t.x + this._b), t.y = e * (this._c * t.y + this._d), t;
      },
      // @method untransform(point: Point, scale?: Number): Point
      // Returns the reverse transformation of the given point, optionally divided
      // by the given scale. Only accepts actual `L.Point` instances, not arrays.
      untransform: function(t, e) {
        return e = e || 1, new O(
          (t.x / e - this._b) / this._a,
          (t.y / e - this._d) / this._c
        );
      }
    };
    function Fe(t, e, n, o) {
      return new mn(t, e, n, o);
    }
    var pn = u({}, se, {
      code: "EPSG:3857",
      projection: _n,
      transformation: function() {
        var t = 0.5 / (Math.PI * _n.R);
        return Fe(t, 0.5, -t, 0.5);
      }()
    }), aa = u({}, pn, {
      code: "EPSG:900913"
    });
    function Rs(t) {
      return document.createElementNS("http://www.w3.org/2000/svg", t);
    }
    function Zs(t, e) {
      var n = "", o, h, l, f, _, m;
      for (o = 0, l = t.length; o < l; o++) {
        for (_ = t[o], h = 0, f = _.length; h < f; h++)
          m = _[h], n += (h ? "L" : "M") + m.x + " " + m.y;
        n += e ? M.svg ? "z" : "x" : "";
      }
      return n || "M0 0";
    }
    var gn = document.documentElement.style, gi = "ActiveXObject" in window, ha = gi && !document.addEventListener, Bs = "msLaunchUri" in navigator && !("documentMode" in document), vn = Nt("webkit"), Ys = Nt("android"), Ws = Nt("android 2") || Nt("android 3"), ua = parseInt(/WebKit\/([0-9]+)|$/.exec(navigator.userAgent)[1], 10), la = Ys && Nt("Google") && ua < 537 && !("AudioNode" in window), yn = !!window.opera, Fs = !Bs && Nt("chrome"), Hs = Nt("gecko") && !vn && !yn && !gi, ca = !Fs && Nt("safari"), Us = Nt("phantom"), Gs = "OTransition" in gn, fa = navigator.platform.indexOf("Win") === 0, Vs = gi && "transition" in gn, wn = "WebKitCSSMatrix" in window && "m11" in new window.WebKitCSSMatrix() && !Ws, js = "MozPerspective" in gn, da = !window.L_DISABLE_3D && (Vs || wn || js) && !Gs && !Us, He = typeof orientation < "u" || Nt("mobile"), _a = He && vn, ma = He && wn, qs = !window.PointerEvent && window.MSPointerEvent, Ks = !!(window.PointerEvent || qs), Xs = "ontouchstart" in window || !!window.TouchEvent, pa = !window.L_NO_TOUCH && (Xs || Ks), ga = He && yn, va = He && Hs, ya = (window.devicePixelRatio || window.screen.deviceXDPI / window.screen.logicalXDPI) > 1, wa = function() {
      var t = !1;
      try {
        var e = Object.defineProperty({}, "passive", {
          get: function() {
            t = !0;
          }
        });
        window.addEventListener("testPassiveEventSupport", D, e), window.removeEventListener("testPassiveEventSupport", D, e);
      } catch {
      }
      return t;
    }(), xa = function() {
      return !!document.createElement("canvas").getContext;
    }(), xn = !!(document.createElementNS && Rs("svg").createSVGRect), Pa = !!xn && function() {
      var t = document.createElement("div");
      return t.innerHTML = "<svg/>", (t.firstChild && t.firstChild.namespaceURI) === "http://www.w3.org/2000/svg";
    }(), La = !xn && function() {
      try {
        var t = document.createElement("div");
        t.innerHTML = '<v:shape adj="1"/>';
        var e = t.firstChild;
        return e.style.behavior = "url(#default#VML)", e && typeof e.adj == "object";
      } catch {
        return !1;
      }
    }(), Ma = navigator.platform.indexOf("Mac") === 0, ba = navigator.platform.indexOf("Linux") === 0;
    function Nt(t) {
      return navigator.userAgent.toLowerCase().indexOf(t) >= 0;
    }
    var M = {
      ie: gi,
      ielt9: ha,
      edge: Bs,
      webkit: vn,
      android: Ys,
      android23: Ws,
      androidStock: la,
      opera: yn,
      chrome: Fs,
      gecko: Hs,
      safari: ca,
      phantom: Us,
      opera12: Gs,
      win: fa,
      ie3d: Vs,
      webkit3d: wn,
      gecko3d: js,
      any3d: da,
      mobile: He,
      mobileWebkit: _a,
      mobileWebkit3d: ma,
      msPointer: qs,
      pointer: Ks,
      touch: pa,
      touchNative: Xs,
      mobileOpera: ga,
      mobileGecko: va,
      retina: ya,
      passiveEvents: wa,
      canvas: xa,
      svg: xn,
      vml: La,
      inlineSvg: Pa,
      mac: Ma,
      linux: ba
    }, Js = M.msPointer ? "MSPointerDown" : "pointerdown", $s = M.msPointer ? "MSPointerMove" : "pointermove", Qs = M.msPointer ? "MSPointerUp" : "pointerup", tr = M.msPointer ? "MSPointerCancel" : "pointercancel", Pn = {
      touchstart: Js,
      touchmove: $s,
      touchend: Qs,
      touchcancel: tr
    }, er = {
      touchstart: Da,
      touchmove: vi,
      touchend: vi,
      touchcancel: vi
    }, Pe = {}, ir = !1;
    function Ta(t, e, n) {
      return e === "touchstart" && Ca(), er[e] ? (n = er[e].bind(this, n), t.addEventListener(Pn[e], n, !1), n) : (console.warn("wrong event specified:", e), D);
    }
    function Sa(t, e, n) {
      if (!Pn[e]) {
        console.warn("wrong event specified:", e);
        return;
      }
      t.removeEventListener(Pn[e], n, !1);
    }
    function ka(t) {
      Pe[t.pointerId] = t;
    }
    function Oa(t) {
      Pe[t.pointerId] && (Pe[t.pointerId] = t);
    }
    function nr(t) {
      delete Pe[t.pointerId];
    }
    function Ca() {
      ir || (document.addEventListener(Js, ka, !0), document.addEventListener($s, Oa, !0), document.addEventListener(Qs, nr, !0), document.addEventListener(tr, nr, !0), ir = !0);
    }
    function vi(t, e) {
      if (e.pointerType !== (e.MSPOINTER_TYPE_MOUSE || "mouse")) {
        e.touches = [];
        for (var n in Pe)
          e.touches.push(Pe[n]);
        e.changedTouches = [e], t(e);
      }
    }
    function Da(t, e) {
      e.MSPOINTER_TYPE_TOUCH && e.pointerType === e.MSPOINTER_TYPE_TOUCH && at(e), vi(t, e);
    }
    function Ea(t) {
      var e = {}, n, o;
      for (o in t)
        n = t[o], e[o] = n && n.bind ? n.bind(t) : n;
      return t = e, e.type = "dblclick", e.detail = 2, e.isTrusted = !1, e._simulated = !0, e;
    }
    var Aa = 200;
    function za(t, e) {
      t.addEventListener("dblclick", e);
      var n = 0, o;
      function h(l) {
        if (l.detail !== 1) {
          o = l.detail;
          return;
        }
        if (!(l.pointerType === "mouse" || l.sourceCapabilities && !l.sourceCapabilities.firesTouchEvents)) {
          var f = hr(l);
          if (!(f.some(function(m) {
            return m instanceof HTMLLabelElement && m.attributes.for;
          }) && !f.some(function(m) {
            return m instanceof HTMLInputElement || m instanceof HTMLSelectElement;
          }))) {
            var _ = Date.now();
            _ - n <= Aa ? (o++, o === 2 && e(Ea(l))) : o = 1, n = _;
          }
        }
      }
      return t.addEventListener("click", h), {
        dblclick: e,
        simDblclick: h
      };
    }
    function Ia(t, e) {
      t.removeEventListener("dblclick", e.dblclick), t.removeEventListener("click", e.simDblclick);
    }
    var Ln = xi(
      ["transform", "webkitTransform", "OTransform", "MozTransform", "msTransform"]
    ), Ue = xi(
      ["webkitTransition", "transition", "OTransition", "MozTransition", "msTransition"]
    ), sr = Ue === "webkitTransition" || Ue === "OTransition" ? Ue + "End" : "transitionend";
    function rr(t) {
      return typeof t == "string" ? document.getElementById(t) : t;
    }
    function Ge(t, e) {
      var n = t.style[e] || t.currentStyle && t.currentStyle[e];
      if ((!n || n === "auto") && document.defaultView) {
        var o = document.defaultView.getComputedStyle(t, null);
        n = o ? o[e] : null;
      }
      return n === "auto" ? null : n;
    }
    function B(t, e, n) {
      var o = document.createElement(t);
      return o.className = e || "", n && n.appendChild(o), o;
    }
    function $(t) {
      var e = t.parentNode;
      e && e.removeChild(t);
    }
    function yi(t) {
      for (; t.firstChild; )
        t.removeChild(t.firstChild);
    }
    function Le(t) {
      var e = t.parentNode;
      e && e.lastChild !== t && e.appendChild(t);
    }
    function Me(t) {
      var e = t.parentNode;
      e && e.firstChild !== t && e.insertBefore(t, e.firstChild);
    }
    function Mn(t, e) {
      if (t.classList !== void 0)
        return t.classList.contains(e);
      var n = wi(t);
      return n.length > 0 && new RegExp("(^|\\s)" + e + "(\\s|$)").test(n);
    }
    function A(t, e) {
      if (t.classList !== void 0)
        for (var n = wt(e), o = 0, h = n.length; o < h; o++)
          t.classList.add(n[o]);
      else if (!Mn(t, e)) {
        var l = wi(t);
        bn(t, (l ? l + " " : "") + e);
      }
    }
    function Q(t, e) {
      t.classList !== void 0 ? t.classList.remove(e) : bn(t, rt((" " + wi(t) + " ").replace(" " + e + " ", " ")));
    }
    function bn(t, e) {
      t.className.baseVal === void 0 ? t.className = e : t.className.baseVal = e;
    }
    function wi(t) {
      return t.correspondingElement && (t = t.correspondingElement), t.className.baseVal === void 0 ? t.className : t.className.baseVal;
    }
    function Pt(t, e) {
      "opacity" in t.style ? t.style.opacity = e : "filter" in t.style && Na(t, e);
    }
    function Na(t, e) {
      var n = !1, o = "DXImageTransform.Microsoft.Alpha";
      try {
        n = t.filters.item(o);
      } catch {
        if (e === 1)
          return;
      }
      e = Math.round(e * 100), n ? (n.Enabled = e !== 100, n.Opacity = e) : t.style.filter += " progid:" + o + "(opacity=" + e + ")";
    }
    function xi(t) {
      for (var e = document.documentElement.style, n = 0; n < t.length; n++)
        if (t[n] in e)
          return t[n];
      return !1;
    }
    function ce(t, e, n) {
      var o = e || new O(0, 0);
      t.style[Ln] = (M.ie3d ? "translate(" + o.x + "px," + o.y + "px)" : "translate3d(" + o.x + "px," + o.y + "px,0)") + (n ? " scale(" + n + ")" : "");
    }
    function it(t, e) {
      t._leaflet_pos = e, M.any3d ? ce(t, e) : (t.style.left = e.x + "px", t.style.top = e.y + "px");
    }
    function fe(t) {
      return t._leaflet_pos || new O(0, 0);
    }
    var Ve, je, Tn;
    if ("onselectstart" in document)
      Ve = function() {
        C(window, "selectstart", at);
      }, je = function() {
        j(window, "selectstart", at);
      };
    else {
      var qe = xi(
        ["userSelect", "WebkitUserSelect", "OUserSelect", "MozUserSelect", "msUserSelect"]
      );
      Ve = function() {
        if (qe) {
          var t = document.documentElement.style;
          Tn = t[qe], t[qe] = "none";
        }
      }, je = function() {
        qe && (document.documentElement.style[qe] = Tn, Tn = void 0);
      };
    }
    function Sn() {
      C(window, "dragstart", at);
    }
    function kn() {
      j(window, "dragstart", at);
    }
    var Pi, On;
    function Cn(t) {
      for (; t.tabIndex === -1; )
        t = t.parentNode;
      t.style && (Li(), Pi = t, On = t.style.outlineStyle, t.style.outlineStyle = "none", C(window, "keydown", Li));
    }
    function Li() {
      Pi && (Pi.style.outlineStyle = On, Pi = void 0, On = void 0, j(window, "keydown", Li));
    }
    function or(t) {
      do
        t = t.parentNode;
      while ((!t.offsetWidth || !t.offsetHeight) && t !== document.body);
      return t;
    }
    function Dn(t) {
      var e = t.getBoundingClientRect();
      return {
        x: e.width / t.offsetWidth || 1,
        y: e.height / t.offsetHeight || 1,
        boundingClientRect: e
      };
    }
    var Ra = {
      __proto__: null,
      TRANSFORM: Ln,
      TRANSITION: Ue,
      TRANSITION_END: sr,
      get: rr,
      getStyle: Ge,
      create: B,
      remove: $,
      empty: yi,
      toFront: Le,
      toBack: Me,
      hasClass: Mn,
      addClass: A,
      removeClass: Q,
      setClass: bn,
      getClass: wi,
      setOpacity: Pt,
      testProp: xi,
      setTransform: ce,
      setPosition: it,
      getPosition: fe,
      get disableTextSelection() {
        return Ve;
      },
      get enableTextSelection() {
        return je;
      },
      disableImageDrag: Sn,
      enableImageDrag: kn,
      preventOutline: Cn,
      restoreOutline: Li,
      getSizedParentNode: or,
      getScale: Dn
    };
    function C(t, e, n, o) {
      if (e && typeof e == "object")
        for (var h in e)
          An(t, h, e[h], n);
      else {
        e = wt(e);
        for (var l = 0, f = e.length; l < f; l++)
          An(t, e[l], n, o);
      }
      return this;
    }
    var Rt = "_leaflet_events";
    function j(t, e, n, o) {
      if (arguments.length === 1)
        ar(t), delete t[Rt];
      else if (e && typeof e == "object")
        for (var h in e)
          zn(t, h, e[h], n);
      else if (e = wt(e), arguments.length === 2)
        ar(t, function(_) {
          return cn(e, _) !== -1;
        });
      else
        for (var l = 0, f = e.length; l < f; l++)
          zn(t, e[l], n, o);
      return this;
    }
    function ar(t, e) {
      for (var n in t[Rt]) {
        var o = n.split(/\d/)[0];
        (!e || e(o)) && zn(t, o, null, null, n);
      }
    }
    var En = {
      mouseenter: "mouseover",
      mouseleave: "mouseout",
      wheel: !("onwheel" in window) && "mousewheel"
    };
    function An(t, e, n, o) {
      var h = e + g(n) + (o ? "_" + g(o) : "");
      if (t[Rt] && t[Rt][h])
        return this;
      var l = function(_) {
        return n.call(o || t, _ || window.event);
      }, f = l;
      !M.touchNative && M.pointer && e.indexOf("touch") === 0 ? l = Ta(t, e, l) : M.touch && e === "dblclick" ? l = za(t, l) : "addEventListener" in t ? e === "touchstart" || e === "touchmove" || e === "wheel" || e === "mousewheel" ? t.addEventListener(En[e] || e, l, M.passiveEvents ? { passive: !1 } : !1) : e === "mouseenter" || e === "mouseleave" ? (l = function(_) {
        _ = _ || window.event, Nn(t, _) && f(_);
      }, t.addEventListener(En[e], l, !1)) : t.addEventListener(e, f, !1) : t.attachEvent("on" + e, l), t[Rt] = t[Rt] || {}, t[Rt][h] = l;
    }
    function zn(t, e, n, o, h) {
      h = h || e + g(n) + (o ? "_" + g(o) : "");
      var l = t[Rt] && t[Rt][h];
      if (!l)
        return this;
      !M.touchNative && M.pointer && e.indexOf("touch") === 0 ? Sa(t, e, l) : M.touch && e === "dblclick" ? Ia(t, l) : "removeEventListener" in t ? t.removeEventListener(En[e] || e, l, !1) : t.detachEvent("on" + e, l), t[Rt][h] = null;
    }
    function de(t) {
      return t.stopPropagation ? t.stopPropagation() : t.originalEvent ? t.originalEvent._stopped = !0 : t.cancelBubble = !0, this;
    }
    function In(t) {
      return An(t, "wheel", de), this;
    }
    function Ke(t) {
      return C(t, "mousedown touchstart dblclick contextmenu", de), t._leaflet_disable_click = !0, this;
    }
    function at(t) {
      return t.preventDefault ? t.preventDefault() : t.returnValue = !1, this;
    }
    function _e(t) {
      return at(t), de(t), this;
    }
    function hr(t) {
      if (t.composedPath)
        return t.composedPath();
      for (var e = [], n = t.target; n; )
        e.push(n), n = n.parentNode;
      return e;
    }
    function ur(t, e) {
      if (!e)
        return new O(t.clientX, t.clientY);
      var n = Dn(e), o = n.boundingClientRect;
      return new O(
        // offset.left/top values are in page scale (like clientX/Y),
        // whereas clientLeft/Top (border width) values are the original values (before CSS scale applies).
        (t.clientX - o.left) / n.x - e.clientLeft,
        (t.clientY - o.top) / n.y - e.clientTop
      );
    }
    var Za = M.linux && M.chrome ? window.devicePixelRatio : M.mac ? window.devicePixelRatio * 3 : window.devicePixelRatio > 0 ? 2 * window.devicePixelRatio : 1;
    function lr(t) {
      return M.edge ? t.wheelDeltaY / 2 : (
        // Don't trust window-geometry-based delta
        t.deltaY && t.deltaMode === 0 ? -t.deltaY / Za : (
          // Pixels
          t.deltaY && t.deltaMode === 1 ? -t.deltaY * 20 : (
            // Lines
            t.deltaY && t.deltaMode === 2 ? -t.deltaY * 60 : (
              // Pages
              t.deltaX || t.deltaZ ? 0 : (
                // Skip horizontal/depth wheel events
                t.wheelDelta ? (t.wheelDeltaY || t.wheelDelta) / 2 : (
                  // Legacy IE pixels
                  t.detail && Math.abs(t.detail) < 32765 ? -t.detail * 20 : (
                    // Legacy Moz lines
                    t.detail ? t.detail / -32765 * 60 : (
                      // Legacy Moz pages
                      0
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
    function Nn(t, e) {
      var n = e.relatedTarget;
      if (!n)
        return !0;
      try {
        for (; n && n !== t; )
          n = n.parentNode;
      } catch {
        return !1;
      }
      return n !== t;
    }
    var Ba = {
      __proto__: null,
      on: C,
      off: j,
      stopPropagation: de,
      disableScrollPropagation: In,
      disableClickPropagation: Ke,
      preventDefault: at,
      stop: _e,
      getPropagationPath: hr,
      getMousePosition: ur,
      getWheelDelta: lr,
      isExternalTarget: Nn,
      addListener: C,
      removeListener: j
    }, cr = We.extend({
      // @method run(el: HTMLElement, newPos: Point, duration?: Number, easeLinearity?: Number)
      // Run an animation of a given element to a new position, optionally setting
      // duration in seconds (`0.25` by default) and easing linearity factor (3rd
      // argument of the [cubic bezier curve](https://cubic-bezier.com/#0,0,.5,1),
      // `0.5` by default).
      run: function(t, e, n, o) {
        this.stop(), this._el = t, this._inProgress = !0, this._duration = n || 0.25, this._easeOutPower = 1 / Math.max(o || 0.5, 0.2), this._startPos = fe(t), this._offset = e.subtract(this._startPos), this._startTime = +/* @__PURE__ */ new Date(), this.fire("start"), this._animate();
      },
      // @method stop()
      // Stops the animation (if currently running).
      stop: function() {
        this._inProgress && (this._step(!0), this._complete());
      },
      _animate: function() {
        this._animId = ft(this._animate, this), this._step();
      },
      _step: function(t) {
        var e = +/* @__PURE__ */ new Date() - this._startTime, n = this._duration * 1e3;
        e < n ? this._runFrame(this._easeOut(e / n), t) : (this._runFrame(1), this._complete());
      },
      _runFrame: function(t, e) {
        var n = this._startPos.add(this._offset.multiplyBy(t));
        e && n._round(), it(this._el, n), this.fire("step");
      },
      _complete: function() {
        xt(this._animId), this._inProgress = !1, this.fire("end");
      },
      _easeOut: function(t) {
        return 1 - Math.pow(1 - t, this._easeOutPower);
      }
    }), R = We.extend({
      options: {
        // @section Map State Options
        // @option crs: CRS = L.CRS.EPSG3857
        // The [Coordinate Reference System](#crs) to use. Don't change this if you're not
        // sure what it means.
        crs: pn,
        // @option center: LatLng = undefined
        // Initial geographic center of the map
        center: void 0,
        // @option zoom: Number = undefined
        // Initial map zoom level
        zoom: void 0,
        // @option minZoom: Number = *
        // Minimum zoom level of the map.
        // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
        // the lowest of their `minZoom` options will be used instead.
        minZoom: void 0,
        // @option maxZoom: Number = *
        // Maximum zoom level of the map.
        // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
        // the highest of their `maxZoom` options will be used instead.
        maxZoom: void 0,
        // @option layers: Layer[] = []
        // Array of layers that will be added to the map initially
        layers: [],
        // @option maxBounds: LatLngBounds = null
        // When this option is set, the map restricts the view to the given
        // geographical bounds, bouncing the user back if the user tries to pan
        // outside the view. To set the restriction dynamically, use
        // [`setMaxBounds`](#map-setmaxbounds) method.
        maxBounds: void 0,
        // @option renderer: Renderer = *
        // The default method for drawing vector layers on the map. `L.SVG`
        // or `L.Canvas` by default depending on browser support.
        renderer: void 0,
        // @section Animation Options
        // @option zoomAnimation: Boolean = true
        // Whether the map zoom animation is enabled. By default it's enabled
        // in all browsers that support CSS3 Transitions except Android.
        zoomAnimation: !0,
        // @option zoomAnimationThreshold: Number = 4
        // Won't animate zoom if the zoom difference exceeds this value.
        zoomAnimationThreshold: 4,
        // @option fadeAnimation: Boolean = true
        // Whether the tile fade animation is enabled. By default it's enabled
        // in all browsers that support CSS3 Transitions except Android.
        fadeAnimation: !0,
        // @option markerZoomAnimation: Boolean = true
        // Whether markers animate their zoom with the zoom animation, if disabled
        // they will disappear for the length of the animation. By default it's
        // enabled in all browsers that support CSS3 Transitions except Android.
        markerZoomAnimation: !0,
        // @option transform3DLimit: Number = 2^23
        // Defines the maximum size of a CSS translation transform. The default
        // value should not be changed unless a web browser positions layers in
        // the wrong place after doing a large `panBy`.
        transform3DLimit: 8388608,
        // Precision limit of a 32-bit float
        // @section Interaction Options
        // @option zoomSnap: Number = 1
        // Forces the map's zoom level to always be a multiple of this, particularly
        // right after a [`fitBounds()`](#map-fitbounds) or a pinch-zoom.
        // By default, the zoom level snaps to the nearest integer; lower values
        // (e.g. `0.5` or `0.1`) allow for greater granularity. A value of `0`
        // means the zoom level will not be snapped after `fitBounds` or a pinch-zoom.
        zoomSnap: 1,
        // @option zoomDelta: Number = 1
        // Controls how much the map's zoom level will change after a
        // [`zoomIn()`](#map-zoomin), [`zoomOut()`](#map-zoomout), pressing `+`
        // or `-` on the keyboard, or using the [zoom controls](#control-zoom).
        // Values smaller than `1` (e.g. `0.5`) allow for greater granularity.
        zoomDelta: 1,
        // @option trackResize: Boolean = true
        // Whether the map automatically handles browser window resize to update itself.
        trackResize: !0
      },
      initialize: function(t, e) {
        e = U(this, e), this._handlers = [], this._layers = {}, this._zoomBoundLayers = {}, this._sizeChanged = !0, this._initContainer(t), this._initLayout(), this._onResize = d(this._onResize, this), this._initEvents(), e.maxBounds && this.setMaxBounds(e.maxBounds), e.zoom !== void 0 && (this._zoom = this._limitZoom(e.zoom)), e.center && e.zoom !== void 0 && this.setView(N(e.center), e.zoom, { reset: !0 }), this.callInitHooks(), this._zoomAnimated = Ue && M.any3d && !M.mobileOpera && this.options.zoomAnimation, this._zoomAnimated && (this._createAnimProxy(), C(this._proxy, sr, this._catchTransitionEnd, this)), this._addLayers(this.options.layers);
      },
      // @section Methods for modifying map state
      // @method setView(center: LatLng, zoom: Number, options?: Zoom/pan options): this
      // Sets the view of the map (geographical center and zoom) with the given
      // animation options.
      setView: function(t, e, n) {
        if (e = e === void 0 ? this._zoom : this._limitZoom(e), t = this._limitCenter(N(t), e, this.options.maxBounds), n = n || {}, this._stop(), this._loaded && !n.reset && n !== !0) {
          n.animate !== void 0 && (n.zoom = u({ animate: n.animate }, n.zoom), n.pan = u({ animate: n.animate, duration: n.duration }, n.pan));
          var o = this._zoom !== e ? this._tryAnimatedZoom && this._tryAnimatedZoom(t, e, n.zoom) : this._tryAnimatedPan(t, n.pan);
          if (o)
            return clearTimeout(this._sizeTimer), this;
        }
        return this._resetView(t, e, n.pan && n.pan.noMoveStart), this;
      },
      // @method setZoom(zoom: Number, options?: Zoom/pan options): this
      // Sets the zoom of the map.
      setZoom: function(t, e) {
        return this._loaded ? this.setView(this.getCenter(), t, { zoom: e }) : (this._zoom = t, this);
      },
      // @method zoomIn(delta?: Number, options?: Zoom options): this
      // Increases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
      zoomIn: function(t, e) {
        return t = t || (M.any3d ? this.options.zoomDelta : 1), this.setZoom(this._zoom + t, e);
      },
      // @method zoomOut(delta?: Number, options?: Zoom options): this
      // Decreases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
      zoomOut: function(t, e) {
        return t = t || (M.any3d ? this.options.zoomDelta : 1), this.setZoom(this._zoom - t, e);
      },
      // @method setZoomAround(latlng: LatLng, zoom: Number, options: Zoom options): this
      // Zooms the map while keeping a specified geographical point on the map
      // stationary (e.g. used internally for scroll zoom and double-click zoom).
      // @alternative
      // @method setZoomAround(offset: Point, zoom: Number, options: Zoom options): this
      // Zooms the map while keeping a specified pixel on the map (relative to the top-left corner) stationary.
      setZoomAround: function(t, e, n) {
        var o = this.getZoomScale(e), h = this.getSize().divideBy(2), l = t instanceof O ? t : this.latLngToContainerPoint(t), f = l.subtract(h).multiplyBy(1 - 1 / o), _ = this.containerPointToLatLng(h.add(f));
        return this.setView(_, e, { zoom: n });
      },
      _getBoundsCenterZoom: function(t, e) {
        e = e || {}, t = t.getBounds ? t.getBounds() : et(t);
        var n = S(e.paddingTopLeft || e.padding || [0, 0]), o = S(e.paddingBottomRight || e.padding || [0, 0]), h = this.getBoundsZoom(t, !1, n.add(o));
        if (h = typeof e.maxZoom == "number" ? Math.min(e.maxZoom, h) : h, h === 1 / 0)
          return {
            center: t.getCenter(),
            zoom: h
          };
        var l = o.subtract(n).divideBy(2), f = this.project(t.getSouthWest(), h), _ = this.project(t.getNorthEast(), h), m = this.unproject(f.add(_).divideBy(2).add(l), h);
        return {
          center: m,
          zoom: h
        };
      },
      // @method fitBounds(bounds: LatLngBounds, options?: fitBounds options): this
      // Sets a map view that contains the given geographical bounds with the
      // maximum zoom level possible.
      fitBounds: function(t, e) {
        if (t = et(t), !t.isValid())
          throw new Error("Bounds are not valid.");
        var n = this._getBoundsCenterZoom(t, e);
        return this.setView(n.center, n.zoom, e);
      },
      // @method fitWorld(options?: fitBounds options): this
      // Sets a map view that mostly contains the whole world with the maximum
      // zoom level possible.
      fitWorld: function(t) {
        return this.fitBounds([[-90, -180], [90, 180]], t);
      },
      // @method panTo(latlng: LatLng, options?: Pan options): this
      // Pans the map to a given center.
      panTo: function(t, e) {
        return this.setView(t, this._zoom, { pan: e });
      },
      // @method panBy(offset: Point, options?: Pan options): this
      // Pans the map by a given number of pixels (animated).
      panBy: function(t, e) {
        if (t = S(t).round(), e = e || {}, !t.x && !t.y)
          return this.fire("moveend");
        if (e.animate !== !0 && !this.getSize().contains(t))
          return this._resetView(this.unproject(this.project(this.getCenter()).add(t)), this.getZoom()), this;
        if (this._panAnim || (this._panAnim = new cr(), this._panAnim.on({
          step: this._onPanTransitionStep,
          end: this._onPanTransitionEnd
        }, this)), e.noMoveStart || this.fire("movestart"), e.animate !== !1) {
          A(this._mapPane, "leaflet-pan-anim");
          var n = this._getMapPanePos().subtract(t).round();
          this._panAnim.run(this._mapPane, n, e.duration || 0.25, e.easeLinearity);
        } else
          this._rawPanBy(t), this.fire("move").fire("moveend");
        return this;
      },
      // @method flyTo(latlng: LatLng, zoom?: Number, options?: Zoom/pan options): this
      // Sets the view of the map (geographical center and zoom) performing a smooth
      // pan-zoom animation.
      flyTo: function(t, e, n) {
        if (n = n || {}, n.animate === !1 || !M.any3d)
          return this.setView(t, e, n);
        this._stop();
        var o = this.project(this.getCenter()), h = this.project(t), l = this.getSize(), f = this._zoom;
        t = N(t), e = e === void 0 ? f : e;
        var _ = Math.max(l.x, l.y), m = _ * this.getZoomScale(f, e), p = h.distanceTo(o) || 1, x = 1.42, T = x * x;
        function z(nt) {
          var Ii = nt ? -1 : 1, Sh = nt ? m : _, kh = m * m - _ * _ + Ii * T * T * p * p, Oh = 2 * Sh * T * p, jn = kh / Oh, Gr = Math.sqrt(jn * jn + 1) - jn, Ch = Gr < 1e-9 ? -18 : Math.log(Gr);
          return Ch;
        }
        function ct(nt) {
          return (Math.exp(nt) - Math.exp(-nt)) / 2;
        }
        function ot(nt) {
          return (Math.exp(nt) + Math.exp(-nt)) / 2;
        }
        function Mt(nt) {
          return ct(nt) / ot(nt);
        }
        var mt = z(0);
        function Ce(nt) {
          return _ * (ot(mt) / ot(mt + x * nt));
        }
        function Lh(nt) {
          return _ * (ot(mt) * Mt(mt + x * nt) - ct(mt)) / T;
        }
        function Mh(nt) {
          return 1 - Math.pow(1 - nt, 1.5);
        }
        var bh = Date.now(), Hr = (z(1) - mt) / x, Th = n.duration ? 1e3 * n.duration : 1e3 * Hr * 0.8;
        function Ur() {
          var nt = (Date.now() - bh) / Th, Ii = Mh(nt) * Hr;
          nt <= 1 ? (this._flyToFrame = ft(Ur, this), this._move(
            this.unproject(o.add(h.subtract(o).multiplyBy(Lh(Ii) / p)), f),
            this.getScaleZoom(_ / Ce(Ii), f),
            { flyTo: !0 }
          )) : this._move(t, e)._moveEnd(!0);
        }
        return this._moveStart(!0, n.noMoveStart), Ur.call(this), this;
      },
      // @method flyToBounds(bounds: LatLngBounds, options?: fitBounds options): this
      // Sets the view of the map with a smooth animation like [`flyTo`](#map-flyto),
      // but takes a bounds parameter like [`fitBounds`](#map-fitbounds).
      flyToBounds: function(t, e) {
        var n = this._getBoundsCenterZoom(t, e);
        return this.flyTo(n.center, n.zoom, e);
      },
      // @method setMaxBounds(bounds: LatLngBounds): this
      // Restricts the map view to the given bounds (see the [maxBounds](#map-maxbounds) option).
      setMaxBounds: function(t) {
        return t = et(t), this.listens("moveend", this._panInsideMaxBounds) && this.off("moveend", this._panInsideMaxBounds), t.isValid() ? (this.options.maxBounds = t, this._loaded && this._panInsideMaxBounds(), this.on("moveend", this._panInsideMaxBounds)) : (this.options.maxBounds = null, this);
      },
      // @method setMinZoom(zoom: Number): this
      // Sets the lower limit for the available zoom levels (see the [minZoom](#map-minzoom) option).
      setMinZoom: function(t) {
        var e = this.options.minZoom;
        return this.options.minZoom = t, this._loaded && e !== t && (this.fire("zoomlevelschange"), this.getZoom() < this.options.minZoom) ? this.setZoom(t) : this;
      },
      // @method setMaxZoom(zoom: Number): this
      // Sets the upper limit for the available zoom levels (see the [maxZoom](#map-maxzoom) option).
      setMaxZoom: function(t) {
        var e = this.options.maxZoom;
        return this.options.maxZoom = t, this._loaded && e !== t && (this.fire("zoomlevelschange"), this.getZoom() > this.options.maxZoom) ? this.setZoom(t) : this;
      },
      // @method panInsideBounds(bounds: LatLngBounds, options?: Pan options): this
      // Pans the map to the closest view that would lie inside the given bounds (if it's not already), controlling the animation using the options specific, if any.
      panInsideBounds: function(t, e) {
        this._enforcingBounds = !0;
        var n = this.getCenter(), o = this._limitCenter(n, this._zoom, et(t));
        return n.equals(o) || this.panTo(o, e), this._enforcingBounds = !1, this;
      },
      // @method panInside(latlng: LatLng, options?: padding options): this
      // Pans the map the minimum amount to make the `latlng` visible. Use
      // padding options to fit the display to more restricted bounds.
      // If `latlng` is already within the (optionally padded) display bounds,
      // the map will not be panned.
      panInside: function(t, e) {
        e = e || {};
        var n = S(e.paddingTopLeft || e.padding || [0, 0]), o = S(e.paddingBottomRight || e.padding || [0, 0]), h = this.project(this.getCenter()), l = this.project(t), f = this.getPixelBounds(), _ = dt([f.min.add(n), f.max.subtract(o)]), m = _.getSize();
        if (!_.contains(l)) {
          this._enforcingBounds = !0;
          var p = l.subtract(_.getCenter()), x = _.extend(l).getSize().subtract(m);
          h.x += p.x < 0 ? -x.x : x.x, h.y += p.y < 0 ? -x.y : x.y, this.panTo(this.unproject(h), e), this._enforcingBounds = !1;
        }
        return this;
      },
      // @method invalidateSize(options: Zoom/pan options): this
      // Checks if the map container size changed and updates the map if so —
      // call it after you've changed the map size dynamically, also animating
      // pan by default. If `options.pan` is `false`, panning will not occur.
      // If `options.debounceMoveend` is `true`, it will delay `moveend` event so
      // that it doesn't happen often even if the method is called many
      // times in a row.
      // @alternative
      // @method invalidateSize(animate: Boolean): this
      // Checks if the map container size changed and updates the map if so —
      // call it after you've changed the map size dynamically, also animating
      // pan by default.
      invalidateSize: function(t) {
        if (!this._loaded)
          return this;
        t = u({
          animate: !1,
          pan: !0
        }, t === !0 ? { animate: !0 } : t);
        var e = this.getSize();
        this._sizeChanged = !0, this._lastCenter = null;
        var n = this.getSize(), o = e.divideBy(2).round(), h = n.divideBy(2).round(), l = o.subtract(h);
        return !l.x && !l.y ? this : (t.animate && t.pan ? this.panBy(l) : (t.pan && this._rawPanBy(l), this.fire("move"), t.debounceMoveend ? (clearTimeout(this._sizeTimer), this._sizeTimer = setTimeout(d(this.fire, this, "moveend"), 200)) : this.fire("moveend")), this.fire("resize", {
          oldSize: e,
          newSize: n
        }));
      },
      // @section Methods for modifying map state
      // @method stop(): this
      // Stops the currently running `panTo` or `flyTo` animation, if any.
      stop: function() {
        return this.setZoom(this._limitZoom(this._zoom)), this.options.zoomSnap || this.fire("viewreset"), this._stop();
      },
      // @section Geolocation methods
      // @method locate(options?: Locate options): this
      // Tries to locate the user using the Geolocation API, firing a [`locationfound`](#map-locationfound)
      // event with location data on success or a [`locationerror`](#map-locationerror) event on failure,
      // and optionally sets the map view to the user's location with respect to
      // detection accuracy (or to the world view if geolocation failed).
      // Note that, if your page doesn't use HTTPS, this method will fail in
      // modern browsers ([Chrome 50 and newer](https://sites.google.com/a/chromium.org/dev/Home/chromium-security/deprecating-powerful-features-on-insecure-origins))
      // See `Locate options` for more details.
      locate: function(t) {
        if (t = this._locateOptions = u({
          timeout: 1e4,
          watch: !1
          // setView: false
          // maxZoom: <Number>
          // maximumAge: 0
          // enableHighAccuracy: false
        }, t), !("geolocation" in navigator))
          return this._handleGeolocationError({
            code: 0,
            message: "Geolocation not supported."
          }), this;
        var e = d(this._handleGeolocationResponse, this), n = d(this._handleGeolocationError, this);
        return t.watch ? this._locationWatchId = navigator.geolocation.watchPosition(e, n, t) : navigator.geolocation.getCurrentPosition(e, n, t), this;
      },
      // @method stopLocate(): this
      // Stops watching location previously initiated by `map.locate({watch: true})`
      // and aborts resetting the map view if map.locate was called with
      // `{setView: true}`.
      stopLocate: function() {
        return navigator.geolocation && navigator.geolocation.clearWatch && navigator.geolocation.clearWatch(this._locationWatchId), this._locateOptions && (this._locateOptions.setView = !1), this;
      },
      _handleGeolocationError: function(t) {
        if (this._container._leaflet_id) {
          var e = t.code, n = t.message || (e === 1 ? "permission denied" : e === 2 ? "position unavailable" : "timeout");
          this._locateOptions.setView && !this._loaded && this.fitWorld(), this.fire("locationerror", {
            code: e,
            message: "Geolocation error: " + n + "."
          });
        }
      },
      _handleGeolocationResponse: function(t) {
        if (this._container._leaflet_id) {
          var e = t.coords.latitude, n = t.coords.longitude, o = new G(e, n), h = o.toBounds(t.coords.accuracy * 2), l = this._locateOptions;
          if (l.setView) {
            var f = this.getBoundsZoom(h);
            this.setView(o, l.maxZoom ? Math.min(f, l.maxZoom) : f);
          }
          var _ = {
            latlng: o,
            bounds: h,
            timestamp: t.timestamp
          };
          for (var m in t.coords)
            typeof t.coords[m] == "number" && (_[m] = t.coords[m]);
          this.fire("locationfound", _);
        }
      },
      // TODO Appropriate docs section?
      // @section Other Methods
      // @method addHandler(name: String, HandlerClass: Function): this
      // Adds a new `Handler` to the map, given its name and constructor function.
      addHandler: function(t, e) {
        if (!e)
          return this;
        var n = this[t] = new e(this);
        return this._handlers.push(n), this.options[t] && n.enable(), this;
      },
      // @method remove(): this
      // Destroys the map and clears all related event listeners.
      remove: function() {
        if (this._initEvents(!0), this.options.maxBounds && this.off("moveend", this._panInsideMaxBounds), this._containerId !== this._container._leaflet_id)
          throw new Error("Map container is being reused by another instance");
        try {
          delete this._container._leaflet_id, delete this._containerId;
        } catch {
          this._container._leaflet_id = void 0, this._containerId = void 0;
        }
        this._locationWatchId !== void 0 && this.stopLocate(), this._stop(), $(this._mapPane), this._clearControlPos && this._clearControlPos(), this._resizeRequest && (xt(this._resizeRequest), this._resizeRequest = null), this._clearHandlers(), this._loaded && this.fire("unload");
        var t;
        for (t in this._layers)
          this._layers[t].remove();
        for (t in this._panes)
          $(this._panes[t]);
        return this._layers = [], this._panes = [], delete this._mapPane, delete this._renderer, this;
      },
      // @section Other Methods
      // @method createPane(name: String, container?: HTMLElement): HTMLElement
      // Creates a new [map pane](#map-pane) with the given name if it doesn't exist already,
      // then returns it. The pane is created as a child of `container`, or
      // as a child of the main map pane if not set.
      createPane: function(t, e) {
        var n = "leaflet-pane" + (t ? " leaflet-" + t.replace("Pane", "") + "-pane" : ""), o = B("div", n, e || this._mapPane);
        return t && (this._panes[t] = o), o;
      },
      // @section Methods for Getting Map State
      // @method getCenter(): LatLng
      // Returns the geographical center of the map view
      getCenter: function() {
        return this._checkIfLoaded(), this._lastCenter && !this._moved() ? this._lastCenter.clone() : this.layerPointToLatLng(this._getCenterLayerPoint());
      },
      // @method getZoom(): Number
      // Returns the current zoom level of the map view
      getZoom: function() {
        return this._zoom;
      },
      // @method getBounds(): LatLngBounds
      // Returns the geographical bounds visible in the current map view
      getBounds: function() {
        var t = this.getPixelBounds(), e = this.unproject(t.getBottomLeft()), n = this.unproject(t.getTopRight());
        return new _t(e, n);
      },
      // @method getMinZoom(): Number
      // Returns the minimum zoom level of the map (if set in the `minZoom` option of the map or of any layers), or `0` by default.
      getMinZoom: function() {
        return this.options.minZoom === void 0 ? this._layersMinZoom || 0 : this.options.minZoom;
      },
      // @method getMaxZoom(): Number
      // Returns the maximum zoom level of the map (if set in the `maxZoom` option of the map or of any layers).
      getMaxZoom: function() {
        return this.options.maxZoom === void 0 ? this._layersMaxZoom === void 0 ? 1 / 0 : this._layersMaxZoom : this.options.maxZoom;
      },
      // @method getBoundsZoom(bounds: LatLngBounds, inside?: Boolean, padding?: Point): Number
      // Returns the maximum zoom level on which the given bounds fit to the map
      // view in its entirety. If `inside` (optional) is set to `true`, the method
      // instead returns the minimum zoom level on which the map view fits into
      // the given bounds in its entirety.
      getBoundsZoom: function(t, e, n) {
        t = et(t), n = S(n || [0, 0]);
        var o = this.getZoom() || 0, h = this.getMinZoom(), l = this.getMaxZoom(), f = t.getNorthWest(), _ = t.getSouthEast(), m = this.getSize().subtract(n), p = dt(this.project(_, o), this.project(f, o)).getSize(), x = M.any3d ? this.options.zoomSnap : 1, T = m.x / p.x, z = m.y / p.y, ct = e ? Math.max(T, z) : Math.min(T, z);
        return o = this.getScaleZoom(ct, o), x && (o = Math.round(o / (x / 100)) * (x / 100), o = e ? Math.ceil(o / x) * x : Math.floor(o / x) * x), Math.max(h, Math.min(l, o));
      },
      // @method getSize(): Point
      // Returns the current size of the map container (in pixels).
      getSize: function() {
        return (!this._size || this._sizeChanged) && (this._size = new O(
          this._container.clientWidth || 0,
          this._container.clientHeight || 0
        ), this._sizeChanged = !1), this._size.clone();
      },
      // @method getPixelBounds(): Bounds
      // Returns the bounds of the current map view in projected pixel
      // coordinates (sometimes useful in layer and overlay implementations).
      getPixelBounds: function(t, e) {
        var n = this._getTopLeftPoint(t, e);
        return new J(n, n.add(this.getSize()));
      },
      // TODO: Check semantics - isn't the pixel origin the 0,0 coord relative to
      // the map pane? "left point of the map layer" can be confusing, specially
      // since there can be negative offsets.
      // @method getPixelOrigin(): Point
      // Returns the projected pixel coordinates of the top left point of
      // the map layer (useful in custom layer and overlay implementations).
      getPixelOrigin: function() {
        return this._checkIfLoaded(), this._pixelOrigin;
      },
      // @method getPixelWorldBounds(zoom?: Number): Bounds
      // Returns the world's bounds in pixel coordinates for zoom level `zoom`.
      // If `zoom` is omitted, the map's current zoom level is used.
      getPixelWorldBounds: function(t) {
        return this.options.crs.getProjectedBounds(t === void 0 ? this.getZoom() : t);
      },
      // @section Other Methods
      // @method getPane(pane: String|HTMLElement): HTMLElement
      // Returns a [map pane](#map-pane), given its name or its HTML element (its identity).
      getPane: function(t) {
        return typeof t == "string" ? this._panes[t] : t;
      },
      // @method getPanes(): Object
      // Returns a plain object containing the names of all [panes](#map-pane) as keys and
      // the panes as values.
      getPanes: function() {
        return this._panes;
      },
      // @method getContainer: HTMLElement
      // Returns the HTML element that contains the map.
      getContainer: function() {
        return this._container;
      },
      // @section Conversion Methods
      // @method getZoomScale(toZoom: Number, fromZoom: Number): Number
      // Returns the scale factor to be applied to a map transition from zoom level
      // `fromZoom` to `toZoom`. Used internally to help with zoom animations.
      getZoomScale: function(t, e) {
        var n = this.options.crs;
        return e = e === void 0 ? this._zoom : e, n.scale(t) / n.scale(e);
      },
      // @method getScaleZoom(scale: Number, fromZoom: Number): Number
      // Returns the zoom level that the map would end up at, if it is at `fromZoom`
      // level and everything is scaled by a factor of `scale`. Inverse of
      // [`getZoomScale`](#map-getZoomScale).
      getScaleZoom: function(t, e) {
        var n = this.options.crs;
        e = e === void 0 ? this._zoom : e;
        var o = n.zoom(t * n.scale(e));
        return isNaN(o) ? 1 / 0 : o;
      },
      // @method project(latlng: LatLng, zoom: Number): Point
      // Projects a geographical coordinate `LatLng` according to the projection
      // of the map's CRS, then scales it according to `zoom` and the CRS's
      // `Transformation`. The result is pixel coordinate relative to
      // the CRS origin.
      project: function(t, e) {
        return e = e === void 0 ? this._zoom : e, this.options.crs.latLngToPoint(N(t), e);
      },
      // @method unproject(point: Point, zoom: Number): LatLng
      // Inverse of [`project`](#map-project).
      unproject: function(t, e) {
        return e = e === void 0 ? this._zoom : e, this.options.crs.pointToLatLng(S(t), e);
      },
      // @method layerPointToLatLng(point: Point): LatLng
      // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
      // returns the corresponding geographical coordinate (for the current zoom level).
      layerPointToLatLng: function(t) {
        var e = S(t).add(this.getPixelOrigin());
        return this.unproject(e);
      },
      // @method latLngToLayerPoint(latlng: LatLng): Point
      // Given a geographical coordinate, returns the corresponding pixel coordinate
      // relative to the [origin pixel](#map-getpixelorigin).
      latLngToLayerPoint: function(t) {
        var e = this.project(N(t))._round();
        return e._subtract(this.getPixelOrigin());
      },
      // @method wrapLatLng(latlng: LatLng): LatLng
      // Returns a `LatLng` where `lat` and `lng` has been wrapped according to the
      // map's CRS's `wrapLat` and `wrapLng` properties, if they are outside the
      // CRS's bounds.
      // By default this means longitude is wrapped around the dateline so its
      // value is between -180 and +180 degrees.
      wrapLatLng: function(t) {
        return this.options.crs.wrapLatLng(N(t));
      },
      // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
      // Returns a `LatLngBounds` with the same size as the given one, ensuring that
      // its center is within the CRS's bounds.
      // By default this means the center longitude is wrapped around the dateline so its
      // value is between -180 and +180 degrees, and the majority of the bounds
      // overlaps the CRS's bounds.
      wrapLatLngBounds: function(t) {
        return this.options.crs.wrapLatLngBounds(et(t));
      },
      // @method distance(latlng1: LatLng, latlng2: LatLng): Number
      // Returns the distance between two geographical coordinates according to
      // the map's CRS. By default this measures distance in meters.
      distance: function(t, e) {
        return this.options.crs.distance(N(t), N(e));
      },
      // @method containerPointToLayerPoint(point: Point): Point
      // Given a pixel coordinate relative to the map container, returns the corresponding
      // pixel coordinate relative to the [origin pixel](#map-getpixelorigin).
      containerPointToLayerPoint: function(t) {
        return S(t).subtract(this._getMapPanePos());
      },
      // @method layerPointToContainerPoint(point: Point): Point
      // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
      // returns the corresponding pixel coordinate relative to the map container.
      layerPointToContainerPoint: function(t) {
        return S(t).add(this._getMapPanePos());
      },
      // @method containerPointToLatLng(point: Point): LatLng
      // Given a pixel coordinate relative to the map container, returns
      // the corresponding geographical coordinate (for the current zoom level).
      containerPointToLatLng: function(t) {
        var e = this.containerPointToLayerPoint(S(t));
        return this.layerPointToLatLng(e);
      },
      // @method latLngToContainerPoint(latlng: LatLng): Point
      // Given a geographical coordinate, returns the corresponding pixel coordinate
      // relative to the map container.
      latLngToContainerPoint: function(t) {
        return this.layerPointToContainerPoint(this.latLngToLayerPoint(N(t)));
      },
      // @method mouseEventToContainerPoint(ev: MouseEvent): Point
      // Given a MouseEvent object, returns the pixel coordinate relative to the
      // map container where the event took place.
      mouseEventToContainerPoint: function(t) {
        return ur(t, this._container);
      },
      // @method mouseEventToLayerPoint(ev: MouseEvent): Point
      // Given a MouseEvent object, returns the pixel coordinate relative to
      // the [origin pixel](#map-getpixelorigin) where the event took place.
      mouseEventToLayerPoint: function(t) {
        return this.containerPointToLayerPoint(this.mouseEventToContainerPoint(t));
      },
      // @method mouseEventToLatLng(ev: MouseEvent): LatLng
      // Given a MouseEvent object, returns geographical coordinate where the
      // event took place.
      mouseEventToLatLng: function(t) {
        return this.layerPointToLatLng(this.mouseEventToLayerPoint(t));
      },
      // map initialization methods
      _initContainer: function(t) {
        var e = this._container = rr(t);
        if (e) {
          if (e._leaflet_id)
            throw new Error("Map container is already initialized.");
        } else
          throw new Error("Map container not found.");
        C(e, "scroll", this._onScroll, this), this._containerId = g(e);
      },
      _initLayout: function() {
        var t = this._container;
        this._fadeAnimated = this.options.fadeAnimation && M.any3d, A(t, "leaflet-container" + (M.touch ? " leaflet-touch" : "") + (M.retina ? " leaflet-retina" : "") + (M.ielt9 ? " leaflet-oldie" : "") + (M.safari ? " leaflet-safari" : "") + (this._fadeAnimated ? " leaflet-fade-anim" : ""));
        var e = Ge(t, "position");
        e !== "absolute" && e !== "relative" && e !== "fixed" && e !== "sticky" && (t.style.position = "relative"), this._initPanes(), this._initControlPos && this._initControlPos();
      },
      _initPanes: function() {
        var t = this._panes = {};
        this._paneRenderers = {}, this._mapPane = this.createPane("mapPane", this._container), it(this._mapPane, new O(0, 0)), this.createPane("tilePane"), this.createPane("overlayPane"), this.createPane("shadowPane"), this.createPane("markerPane"), this.createPane("tooltipPane"), this.createPane("popupPane"), this.options.markerZoomAnimation || (A(t.markerPane, "leaflet-zoom-hide"), A(t.shadowPane, "leaflet-zoom-hide"));
      },
      // private methods that modify map state
      // @section Map state change events
      _resetView: function(t, e, n) {
        it(this._mapPane, new O(0, 0));
        var o = !this._loaded;
        this._loaded = !0, e = this._limitZoom(e), this.fire("viewprereset");
        var h = this._zoom !== e;
        this._moveStart(h, n)._move(t, e)._moveEnd(h), this.fire("viewreset"), o && this.fire("load");
      },
      _moveStart: function(t, e) {
        return t && this.fire("zoomstart"), e || this.fire("movestart"), this;
      },
      _move: function(t, e, n, o) {
        e === void 0 && (e = this._zoom);
        var h = this._zoom !== e;
        return this._zoom = e, this._lastCenter = t, this._pixelOrigin = this._getNewPixelOrigin(t), o ? n && n.pinch && this.fire("zoom", n) : ((h || n && n.pinch) && this.fire("zoom", n), this.fire("move", n)), this;
      },
      _moveEnd: function(t) {
        return t && this.fire("zoomend"), this.fire("moveend");
      },
      _stop: function() {
        return xt(this._flyToFrame), this._panAnim && this._panAnim.stop(), this;
      },
      _rawPanBy: function(t) {
        it(this._mapPane, this._getMapPanePos().subtract(t));
      },
      _getZoomSpan: function() {
        return this.getMaxZoom() - this.getMinZoom();
      },
      _panInsideMaxBounds: function() {
        this._enforcingBounds || this.panInsideBounds(this.options.maxBounds);
      },
      _checkIfLoaded: function() {
        if (!this._loaded)
          throw new Error("Set map center and zoom first.");
      },
      // DOM event handling
      // @section Interaction events
      _initEvents: function(t) {
        this._targets = {}, this._targets[g(this._container)] = this;
        var e = t ? j : C;
        e(this._container, "click dblclick mousedown mouseup mouseover mouseout mousemove contextmenu keypress keydown keyup", this._handleDOMEvent, this), this.options.trackResize && e(window, "resize", this._onResize, this), M.any3d && this.options.transform3DLimit && (t ? this.off : this.on).call(this, "moveend", this._onMoveEnd);
      },
      _onResize: function() {
        xt(this._resizeRequest), this._resizeRequest = ft(
          function() {
            this.invalidateSize({ debounceMoveend: !0 });
          },
          this
        );
      },
      _onScroll: function() {
        this._container.scrollTop = 0, this._container.scrollLeft = 0;
      },
      _onMoveEnd: function() {
        var t = this._getMapPanePos();
        Math.max(Math.abs(t.x), Math.abs(t.y)) >= this.options.transform3DLimit && this._resetView(this.getCenter(), this.getZoom());
      },
      _findEventTargets: function(t, e) {
        for (var n = [], o, h = e === "mouseout" || e === "mouseover", l = t.target || t.srcElement, f = !1; l; ) {
          if (o = this._targets[g(l)], o && (e === "click" || e === "preclick") && this._draggableMoved(o)) {
            f = !0;
            break;
          }
          if (o && o.listens(e, !0) && (h && !Nn(l, t) || (n.push(o), h)) || l === this._container)
            break;
          l = l.parentNode;
        }
        return !n.length && !f && !h && this.listens(e, !0) && (n = [this]), n;
      },
      _isClickDisabled: function(t) {
        for (; t && t !== this._container; ) {
          if (t._leaflet_disable_click)
            return !0;
          t = t.parentNode;
        }
      },
      _handleDOMEvent: function(t) {
        var e = t.target || t.srcElement;
        if (!(!this._loaded || e._leaflet_disable_events || t.type === "click" && this._isClickDisabled(e))) {
          var n = t.type;
          n === "mousedown" && Cn(e), this._fireDOMEvent(t, n);
        }
      },
      _mouseEvents: ["click", "dblclick", "mouseover", "mouseout", "contextmenu"],
      _fireDOMEvent: function(t, e, n) {
        if (t.type === "click") {
          var o = u({}, t);
          o.type = "preclick", this._fireDOMEvent(o, o.type, n);
        }
        var h = this._findEventTargets(t, e);
        if (n) {
          for (var l = [], f = 0; f < n.length; f++)
            n[f].listens(e, !0) && l.push(n[f]);
          h = l.concat(h);
        }
        if (h.length) {
          e === "contextmenu" && at(t);
          var _ = h[0], m = {
            originalEvent: t
          };
          if (t.type !== "keypress" && t.type !== "keydown" && t.type !== "keyup") {
            var p = _.getLatLng && (!_._radius || _._radius <= 10);
            m.containerPoint = p ? this.latLngToContainerPoint(_.getLatLng()) : this.mouseEventToContainerPoint(t), m.layerPoint = this.containerPointToLayerPoint(m.containerPoint), m.latlng = p ? _.getLatLng() : this.layerPointToLatLng(m.layerPoint);
          }
          for (f = 0; f < h.length; f++)
            if (h[f].fire(e, m, !0), m.originalEvent._stopped || h[f].options.bubblingMouseEvents === !1 && cn(this._mouseEvents, e) !== -1)
              return;
        }
      },
      _draggableMoved: function(t) {
        return t = t.dragging && t.dragging.enabled() ? t : this, t.dragging && t.dragging.moved() || this.boxZoom && this.boxZoom.moved();
      },
      _clearHandlers: function() {
        for (var t = 0, e = this._handlers.length; t < e; t++)
          this._handlers[t].disable();
      },
      // @section Other Methods
      // @method whenReady(fn: Function, context?: Object): this
      // Runs the given function `fn` when the map gets initialized with
      // a view (center and zoom) and at least one layer, or immediately
      // if it's already initialized, optionally passing a function context.
      whenReady: function(t, e) {
        return this._loaded ? t.call(e || this, { target: this }) : this.on("load", t, e), this;
      },
      // private methods for getting map state
      _getMapPanePos: function() {
        return fe(this._mapPane) || new O(0, 0);
      },
      _moved: function() {
        var t = this._getMapPanePos();
        return t && !t.equals([0, 0]);
      },
      _getTopLeftPoint: function(t, e) {
        var n = t && e !== void 0 ? this._getNewPixelOrigin(t, e) : this.getPixelOrigin();
        return n.subtract(this._getMapPanePos());
      },
      _getNewPixelOrigin: function(t, e) {
        var n = this.getSize()._divideBy(2);
        return this.project(t, e)._subtract(n)._add(this._getMapPanePos())._round();
      },
      _latLngToNewLayerPoint: function(t, e, n) {
        var o = this._getNewPixelOrigin(n, e);
        return this.project(t, e)._subtract(o);
      },
      _latLngBoundsToNewLayerBounds: function(t, e, n) {
        var o = this._getNewPixelOrigin(n, e);
        return dt([
          this.project(t.getSouthWest(), e)._subtract(o),
          this.project(t.getNorthWest(), e)._subtract(o),
          this.project(t.getSouthEast(), e)._subtract(o),
          this.project(t.getNorthEast(), e)._subtract(o)
        ]);
      },
      // layer point of the current center
      _getCenterLayerPoint: function() {
        return this.containerPointToLayerPoint(this.getSize()._divideBy(2));
      },
      // offset of the specified place to the current center in pixels
      _getCenterOffset: function(t) {
        return this.latLngToLayerPoint(t).subtract(this._getCenterLayerPoint());
      },
      // adjust center for view to get inside bounds
      _limitCenter: function(t, e, n) {
        if (!n)
          return t;
        var o = this.project(t, e), h = this.getSize().divideBy(2), l = new J(o.subtract(h), o.add(h)), f = this._getBoundsOffset(l, n, e);
        return Math.abs(f.x) <= 1 && Math.abs(f.y) <= 1 ? t : this.unproject(o.add(f), e);
      },
      // adjust offset for view to get inside bounds
      _limitOffset: function(t, e) {
        if (!e)
          return t;
        var n = this.getPixelBounds(), o = new J(n.min.add(t), n.max.add(t));
        return t.add(this._getBoundsOffset(o, e));
      },
      // returns offset needed for pxBounds to get inside maxBounds at a specified zoom
      _getBoundsOffset: function(t, e, n) {
        var o = dt(
          this.project(e.getNorthEast(), n),
          this.project(e.getSouthWest(), n)
        ), h = o.min.subtract(t.min), l = o.max.subtract(t.max), f = this._rebound(h.x, -l.x), _ = this._rebound(h.y, -l.y);
        return new O(f, _);
      },
      _rebound: function(t, e) {
        return t + e > 0 ? Math.round(t - e) / 2 : Math.max(0, Math.ceil(t)) - Math.max(0, Math.floor(e));
      },
      _limitZoom: function(t) {
        var e = this.getMinZoom(), n = this.getMaxZoom(), o = M.any3d ? this.options.zoomSnap : 1;
        return o && (t = Math.round(t / o) * o), Math.max(e, Math.min(n, t));
      },
      _onPanTransitionStep: function() {
        this.fire("move");
      },
      _onPanTransitionEnd: function() {
        Q(this._mapPane, "leaflet-pan-anim"), this.fire("moveend");
      },
      _tryAnimatedPan: function(t, e) {
        var n = this._getCenterOffset(t)._trunc();
        return (e && e.animate) !== !0 && !this.getSize().contains(n) ? !1 : (this.panBy(n, e), !0);
      },
      _createAnimProxy: function() {
        var t = this._proxy = B("div", "leaflet-proxy leaflet-zoom-animated");
        this._panes.mapPane.appendChild(t), this.on("zoomanim", function(e) {
          var n = Ln, o = this._proxy.style[n];
          ce(this._proxy, this.project(e.center, e.zoom), this.getZoomScale(e.zoom, 1)), o === this._proxy.style[n] && this._animatingZoom && this._onZoomTransitionEnd();
        }, this), this.on("load moveend", this._animMoveEnd, this), this._on("unload", this._destroyAnimProxy, this);
      },
      _destroyAnimProxy: function() {
        $(this._proxy), this.off("load moveend", this._animMoveEnd, this), delete this._proxy;
      },
      _animMoveEnd: function() {
        var t = this.getCenter(), e = this.getZoom();
        ce(this._proxy, this.project(t, e), this.getZoomScale(e, 1));
      },
      _catchTransitionEnd: function(t) {
        this._animatingZoom && t.propertyName.indexOf("transform") >= 0 && this._onZoomTransitionEnd();
      },
      _nothingToAnimate: function() {
        return !this._container.getElementsByClassName("leaflet-zoom-animated").length;
      },
      _tryAnimatedZoom: function(t, e, n) {
        if (this._animatingZoom)
          return !0;
        if (n = n || {}, !this._zoomAnimated || n.animate === !1 || this._nothingToAnimate() || Math.abs(e - this._zoom) > this.options.zoomAnimationThreshold)
          return !1;
        var o = this.getZoomScale(e), h = this._getCenterOffset(t)._divideBy(1 - 1 / o);
        return n.animate !== !0 && !this.getSize().contains(h) ? !1 : (ft(function() {
          this._moveStart(!0, n.noMoveStart || !1)._animateZoom(t, e, !0);
        }, this), !0);
      },
      _animateZoom: function(t, e, n, o) {
        this._mapPane && (n && (this._animatingZoom = !0, this._animateToCenter = t, this._animateToZoom = e, A(this._mapPane, "leaflet-zoom-anim")), this.fire("zoomanim", {
          center: t,
          zoom: e,
          noUpdate: o
        }), this._tempFireZoomEvent || (this._tempFireZoomEvent = this._zoom !== this._animateToZoom), this._move(this._animateToCenter, this._animateToZoom, void 0, !0), setTimeout(d(this._onZoomTransitionEnd, this), 250));
      },
      _onZoomTransitionEnd: function() {
        this._animatingZoom && (this._mapPane && Q(this._mapPane, "leaflet-zoom-anim"), this._animatingZoom = !1, this._move(this._animateToCenter, this._animateToZoom, void 0, !0), this._tempFireZoomEvent && this.fire("zoom"), delete this._tempFireZoomEvent, this.fire("move"), this._moveEnd(!0));
      }
    });
    function Ya(t, e) {
      return new R(t, e);
    }
    var Ot = Ut.extend({
      // @section
      // @aka Control Options
      options: {
        // @option position: String = 'topright'
        // The position of the control (one of the map corners). Possible values are `'topleft'`,
        // `'topright'`, `'bottomleft'` or `'bottomright'`
        position: "topright"
      },
      initialize: function(t) {
        U(this, t);
      },
      /* @section
       * Classes extending L.Control will inherit the following methods:
       *
       * @method getPosition: string
       * Returns the position of the control.
       */
      getPosition: function() {
        return this.options.position;
      },
      // @method setPosition(position: string): this
      // Sets the position of the control.
      setPosition: function(t) {
        var e = this._map;
        return e && e.removeControl(this), this.options.position = t, e && e.addControl(this), this;
      },
      // @method getContainer: HTMLElement
      // Returns the HTMLElement that contains the control.
      getContainer: function() {
        return this._container;
      },
      // @method addTo(map: Map): this
      // Adds the control to the given map.
      addTo: function(t) {
        this.remove(), this._map = t;
        var e = this._container = this.onAdd(t), n = this.getPosition(), o = t._controlCorners[n];
        return A(e, "leaflet-control"), n.indexOf("bottom") !== -1 ? o.insertBefore(e, o.firstChild) : o.appendChild(e), this._map.on("unload", this.remove, this), this;
      },
      // @method remove: this
      // Removes the control from the map it is currently active on.
      remove: function() {
        return this._map ? ($(this._container), this.onRemove && this.onRemove(this._map), this._map.off("unload", this.remove, this), this._map = null, this) : this;
      },
      _refocusOnMap: function(t) {
        this._map && t && t.screenX > 0 && t.screenY > 0 && this._map.getContainer().focus();
      }
    }), Xe = function(t) {
      return new Ot(t);
    };
    R.include({
      // @method addControl(control: Control): this
      // Adds the given control to the map
      addControl: function(t) {
        return t.addTo(this), this;
      },
      // @method removeControl(control: Control): this
      // Removes the given control from the map
      removeControl: function(t) {
        return t.remove(), this;
      },
      _initControlPos: function() {
        var t = this._controlCorners = {}, e = "leaflet-", n = this._controlContainer = B("div", e + "control-container", this._container);
        function o(h, l) {
          var f = e + h + " " + e + l;
          t[h + l] = B("div", f, n);
        }
        o("top", "left"), o("top", "right"), o("bottom", "left"), o("bottom", "right");
      },
      _clearControlPos: function() {
        for (var t in this._controlCorners)
          $(this._controlCorners[t]);
        $(this._controlContainer), delete this._controlCorners, delete this._controlContainer;
      }
    });
    var fr = Ot.extend({
      // @section
      // @aka Control.Layers options
      options: {
        // @option collapsed: Boolean = true
        // If `true`, the control will be collapsed into an icon and expanded on mouse hover, touch, or keyboard activation.
        collapsed: !0,
        position: "topright",
        // @option autoZIndex: Boolean = true
        // If `true`, the control will assign zIndexes in increasing order to all of its layers so that the order is preserved when switching them on/off.
        autoZIndex: !0,
        // @option hideSingleBase: Boolean = false
        // If `true`, the base layers in the control will be hidden when there is only one.
        hideSingleBase: !1,
        // @option sortLayers: Boolean = false
        // Whether to sort the layers. When `false`, layers will keep the order
        // in which they were added to the control.
        sortLayers: !1,
        // @option sortFunction: Function = *
        // A [compare function](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/sort)
        // that will be used for sorting the layers, when `sortLayers` is `true`.
        // The function receives both the `L.Layer` instances and their names, as in
        // `sortFunction(layerA, layerB, nameA, nameB)`.
        // By default, it sorts layers alphabetically by their name.
        sortFunction: function(t, e, n, o) {
          return n < o ? -1 : o < n ? 1 : 0;
        }
      },
      initialize: function(t, e, n) {
        U(this, n), this._layerControlInputs = [], this._layers = [], this._lastZIndex = 0, this._handlingClick = !1, this._preventClick = !1;
        for (var o in t)
          this._addLayer(t[o], o);
        for (o in e)
          this._addLayer(e[o], o, !0);
      },
      onAdd: function(t) {
        this._initLayout(), this._update(), this._map = t, t.on("zoomend", this._checkDisabledLayers, this);
        for (var e = 0; e < this._layers.length; e++)
          this._layers[e].layer.on("add remove", this._onLayerChange, this);
        return this._container;
      },
      addTo: function(t) {
        return Ot.prototype.addTo.call(this, t), this._expandIfNotCollapsed();
      },
      onRemove: function() {
        this._map.off("zoomend", this._checkDisabledLayers, this);
        for (var t = 0; t < this._layers.length; t++)
          this._layers[t].layer.off("add remove", this._onLayerChange, this);
      },
      // @method addBaseLayer(layer: Layer, name: String): this
      // Adds a base layer (radio button entry) with the given name to the control.
      addBaseLayer: function(t, e) {
        return this._addLayer(t, e), this._map ? this._update() : this;
      },
      // @method addOverlay(layer: Layer, name: String): this
      // Adds an overlay (checkbox entry) with the given name to the control.
      addOverlay: function(t, e) {
        return this._addLayer(t, e, !0), this._map ? this._update() : this;
      },
      // @method removeLayer(layer: Layer): this
      // Remove the given layer from the control.
      removeLayer: function(t) {
        t.off("add remove", this._onLayerChange, this);
        var e = this._getLayer(g(t));
        return e && this._layers.splice(this._layers.indexOf(e), 1), this._map ? this._update() : this;
      },
      // @method expand(): this
      // Expand the control container if collapsed.
      expand: function() {
        A(this._container, "leaflet-control-layers-expanded"), this._section.style.height = null;
        var t = this._map.getSize().y - (this._container.offsetTop + 50);
        return t < this._section.clientHeight ? (A(this._section, "leaflet-control-layers-scrollbar"), this._section.style.height = t + "px") : Q(this._section, "leaflet-control-layers-scrollbar"), this._checkDisabledLayers(), this;
      },
      // @method collapse(): this
      // Collapse the control container if expanded.
      collapse: function() {
        return Q(this._container, "leaflet-control-layers-expanded"), this;
      },
      _initLayout: function() {
        var t = "leaflet-control-layers", e = this._container = B("div", t), n = this.options.collapsed;
        e.setAttribute("aria-haspopup", !0), Ke(e), In(e);
        var o = this._section = B("section", t + "-list");
        n && (this._map.on("click", this.collapse, this), C(e, {
          mouseenter: this._expandSafely,
          mouseleave: this.collapse
        }, this));
        var h = this._layersLink = B("a", t + "-toggle", e);
        h.href = "#", h.title = "Layers", h.setAttribute("role", "button"), C(h, {
          keydown: function(l) {
            l.keyCode === 13 && this._expandSafely();
          },
          // Certain screen readers intercept the key event and instead send a click event
          click: function(l) {
            at(l), this._expandSafely();
          }
        }, this), n || this.expand(), this._baseLayersList = B("div", t + "-base", o), this._separator = B("div", t + "-separator", o), this._overlaysList = B("div", t + "-overlays", o), e.appendChild(o);
      },
      _getLayer: function(t) {
        for (var e = 0; e < this._layers.length; e++)
          if (this._layers[e] && g(this._layers[e].layer) === t)
            return this._layers[e];
      },
      _addLayer: function(t, e, n) {
        this._map && t.on("add remove", this._onLayerChange, this), this._layers.push({
          layer: t,
          name: e,
          overlay: n
        }), this.options.sortLayers && this._layers.sort(d(function(o, h) {
          return this.options.sortFunction(o.layer, h.layer, o.name, h.name);
        }, this)), this.options.autoZIndex && t.setZIndex && (this._lastZIndex++, t.setZIndex(this._lastZIndex)), this._expandIfNotCollapsed();
      },
      _update: function() {
        if (!this._container)
          return this;
        yi(this._baseLayersList), yi(this._overlaysList), this._layerControlInputs = [];
        var t, e, n, o, h = 0;
        for (n = 0; n < this._layers.length; n++)
          o = this._layers[n], this._addItem(o), e = e || o.overlay, t = t || !o.overlay, h += o.overlay ? 0 : 1;
        return this.options.hideSingleBase && (t = t && h > 1, this._baseLayersList.style.display = t ? "" : "none"), this._separator.style.display = e && t ? "" : "none", this;
      },
      _onLayerChange: function(t) {
        this._handlingClick || this._update();
        var e = this._getLayer(g(t.target)), n = e.overlay ? t.type === "add" ? "overlayadd" : "overlayremove" : t.type === "add" ? "baselayerchange" : null;
        n && this._map.fire(n, e);
      },
      // IE7 bugs out if you create a radio dynamically, so you have to do it this hacky way (see https://stackoverflow.com/a/119079)
      _createRadioElement: function(t, e) {
        var n = '<input type="radio" class="leaflet-control-layers-selector" name="' + t + '"' + (e ? ' checked="checked"' : "") + "/>", o = document.createElement("div");
        return o.innerHTML = n, o.firstChild;
      },
      _addItem: function(t) {
        var e = document.createElement("label"), n = this._map.hasLayer(t.layer), o;
        t.overlay ? (o = document.createElement("input"), o.type = "checkbox", o.className = "leaflet-control-layers-selector", o.defaultChecked = n) : o = this._createRadioElement("leaflet-base-layers_" + g(this), n), this._layerControlInputs.push(o), o.layerId = g(t.layer), C(o, "click", this._onInputClick, this);
        var h = document.createElement("span");
        h.innerHTML = " " + t.name;
        var l = document.createElement("span");
        e.appendChild(l), l.appendChild(o), l.appendChild(h);
        var f = t.overlay ? this._overlaysList : this._baseLayersList;
        return f.appendChild(e), this._checkDisabledLayers(), e;
      },
      _onInputClick: function() {
        if (!this._preventClick) {
          var t = this._layerControlInputs, e, n, o = [], h = [];
          this._handlingClick = !0;
          for (var l = t.length - 1; l >= 0; l--)
            e = t[l], n = this._getLayer(e.layerId).layer, e.checked ? o.push(n) : e.checked || h.push(n);
          for (l = 0; l < h.length; l++)
            this._map.hasLayer(h[l]) && this._map.removeLayer(h[l]);
          for (l = 0; l < o.length; l++)
            this._map.hasLayer(o[l]) || this._map.addLayer(o[l]);
          this._handlingClick = !1, this._refocusOnMap();
        }
      },
      _checkDisabledLayers: function() {
        for (var t = this._layerControlInputs, e, n, o = this._map.getZoom(), h = t.length - 1; h >= 0; h--)
          e = t[h], n = this._getLayer(e.layerId).layer, e.disabled = n.options.minZoom !== void 0 && o < n.options.minZoom || n.options.maxZoom !== void 0 && o > n.options.maxZoom;
      },
      _expandIfNotCollapsed: function() {
        return this._map && !this.options.collapsed && this.expand(), this;
      },
      _expandSafely: function() {
        var t = this._section;
        this._preventClick = !0, C(t, "click", at), this.expand();
        var e = this;
        setTimeout(function() {
          j(t, "click", at), e._preventClick = !1;
        });
      }
    }), Wa = function(t, e, n) {
      return new fr(t, e, n);
    }, Rn = Ot.extend({
      // @section
      // @aka Control.Zoom options
      options: {
        position: "topleft",
        // @option zoomInText: String = '<span aria-hidden="true">+</span>'
        // The text set on the 'zoom in' button.
        zoomInText: '<span aria-hidden="true">+</span>',
        // @option zoomInTitle: String = 'Zoom in'
        // The title set on the 'zoom in' button.
        zoomInTitle: "Zoom in",
        // @option zoomOutText: String = '<span aria-hidden="true">&#x2212;</span>'
        // The text set on the 'zoom out' button.
        zoomOutText: '<span aria-hidden="true">&#x2212;</span>',
        // @option zoomOutTitle: String = 'Zoom out'
        // The title set on the 'zoom out' button.
        zoomOutTitle: "Zoom out"
      },
      onAdd: function(t) {
        var e = "leaflet-control-zoom", n = B("div", e + " leaflet-bar"), o = this.options;
        return this._zoomInButton = this._createButton(
          o.zoomInText,
          o.zoomInTitle,
          e + "-in",
          n,
          this._zoomIn
        ), this._zoomOutButton = this._createButton(
          o.zoomOutText,
          o.zoomOutTitle,
          e + "-out",
          n,
          this._zoomOut
        ), this._updateDisabled(), t.on("zoomend zoomlevelschange", this._updateDisabled, this), n;
      },
      onRemove: function(t) {
        t.off("zoomend zoomlevelschange", this._updateDisabled, this);
      },
      disable: function() {
        return this._disabled = !0, this._updateDisabled(), this;
      },
      enable: function() {
        return this._disabled = !1, this._updateDisabled(), this;
      },
      _zoomIn: function(t) {
        !this._disabled && this._map._zoom < this._map.getMaxZoom() && this._map.zoomIn(this._map.options.zoomDelta * (t.shiftKey ? 3 : 1));
      },
      _zoomOut: function(t) {
        !this._disabled && this._map._zoom > this._map.getMinZoom() && this._map.zoomOut(this._map.options.zoomDelta * (t.shiftKey ? 3 : 1));
      },
      _createButton: function(t, e, n, o, h) {
        var l = B("a", n, o);
        return l.innerHTML = t, l.href = "#", l.title = e, l.setAttribute("role", "button"), l.setAttribute("aria-label", e), Ke(l), C(l, "click", _e), C(l, "click", h, this), C(l, "click", this._refocusOnMap, this), l;
      },
      _updateDisabled: function() {
        var t = this._map, e = "leaflet-disabled";
        Q(this._zoomInButton, e), Q(this._zoomOutButton, e), this._zoomInButton.setAttribute("aria-disabled", "false"), this._zoomOutButton.setAttribute("aria-disabled", "false"), (this._disabled || t._zoom === t.getMinZoom()) && (A(this._zoomOutButton, e), this._zoomOutButton.setAttribute("aria-disabled", "true")), (this._disabled || t._zoom === t.getMaxZoom()) && (A(this._zoomInButton, e), this._zoomInButton.setAttribute("aria-disabled", "true"));
      }
    });
    R.mergeOptions({
      zoomControl: !0
    }), R.addInitHook(function() {
      this.options.zoomControl && (this.zoomControl = new Rn(), this.addControl(this.zoomControl));
    });
    var Fa = function(t) {
      return new Rn(t);
    }, dr = Ot.extend({
      // @section
      // @aka Control.Scale options
      options: {
        position: "bottomleft",
        // @option maxWidth: Number = 100
        // Maximum width of the control in pixels. The width is set dynamically to show round values (e.g. 100, 200, 500).
        maxWidth: 100,
        // @option metric: Boolean = True
        // Whether to show the metric scale line (m/km).
        metric: !0,
        // @option imperial: Boolean = True
        // Whether to show the imperial scale line (mi/ft).
        imperial: !0
        // @option updateWhenIdle: Boolean = false
        // If `true`, the control is updated on [`moveend`](#map-moveend), otherwise it's always up-to-date (updated on [`move`](#map-move)).
      },
      onAdd: function(t) {
        var e = "leaflet-control-scale", n = B("div", e), o = this.options;
        return this._addScales(o, e + "-line", n), t.on(o.updateWhenIdle ? "moveend" : "move", this._update, this), t.whenReady(this._update, this), n;
      },
      onRemove: function(t) {
        t.off(this.options.updateWhenIdle ? "moveend" : "move", this._update, this);
      },
      _addScales: function(t, e, n) {
        t.metric && (this._mScale = B("div", e, n)), t.imperial && (this._iScale = B("div", e, n));
      },
      _update: function() {
        var t = this._map, e = t.getSize().y / 2, n = t.distance(
          t.containerPointToLatLng([0, e]),
          t.containerPointToLatLng([this.options.maxWidth, e])
        );
        this._updateScales(n);
      },
      _updateScales: function(t) {
        this.options.metric && t && this._updateMetric(t), this.options.imperial && t && this._updateImperial(t);
      },
      _updateMetric: function(t) {
        var e = this._getRoundNum(t), n = e < 1e3 ? e + " m" : e / 1e3 + " km";
        this._updateScale(this._mScale, n, e / t);
      },
      _updateImperial: function(t) {
        var e = t * 3.2808399, n, o, h;
        e > 5280 ? (n = e / 5280, o = this._getRoundNum(n), this._updateScale(this._iScale, o + " mi", o / n)) : (h = this._getRoundNum(e), this._updateScale(this._iScale, h + " ft", h / e));
      },
      _updateScale: function(t, e, n) {
        t.style.width = Math.round(this.options.maxWidth * n) + "px", t.innerHTML = e;
      },
      _getRoundNum: function(t) {
        var e = Math.pow(10, (Math.floor(t) + "").length - 1), n = t / e;
        return n = n >= 10 ? 10 : n >= 5 ? 5 : n >= 3 ? 3 : n >= 2 ? 2 : 1, e * n;
      }
    }), Ha = function(t) {
      return new dr(t);
    }, Ua = '<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" class="leaflet-attribution-flag"><path fill="#4C7BE1" d="M0 0h12v4H0z"/><path fill="#FFD500" d="M0 4h12v3H0z"/><path fill="#E0BC00" d="M0 7h12v1H0z"/></svg>', Zn = Ot.extend({
      // @section
      // @aka Control.Attribution options
      options: {
        position: "bottomright",
        // @option prefix: String|false = 'Leaflet'
        // The HTML text shown before the attributions. Pass `false` to disable.
        prefix: '<a href="https://leafletjs.com" title="A JavaScript library for interactive maps">' + (M.inlineSvg ? Ua + " " : "") + "Leaflet</a>"
      },
      initialize: function(t) {
        U(this, t), this._attributions = {};
      },
      onAdd: function(t) {
        t.attributionControl = this, this._container = B("div", "leaflet-control-attribution"), Ke(this._container);
        for (var e in t._layers)
          t._layers[e].getAttribution && this.addAttribution(t._layers[e].getAttribution());
        return this._update(), t.on("layeradd", this._addAttribution, this), this._container;
      },
      onRemove: function(t) {
        t.off("layeradd", this._addAttribution, this);
      },
      _addAttribution: function(t) {
        t.layer.getAttribution && (this.addAttribution(t.layer.getAttribution()), t.layer.once("remove", function() {
          this.removeAttribution(t.layer.getAttribution());
        }, this));
      },
      // @method setPrefix(prefix: String|false): this
      // The HTML text shown before the attributions. Pass `false` to disable.
      setPrefix: function(t) {
        return this.options.prefix = t, this._update(), this;
      },
      // @method addAttribution(text: String): this
      // Adds an attribution text (e.g. `'&copy; OpenStreetMap contributors'`).
      addAttribution: function(t) {
        return t ? (this._attributions[t] || (this._attributions[t] = 0), this._attributions[t]++, this._update(), this) : this;
      },
      // @method removeAttribution(text: String): this
      // Removes an attribution text.
      removeAttribution: function(t) {
        return t ? (this._attributions[t] && (this._attributions[t]--, this._update()), this) : this;
      },
      _update: function() {
        if (this._map) {
          var t = [];
          for (var e in this._attributions)
            this._attributions[e] && t.push(e);
          var n = [];
          this.options.prefix && n.push(this.options.prefix), t.length && n.push(t.join(", ")), this._container.innerHTML = n.join(' <span aria-hidden="true">|</span> ');
        }
      }
    });
    R.mergeOptions({
      attributionControl: !0
    }), R.addInitHook(function() {
      this.options.attributionControl && new Zn().addTo(this);
    });
    var Ga = function(t) {
      return new Zn(t);
    };
    Ot.Layers = fr, Ot.Zoom = Rn, Ot.Scale = dr, Ot.Attribution = Zn, Xe.layers = Wa, Xe.zoom = Fa, Xe.scale = Ha, Xe.attribution = Ga;
    var Zt = Ut.extend({
      initialize: function(t) {
        this._map = t;
      },
      // @method enable(): this
      // Enables the handler
      enable: function() {
        return this._enabled ? this : (this._enabled = !0, this.addHooks(), this);
      },
      // @method disable(): this
      // Disables the handler
      disable: function() {
        return this._enabled ? (this._enabled = !1, this.removeHooks(), this) : this;
      },
      // @method enabled(): Boolean
      // Returns `true` if the handler is enabled
      enabled: function() {
        return !!this._enabled;
      }
      // @section Extension methods
      // Classes inheriting from `Handler` must implement the two following methods:
      // @method addHooks()
      // Called when the handler is enabled, should add event hooks.
      // @method removeHooks()
      // Called when the handler is disabled, should remove the event hooks added previously.
    });
    Zt.addTo = function(t, e) {
      return t.addHandler(e, this), this;
    };
    var Va = { Events: gt }, _r = M.touch ? "touchstart mousedown" : "mousedown", re = We.extend({
      options: {
        // @section
        // @aka Draggable options
        // @option clickTolerance: Number = 3
        // The max number of pixels a user can shift the mouse pointer during a click
        // for it to be considered a valid click (as opposed to a mouse drag).
        clickTolerance: 3
      },
      // @constructor L.Draggable(el: HTMLElement, dragHandle?: HTMLElement, preventOutline?: Boolean, options?: Draggable options)
      // Creates a `Draggable` object for moving `el` when you start dragging the `dragHandle` element (equals `el` itself by default).
      initialize: function(t, e, n, o) {
        U(this, o), this._element = t, this._dragStartTarget = e || t, this._preventOutline = n;
      },
      // @method enable()
      // Enables the dragging ability
      enable: function() {
        this._enabled || (C(this._dragStartTarget, _r, this._onDown, this), this._enabled = !0);
      },
      // @method disable()
      // Disables the dragging ability
      disable: function() {
        this._enabled && (re._dragging === this && this.finishDrag(!0), j(this._dragStartTarget, _r, this._onDown, this), this._enabled = !1, this._moved = !1);
      },
      _onDown: function(t) {
        if (this._enabled && (this._moved = !1, !Mn(this._element, "leaflet-zoom-anim"))) {
          if (t.touches && t.touches.length !== 1) {
            re._dragging === this && this.finishDrag();
            return;
          }
          if (!(re._dragging || t.shiftKey || t.which !== 1 && t.button !== 1 && !t.touches) && (re._dragging = this, this._preventOutline && Cn(this._element), Sn(), Ve(), !this._moving)) {
            this.fire("down");
            var e = t.touches ? t.touches[0] : t, n = or(this._element);
            this._startPoint = new O(e.clientX, e.clientY), this._startPos = fe(this._element), this._parentScale = Dn(n);
            var o = t.type === "mousedown";
            C(document, o ? "mousemove" : "touchmove", this._onMove, this), C(document, o ? "mouseup" : "touchend touchcancel", this._onUp, this);
          }
        }
      },
      _onMove: function(t) {
        if (this._enabled) {
          if (t.touches && t.touches.length > 1) {
            this._moved = !0;
            return;
          }
          var e = t.touches && t.touches.length === 1 ? t.touches[0] : t, n = new O(e.clientX, e.clientY)._subtract(this._startPoint);
          !n.x && !n.y || Math.abs(n.x) + Math.abs(n.y) < this.options.clickTolerance || (n.x /= this._parentScale.x, n.y /= this._parentScale.y, at(t), this._moved || (this.fire("dragstart"), this._moved = !0, A(document.body, "leaflet-dragging"), this._lastTarget = t.target || t.srcElement, window.SVGElementInstance && this._lastTarget instanceof window.SVGElementInstance && (this._lastTarget = this._lastTarget.correspondingUseElement), A(this._lastTarget, "leaflet-drag-target")), this._newPos = this._startPos.add(n), this._moving = !0, this._lastEvent = t, this._updatePosition());
        }
      },
      _updatePosition: function() {
        var t = { originalEvent: this._lastEvent };
        this.fire("predrag", t), it(this._element, this._newPos), this.fire("drag", t);
      },
      _onUp: function() {
        this._enabled && this.finishDrag();
      },
      finishDrag: function(t) {
        Q(document.body, "leaflet-dragging"), this._lastTarget && (Q(this._lastTarget, "leaflet-drag-target"), this._lastTarget = null), j(document, "mousemove touchmove", this._onMove, this), j(document, "mouseup touchend touchcancel", this._onUp, this), kn(), je();
        var e = this._moved && this._moving;
        this._moving = !1, re._dragging = !1, e && this.fire("dragend", {
          noInertia: t,
          distance: this._newPos.distanceTo(this._startPos)
        });
      }
    });
    function mr(t, e, n) {
      var o, h = [1, 4, 2, 8], l, f, _, m, p, x, T, z;
      for (l = 0, x = t.length; l < x; l++)
        t[l]._code = me(t[l], e);
      for (_ = 0; _ < 4; _++) {
        for (T = h[_], o = [], l = 0, x = t.length, f = x - 1; l < x; f = l++)
          m = t[l], p = t[f], m._code & T ? p._code & T || (z = Mi(p, m, T, e, n), z._code = me(z, e), o.push(z)) : (p._code & T && (z = Mi(p, m, T, e, n), z._code = me(z, e), o.push(z)), o.push(m));
        t = o;
      }
      return t;
    }
    function pr(t, e) {
      var n, o, h, l, f, _, m, p, x;
      if (!t || t.length === 0)
        throw new Error("latlngs not passed");
      Lt(t) || (console.warn("latlngs are not flat! Only the first ring will be used"), t = t[0]);
      var T = N([0, 0]), z = et(t), ct = z.getNorthWest().distanceTo(z.getSouthWest()) * z.getNorthEast().distanceTo(z.getNorthWest());
      ct < 1700 && (T = Bn(t));
      var ot = t.length, Mt = [];
      for (n = 0; n < ot; n++) {
        var mt = N(t[n]);
        Mt.push(e.project(N([mt.lat - T.lat, mt.lng - T.lng])));
      }
      for (_ = m = p = 0, n = 0, o = ot - 1; n < ot; o = n++)
        h = Mt[n], l = Mt[o], f = h.y * l.x - l.y * h.x, m += (h.x + l.x) * f, p += (h.y + l.y) * f, _ += f * 3;
      _ === 0 ? x = Mt[0] : x = [m / _, p / _];
      var Ce = e.unproject(S(x));
      return N([Ce.lat + T.lat, Ce.lng + T.lng]);
    }
    function Bn(t) {
      for (var e = 0, n = 0, o = 0, h = 0; h < t.length; h++) {
        var l = N(t[h]);
        e += l.lat, n += l.lng, o++;
      }
      return N([e / o, n / o]);
    }
    var ja = {
      __proto__: null,
      clipPolygon: mr,
      polygonCenter: pr,
      centroid: Bn
    };
    function gr(t, e) {
      if (!e || !t.length)
        return t.slice();
      var n = e * e;
      return t = Xa(t, n), t = Ka(t, n), t;
    }
    function vr(t, e, n) {
      return Math.sqrt(Je(t, e, n, !0));
    }
    function qa(t, e, n) {
      return Je(t, e, n);
    }
    function Ka(t, e) {
      var n = t.length, o = typeof Uint8Array != void 0 + "" ? Uint8Array : Array, h = new o(n);
      h[0] = h[n - 1] = 1, Yn(t, h, e, 0, n - 1);
      var l, f = [];
      for (l = 0; l < n; l++)
        h[l] && f.push(t[l]);
      return f;
    }
    function Yn(t, e, n, o, h) {
      var l = 0, f, _, m;
      for (_ = o + 1; _ <= h - 1; _++)
        m = Je(t[_], t[o], t[h], !0), m > l && (f = _, l = m);
      l > n && (e[f] = 1, Yn(t, e, n, o, f), Yn(t, e, n, f, h));
    }
    function Xa(t, e) {
      for (var n = [t[0]], o = 1, h = 0, l = t.length; o < l; o++)
        Ja(t[o], t[h]) > e && (n.push(t[o]), h = o);
      return h < l - 1 && n.push(t[l - 1]), n;
    }
    var yr;
    function wr(t, e, n, o, h) {
      var l = o ? yr : me(t, n), f = me(e, n), _, m, p;
      for (yr = f; ; ) {
        if (!(l | f))
          return [t, e];
        if (l & f)
          return !1;
        _ = l || f, m = Mi(t, e, _, n, h), p = me(m, n), _ === l ? (t = m, l = p) : (e = m, f = p);
      }
    }
    function Mi(t, e, n, o, h) {
      var l = e.x - t.x, f = e.y - t.y, _ = o.min, m = o.max, p, x;
      return n & 8 ? (p = t.x + l * (m.y - t.y) / f, x = m.y) : n & 4 ? (p = t.x + l * (_.y - t.y) / f, x = _.y) : n & 2 ? (p = m.x, x = t.y + f * (m.x - t.x) / l) : n & 1 && (p = _.x, x = t.y + f * (_.x - t.x) / l), new O(p, x, h);
    }
    function me(t, e) {
      var n = 0;
      return t.x < e.min.x ? n |= 1 : t.x > e.max.x && (n |= 2), t.y < e.min.y ? n |= 4 : t.y > e.max.y && (n |= 8), n;
    }
    function Ja(t, e) {
      var n = e.x - t.x, o = e.y - t.y;
      return n * n + o * o;
    }
    function Je(t, e, n, o) {
      var h = e.x, l = e.y, f = n.x - h, _ = n.y - l, m = f * f + _ * _, p;
      return m > 0 && (p = ((t.x - h) * f + (t.y - l) * _) / m, p > 1 ? (h = n.x, l = n.y) : p > 0 && (h += f * p, l += _ * p)), f = t.x - h, _ = t.y - l, o ? f * f + _ * _ : new O(h, l);
    }
    function Lt(t) {
      return !kt(t[0]) || typeof t[0][0] != "object" && typeof t[0][0] < "u";
    }
    function xr(t) {
      return console.warn("Deprecated use of _flat, please use L.LineUtil.isFlat instead."), Lt(t);
    }
    function Pr(t, e) {
      var n, o, h, l, f, _, m, p;
      if (!t || t.length === 0)
        throw new Error("latlngs not passed");
      Lt(t) || (console.warn("latlngs are not flat! Only the first ring will be used"), t = t[0]);
      var x = N([0, 0]), T = et(t), z = T.getNorthWest().distanceTo(T.getSouthWest()) * T.getNorthEast().distanceTo(T.getNorthWest());
      z < 1700 && (x = Bn(t));
      var ct = t.length, ot = [];
      for (n = 0; n < ct; n++) {
        var Mt = N(t[n]);
        ot.push(e.project(N([Mt.lat - x.lat, Mt.lng - x.lng])));
      }
      for (n = 0, o = 0; n < ct - 1; n++)
        o += ot[n].distanceTo(ot[n + 1]) / 2;
      if (o === 0)
        p = ot[0];
      else
        for (n = 0, l = 0; n < ct - 1; n++)
          if (f = ot[n], _ = ot[n + 1], h = f.distanceTo(_), l += h, l > o) {
            m = (l - o) / h, p = [
              _.x - m * (_.x - f.x),
              _.y - m * (_.y - f.y)
            ];
            break;
          }
      var mt = e.unproject(S(p));
      return N([mt.lat + x.lat, mt.lng + x.lng]);
    }
    var $a = {
      __proto__: null,
      simplify: gr,
      pointToSegmentDistance: vr,
      closestPointOnSegment: qa,
      clipSegment: wr,
      _getEdgeIntersection: Mi,
      _getBitCode: me,
      _sqClosestPointOnSegment: Je,
      isFlat: Lt,
      _flat: xr,
      polylineCenter: Pr
    }, Wn = {
      project: function(t) {
        return new O(t.lng, t.lat);
      },
      unproject: function(t) {
        return new G(t.y, t.x);
      },
      bounds: new J([-180, -90], [180, 90])
    }, Fn = {
      R: 6378137,
      R_MINOR: 6356752314245179e-9,
      bounds: new J([-2003750834279e-5, -1549657073972e-5], [2003750834279e-5, 1876465623138e-5]),
      project: function(t) {
        var e = Math.PI / 180, n = this.R, o = t.lat * e, h = this.R_MINOR / n, l = Math.sqrt(1 - h * h), f = l * Math.sin(o), _ = Math.tan(Math.PI / 4 - o / 2) / Math.pow((1 - f) / (1 + f), l / 2);
        return o = -n * Math.log(Math.max(_, 1e-10)), new O(t.lng * e * n, o);
      },
      unproject: function(t) {
        for (var e = 180 / Math.PI, n = this.R, o = this.R_MINOR / n, h = Math.sqrt(1 - o * o), l = Math.exp(-t.y / n), f = Math.PI / 2 - 2 * Math.atan(l), _ = 0, m = 0.1, p; _ < 15 && Math.abs(m) > 1e-7; _++)
          p = h * Math.sin(f), p = Math.pow((1 - p) / (1 + p), h / 2), m = Math.PI / 2 - 2 * Math.atan(l * p) - f, f += m;
        return new G(f * e, t.x * e / n);
      }
    }, Qa = {
      __proto__: null,
      LonLat: Wn,
      Mercator: Fn,
      SphericalMercator: _n
    }, th = u({}, se, {
      code: "EPSG:3395",
      projection: Fn,
      transformation: function() {
        var t = 0.5 / (Math.PI * Fn.R);
        return Fe(t, 0.5, -t, 0.5);
      }()
    }), Lr = u({}, se, {
      code: "EPSG:4326",
      projection: Wn,
      transformation: Fe(1 / 180, 1, -1 / 180, 0.5)
    }), eh = u({}, Gt, {
      projection: Wn,
      transformation: Fe(1, 0, -1, 0),
      scale: function(t) {
        return Math.pow(2, t);
      },
      zoom: function(t) {
        return Math.log(t) / Math.LN2;
      },
      distance: function(t, e) {
        var n = e.lng - t.lng, o = e.lat - t.lat;
        return Math.sqrt(n * n + o * o);
      },
      infinite: !0
    });
    Gt.Earth = se, Gt.EPSG3395 = th, Gt.EPSG3857 = pn, Gt.EPSG900913 = aa, Gt.EPSG4326 = Lr, Gt.Simple = eh;
    var Ct = We.extend({
      // Classes extending `L.Layer` will inherit the following options:
      options: {
        // @option pane: String = 'overlayPane'
        // By default the layer will be added to the map's [overlay pane](#map-overlaypane). Overriding this option will cause the layer to be placed on another pane by default.
        pane: "overlayPane",
        // @option attribution: String = null
        // String to be shown in the attribution control, e.g. "© OpenStreetMap contributors". It describes the layer data and is often a legal obligation towards copyright holders and tile providers.
        attribution: null,
        bubblingMouseEvents: !0
      },
      /* @section
       * Classes extending `L.Layer` will inherit the following methods:
       *
       * @method addTo(map: Map|LayerGroup): this
       * Adds the layer to the given map or layer group.
       */
      addTo: function(t) {
        return t.addLayer(this), this;
      },
      // @method remove: this
      // Removes the layer from the map it is currently active on.
      remove: function() {
        return this.removeFrom(this._map || this._mapToAdd);
      },
      // @method removeFrom(map: Map): this
      // Removes the layer from the given map
      //
      // @alternative
      // @method removeFrom(group: LayerGroup): this
      // Removes the layer from the given `LayerGroup`
      removeFrom: function(t) {
        return t && t.removeLayer(this), this;
      },
      // @method getPane(name? : String): HTMLElement
      // Returns the `HTMLElement` representing the named pane on the map. If `name` is omitted, returns the pane for this layer.
      getPane: function(t) {
        return this._map.getPane(t ? this.options[t] || t : this.options.pane);
      },
      addInteractiveTarget: function(t) {
        return this._map._targets[g(t)] = this, this;
      },
      removeInteractiveTarget: function(t) {
        return delete this._map._targets[g(t)], this;
      },
      // @method getAttribution: String
      // Used by the `attribution control`, returns the [attribution option](#gridlayer-attribution).
      getAttribution: function() {
        return this.options.attribution;
      },
      _layerAdd: function(t) {
        var e = t.target;
        if (e.hasLayer(this)) {
          if (this._map = e, this._zoomAnimated = e._zoomAnimated, this.getEvents) {
            var n = this.getEvents();
            e.on(n, this), this.once("remove", function() {
              e.off(n, this);
            }, this);
          }
          this.onAdd(e), this.fire("add"), e.fire("layeradd", { layer: this });
        }
      }
    });
    R.include({
      // @method addLayer(layer: Layer): this
      // Adds the given layer to the map
      addLayer: function(t) {
        if (!t._layerAdd)
          throw new Error("The provided object is not a Layer.");
        var e = g(t);
        return this._layers[e] ? this : (this._layers[e] = t, t._mapToAdd = this, t.beforeAdd && t.beforeAdd(this), this.whenReady(t._layerAdd, t), this);
      },
      // @method removeLayer(layer: Layer): this
      // Removes the given layer from the map.
      removeLayer: function(t) {
        var e = g(t);
        return this._layers[e] ? (this._loaded && t.onRemove(this), delete this._layers[e], this._loaded && (this.fire("layerremove", { layer: t }), t.fire("remove")), t._map = t._mapToAdd = null, this) : this;
      },
      // @method hasLayer(layer: Layer): Boolean
      // Returns `true` if the given layer is currently added to the map
      hasLayer: function(t) {
        return g(t) in this._layers;
      },
      /* @method eachLayer(fn: Function, context?: Object): this
       * Iterates over the layers of the map, optionally specifying context of the iterator function.
       * ```
       * map.eachLayer(function(layer){
       *     layer.bindPopup('Hello');
       * });
       * ```
       */
      eachLayer: function(t, e) {
        for (var n in this._layers)
          t.call(e, this._layers[n]);
        return this;
      },
      _addLayers: function(t) {
        t = t ? kt(t) ? t : [t] : [];
        for (var e = 0, n = t.length; e < n; e++)
          this.addLayer(t[e]);
      },
      _addZoomLimit: function(t) {
        (!isNaN(t.options.maxZoom) || !isNaN(t.options.minZoom)) && (this._zoomBoundLayers[g(t)] = t, this._updateZoomLevels());
      },
      _removeZoomLimit: function(t) {
        var e = g(t);
        this._zoomBoundLayers[e] && (delete this._zoomBoundLayers[e], this._updateZoomLevels());
      },
      _updateZoomLevels: function() {
        var t = 1 / 0, e = -1 / 0, n = this._getZoomSpan();
        for (var o in this._zoomBoundLayers) {
          var h = this._zoomBoundLayers[o].options;
          t = h.minZoom === void 0 ? t : Math.min(t, h.minZoom), e = h.maxZoom === void 0 ? e : Math.max(e, h.maxZoom);
        }
        this._layersMaxZoom = e === -1 / 0 ? void 0 : e, this._layersMinZoom = t === 1 / 0 ? void 0 : t, n !== this._getZoomSpan() && this.fire("zoomlevelschange"), this.options.maxZoom === void 0 && this._layersMaxZoom && this.getZoom() > this._layersMaxZoom && this.setZoom(this._layersMaxZoom), this.options.minZoom === void 0 && this._layersMinZoom && this.getZoom() < this._layersMinZoom && this.setZoom(this._layersMinZoom);
      }
    });
    var be = Ct.extend({
      initialize: function(t, e) {
        U(this, e), this._layers = {};
        var n, o;
        if (t)
          for (n = 0, o = t.length; n < o; n++)
            this.addLayer(t[n]);
      },
      // @method addLayer(layer: Layer): this
      // Adds the given layer to the group.
      addLayer: function(t) {
        var e = this.getLayerId(t);
        return this._layers[e] = t, this._map && this._map.addLayer(t), this;
      },
      // @method removeLayer(layer: Layer): this
      // Removes the given layer from the group.
      // @alternative
      // @method removeLayer(id: Number): this
      // Removes the layer with the given internal ID from the group.
      removeLayer: function(t) {
        var e = t in this._layers ? t : this.getLayerId(t);
        return this._map && this._layers[e] && this._map.removeLayer(this._layers[e]), delete this._layers[e], this;
      },
      // @method hasLayer(layer: Layer): Boolean
      // Returns `true` if the given layer is currently added to the group.
      // @alternative
      // @method hasLayer(id: Number): Boolean
      // Returns `true` if the given internal ID is currently added to the group.
      hasLayer: function(t) {
        var e = typeof t == "number" ? t : this.getLayerId(t);
        return e in this._layers;
      },
      // @method clearLayers(): this
      // Removes all the layers from the group.
      clearLayers: function() {
        return this.eachLayer(this.removeLayer, this);
      },
      // @method invoke(methodName: String, …): this
      // Calls `methodName` on every layer contained in this group, passing any
      // additional parameters. Has no effect if the layers contained do not
      // implement `methodName`.
      invoke: function(t) {
        var e = Array.prototype.slice.call(arguments, 1), n, o;
        for (n in this._layers)
          o = this._layers[n], o[t] && o[t].apply(o, e);
        return this;
      },
      onAdd: function(t) {
        this.eachLayer(t.addLayer, t);
      },
      onRemove: function(t) {
        this.eachLayer(t.removeLayer, t);
      },
      // @method eachLayer(fn: Function, context?: Object): this
      // Iterates over the layers of the group, optionally specifying context of the iterator function.
      // ```js
      // group.eachLayer(function (layer) {
      // 	layer.bindPopup('Hello');
      // });
      // ```
      eachLayer: function(t, e) {
        for (var n in this._layers)
          t.call(e, this._layers[n]);
        return this;
      },
      // @method getLayer(id: Number): Layer
      // Returns the layer with the given internal ID.
      getLayer: function(t) {
        return this._layers[t];
      },
      // @method getLayers(): Layer[]
      // Returns an array of all the layers added to the group.
      getLayers: function() {
        var t = [];
        return this.eachLayer(t.push, t), t;
      },
      // @method setZIndex(zIndex: Number): this
      // Calls `setZIndex` on every layer contained in this group, passing the z-index.
      setZIndex: function(t) {
        return this.invoke("setZIndex", t);
      },
      // @method getLayerId(layer: Layer): Number
      // Returns the internal ID for a layer
      getLayerId: function(t) {
        return g(t);
      }
    }), ih = function(t, e) {
      return new be(t, e);
    }, Vt = be.extend({
      addLayer: function(t) {
        return this.hasLayer(t) ? this : (t.addEventParent(this), be.prototype.addLayer.call(this, t), this.fire("layeradd", { layer: t }));
      },
      removeLayer: function(t) {
        return this.hasLayer(t) ? (t in this._layers && (t = this._layers[t]), t.removeEventParent(this), be.prototype.removeLayer.call(this, t), this.fire("layerremove", { layer: t })) : this;
      },
      // @method setStyle(style: Path options): this
      // Sets the given path options to each layer of the group that has a `setStyle` method.
      setStyle: function(t) {
        return this.invoke("setStyle", t);
      },
      // @method bringToFront(): this
      // Brings the layer group to the top of all other layers
      bringToFront: function() {
        return this.invoke("bringToFront");
      },
      // @method bringToBack(): this
      // Brings the layer group to the back of all other layers
      bringToBack: function() {
        return this.invoke("bringToBack");
      },
      // @method getBounds(): LatLngBounds
      // Returns the LatLngBounds of the Feature Group (created from bounds and coordinates of its children).
      getBounds: function() {
        var t = new _t();
        for (var e in this._layers) {
          var n = this._layers[e];
          t.extend(n.getBounds ? n.getBounds() : n.getLatLng());
        }
        return t;
      }
    }), nh = function(t, e) {
      return new Vt(t, e);
    }, Te = Ut.extend({
      /* @section
       * @aka Icon options
       *
       * @option iconUrl: String = null
       * **(required)** The URL to the icon image (absolute or relative to your script path).
       *
       * @option iconRetinaUrl: String = null
       * The URL to a retina sized version of the icon image (absolute or relative to your
       * script path). Used for Retina screen devices.
       *
       * @option iconSize: Point = null
       * Size of the icon image in pixels.
       *
       * @option iconAnchor: Point = null
       * The coordinates of the "tip" of the icon (relative to its top left corner). The icon
       * will be aligned so that this point is at the marker's geographical location. Centered
       * by default if size is specified, also can be set in CSS with negative margins.
       *
       * @option popupAnchor: Point = [0, 0]
       * The coordinates of the point from which popups will "open", relative to the icon anchor.
       *
       * @option tooltipAnchor: Point = [0, 0]
       * The coordinates of the point from which tooltips will "open", relative to the icon anchor.
       *
       * @option shadowUrl: String = null
       * The URL to the icon shadow image. If not specified, no shadow image will be created.
       *
       * @option shadowRetinaUrl: String = null
       *
       * @option shadowSize: Point = null
       * Size of the shadow image in pixels.
       *
       * @option shadowAnchor: Point = null
       * The coordinates of the "tip" of the shadow (relative to its top left corner) (the same
       * as iconAnchor if not specified).
       *
       * @option className: String = ''
       * A custom class name to assign to both icon and shadow images. Empty by default.
       */
      options: {
        popupAnchor: [0, 0],
        tooltipAnchor: [0, 0],
        // @option crossOrigin: Boolean|String = false
        // Whether the crossOrigin attribute will be added to the tiles.
        // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
        // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
        crossOrigin: !1
      },
      initialize: function(t) {
        U(this, t);
      },
      // @method createIcon(oldIcon?: HTMLElement): HTMLElement
      // Called internally when the icon has to be shown, returns a `<img>` HTML element
      // styled according to the options.
      createIcon: function(t) {
        return this._createIcon("icon", t);
      },
      // @method createShadow(oldIcon?: HTMLElement): HTMLElement
      // As `createIcon`, but for the shadow beneath it.
      createShadow: function(t) {
        return this._createIcon("shadow", t);
      },
      _createIcon: function(t, e) {
        var n = this._getIconUrl(t);
        if (!n) {
          if (t === "icon")
            throw new Error("iconUrl not set in Icon options (see the docs).");
          return null;
        }
        var o = this._createImg(n, e && e.tagName === "IMG" ? e : null);
        return this._setIconStyles(o, t), (this.options.crossOrigin || this.options.crossOrigin === "") && (o.crossOrigin = this.options.crossOrigin === !0 ? "" : this.options.crossOrigin), o;
      },
      _setIconStyles: function(t, e) {
        var n = this.options, o = n[e + "Size"];
        typeof o == "number" && (o = [o, o]);
        var h = S(o), l = S(e === "shadow" && n.shadowAnchor || n.iconAnchor || h && h.divideBy(2, !0));
        t.className = "leaflet-marker-" + e + " " + (n.className || ""), l && (t.style.marginLeft = -l.x + "px", t.style.marginTop = -l.y + "px"), h && (t.style.width = h.x + "px", t.style.height = h.y + "px");
      },
      _createImg: function(t, e) {
        return e = e || document.createElement("img"), e.src = t, e;
      },
      _getIconUrl: function(t) {
        return M.retina && this.options[t + "RetinaUrl"] || this.options[t + "Url"];
      }
    });
    function sh(t) {
      return new Te(t);
    }
    var $e = Te.extend({
      options: {
        iconUrl: "marker-icon.png",
        iconRetinaUrl: "marker-icon-2x.png",
        shadowUrl: "marker-shadow.png",
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        tooltipAnchor: [16, -28],
        shadowSize: [41, 41]
      },
      _getIconUrl: function(t) {
        return typeof $e.imagePath != "string" && ($e.imagePath = this._detectIconPath()), (this.options.imagePath || $e.imagePath) + Te.prototype._getIconUrl.call(this, t);
      },
      _stripUrl: function(t) {
        var e = function(n, o, h) {
          var l = o.exec(n);
          return l && l[h];
        };
        return t = e(t, /^url\((['"])?(.+)\1\)$/, 2), t && e(t, /^(.*)marker-icon\.png$/, 1);
      },
      _detectIconPath: function() {
        var t = B("div", "leaflet-default-icon-path", document.body), e = Ge(t, "background-image") || Ge(t, "backgroundImage");
        if (document.body.removeChild(t), e = this._stripUrl(e), e)
          return e;
        var n = document.querySelector('link[href$="leaflet.css"]');
        return n ? n.href.substring(0, n.href.length - 11 - 1) : "";
      }
    }), Mr = Zt.extend({
      initialize: function(t) {
        this._marker = t;
      },
      addHooks: function() {
        var t = this._marker._icon;
        this._draggable || (this._draggable = new re(t, t, !0)), this._draggable.on({
          dragstart: this._onDragStart,
          predrag: this._onPreDrag,
          drag: this._onDrag,
          dragend: this._onDragEnd
        }, this).enable(), A(t, "leaflet-marker-draggable");
      },
      removeHooks: function() {
        this._draggable.off({
          dragstart: this._onDragStart,
          predrag: this._onPreDrag,
          drag: this._onDrag,
          dragend: this._onDragEnd
        }, this).disable(), this._marker._icon && Q(this._marker._icon, "leaflet-marker-draggable");
      },
      moved: function() {
        return this._draggable && this._draggable._moved;
      },
      _adjustPan: function(t) {
        var e = this._marker, n = e._map, o = this._marker.options.autoPanSpeed, h = this._marker.options.autoPanPadding, l = fe(e._icon), f = n.getPixelBounds(), _ = n.getPixelOrigin(), m = dt(
          f.min._subtract(_).add(h),
          f.max._subtract(_).subtract(h)
        );
        if (!m.contains(l)) {
          var p = S(
            (Math.max(m.max.x, l.x) - m.max.x) / (f.max.x - m.max.x) - (Math.min(m.min.x, l.x) - m.min.x) / (f.min.x - m.min.x),
            (Math.max(m.max.y, l.y) - m.max.y) / (f.max.y - m.max.y) - (Math.min(m.min.y, l.y) - m.min.y) / (f.min.y - m.min.y)
          ).multiplyBy(o);
          n.panBy(p, { animate: !1 }), this._draggable._newPos._add(p), this._draggable._startPos._add(p), it(e._icon, this._draggable._newPos), this._onDrag(t), this._panRequest = ft(this._adjustPan.bind(this, t));
        }
      },
      _onDragStart: function() {
        this._oldLatLng = this._marker.getLatLng(), this._marker.closePopup && this._marker.closePopup(), this._marker.fire("movestart").fire("dragstart");
      },
      _onPreDrag: function(t) {
        this._marker.options.autoPan && (xt(this._panRequest), this._panRequest = ft(this._adjustPan.bind(this, t)));
      },
      _onDrag: function(t) {
        var e = this._marker, n = e._shadow, o = fe(e._icon), h = e._map.layerPointToLatLng(o);
        n && it(n, o), e._latlng = h, t.latlng = h, t.oldLatLng = this._oldLatLng, e.fire("move", t).fire("drag", t);
      },
      _onDragEnd: function(t) {
        xt(this._panRequest), delete this._oldLatLng, this._marker.fire("moveend").fire("dragend", t);
      }
    }), bi = Ct.extend({
      // @section
      // @aka Marker options
      options: {
        // @option icon: Icon = *
        // Icon instance to use for rendering the marker.
        // See [Icon documentation](#L.Icon) for details on how to customize the marker icon.
        // If not specified, a common instance of `L.Icon.Default` is used.
        icon: new $e(),
        // Option inherited from "Interactive layer" abstract class
        interactive: !0,
        // @option keyboard: Boolean = true
        // Whether the marker can be tabbed to with a keyboard and clicked by pressing enter.
        keyboard: !0,
        // @option title: String = ''
        // Text for the browser tooltip that appear on marker hover (no tooltip by default).
        // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
        title: "",
        // @option alt: String = 'Marker'
        // Text for the `alt` attribute of the icon image.
        // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
        alt: "Marker",
        // @option zIndexOffset: Number = 0
        // By default, marker images zIndex is set automatically based on its latitude. Use this option if you want to put the marker on top of all others (or below), specifying a high value like `1000` (or high negative value, respectively).
        zIndexOffset: 0,
        // @option opacity: Number = 1.0
        // The opacity of the marker.
        opacity: 1,
        // @option riseOnHover: Boolean = false
        // If `true`, the marker will get on top of others when you hover the mouse over it.
        riseOnHover: !1,
        // @option riseOffset: Number = 250
        // The z-index offset used for the `riseOnHover` feature.
        riseOffset: 250,
        // @option pane: String = 'markerPane'
        // `Map pane` where the markers icon will be added.
        pane: "markerPane",
        // @option shadowPane: String = 'shadowPane'
        // `Map pane` where the markers shadow will be added.
        shadowPane: "shadowPane",
        // @option bubblingMouseEvents: Boolean = false
        // When `true`, a mouse event on this marker will trigger the same event on the map
        // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
        bubblingMouseEvents: !1,
        // @option autoPanOnFocus: Boolean = true
        // When `true`, the map will pan whenever the marker is focused (via
        // e.g. pressing `tab` on the keyboard) to ensure the marker is
        // visible within the map's bounds
        autoPanOnFocus: !0,
        // @section Draggable marker options
        // @option draggable: Boolean = false
        // Whether the marker is draggable with mouse/touch or not.
        draggable: !1,
        // @option autoPan: Boolean = false
        // Whether to pan the map when dragging this marker near its edge or not.
        autoPan: !1,
        // @option autoPanPadding: Point = Point(50, 50)
        // Distance (in pixels to the left/right and to the top/bottom) of the
        // map edge to start panning the map.
        autoPanPadding: [50, 50],
        // @option autoPanSpeed: Number = 10
        // Number of pixels the map should pan by.
        autoPanSpeed: 10
      },
      /* @section
       *
       * In addition to [shared layer methods](#Layer) like `addTo()` and `remove()` and [popup methods](#Popup) like bindPopup() you can also use the following methods:
       */
      initialize: function(t, e) {
        U(this, e), this._latlng = N(t);
      },
      onAdd: function(t) {
        this._zoomAnimated = this._zoomAnimated && t.options.markerZoomAnimation, this._zoomAnimated && t.on("zoomanim", this._animateZoom, this), this._initIcon(), this.update();
      },
      onRemove: function(t) {
        this.dragging && this.dragging.enabled() && (this.options.draggable = !0, this.dragging.removeHooks()), delete this.dragging, this._zoomAnimated && t.off("zoomanim", this._animateZoom, this), this._removeIcon(), this._removeShadow();
      },
      getEvents: function() {
        return {
          zoom: this.update,
          viewreset: this.update
        };
      },
      // @method getLatLng: LatLng
      // Returns the current geographical position of the marker.
      getLatLng: function() {
        return this._latlng;
      },
      // @method setLatLng(latlng: LatLng): this
      // Changes the marker position to the given point.
      setLatLng: function(t) {
        var e = this._latlng;
        return this._latlng = N(t), this.update(), this.fire("move", { oldLatLng: e, latlng: this._latlng });
      },
      // @method setZIndexOffset(offset: Number): this
      // Changes the [zIndex offset](#marker-zindexoffset) of the marker.
      setZIndexOffset: function(t) {
        return this.options.zIndexOffset = t, this.update();
      },
      // @method getIcon: Icon
      // Returns the current icon used by the marker
      getIcon: function() {
        return this.options.icon;
      },
      // @method setIcon(icon: Icon): this
      // Changes the marker icon.
      setIcon: function(t) {
        return this.options.icon = t, this._map && (this._initIcon(), this.update()), this._popup && this.bindPopup(this._popup, this._popup.options), this;
      },
      getElement: function() {
        return this._icon;
      },
      update: function() {
        if (this._icon && this._map) {
          var t = this._map.latLngToLayerPoint(this._latlng).round();
          this._setPos(t);
        }
        return this;
      },
      _initIcon: function() {
        var t = this.options, e = "leaflet-zoom-" + (this._zoomAnimated ? "animated" : "hide"), n = t.icon.createIcon(this._icon), o = !1;
        n !== this._icon && (this._icon && this._removeIcon(), o = !0, t.title && (n.title = t.title), n.tagName === "IMG" && (n.alt = t.alt || "")), A(n, e), t.keyboard && (n.tabIndex = "0", n.setAttribute("role", "button")), this._icon = n, t.riseOnHover && this.on({
          mouseover: this._bringToFront,
          mouseout: this._resetZIndex
        }), this.options.autoPanOnFocus && C(n, "focus", this._panOnFocus, this);
        var h = t.icon.createShadow(this._shadow), l = !1;
        h !== this._shadow && (this._removeShadow(), l = !0), h && (A(h, e), h.alt = ""), this._shadow = h, t.opacity < 1 && this._updateOpacity(), o && this.getPane().appendChild(this._icon), this._initInteraction(), h && l && this.getPane(t.shadowPane).appendChild(this._shadow);
      },
      _removeIcon: function() {
        this.options.riseOnHover && this.off({
          mouseover: this._bringToFront,
          mouseout: this._resetZIndex
        }), this.options.autoPanOnFocus && j(this._icon, "focus", this._panOnFocus, this), $(this._icon), this.removeInteractiveTarget(this._icon), this._icon = null;
      },
      _removeShadow: function() {
        this._shadow && $(this._shadow), this._shadow = null;
      },
      _setPos: function(t) {
        this._icon && it(this._icon, t), this._shadow && it(this._shadow, t), this._zIndex = t.y + this.options.zIndexOffset, this._resetZIndex();
      },
      _updateZIndex: function(t) {
        this._icon && (this._icon.style.zIndex = this._zIndex + t);
      },
      _animateZoom: function(t) {
        var e = this._map._latLngToNewLayerPoint(this._latlng, t.zoom, t.center).round();
        this._setPos(e);
      },
      _initInteraction: function() {
        if (this.options.interactive && (A(this._icon, "leaflet-interactive"), this.addInteractiveTarget(this._icon), Mr)) {
          var t = this.options.draggable;
          this.dragging && (t = this.dragging.enabled(), this.dragging.disable()), this.dragging = new Mr(this), t && this.dragging.enable();
        }
      },
      // @method setOpacity(opacity: Number): this
      // Changes the opacity of the marker.
      setOpacity: function(t) {
        return this.options.opacity = t, this._map && this._updateOpacity(), this;
      },
      _updateOpacity: function() {
        var t = this.options.opacity;
        this._icon && Pt(this._icon, t), this._shadow && Pt(this._shadow, t);
      },
      _bringToFront: function() {
        this._updateZIndex(this.options.riseOffset);
      },
      _resetZIndex: function() {
        this._updateZIndex(0);
      },
      _panOnFocus: function() {
        var t = this._map;
        if (t) {
          var e = this.options.icon.options, n = e.iconSize ? S(e.iconSize) : S(0, 0), o = e.iconAnchor ? S(e.iconAnchor) : S(0, 0);
          t.panInside(this._latlng, {
            paddingTopLeft: o,
            paddingBottomRight: n.subtract(o)
          });
        }
      },
      _getPopupAnchor: function() {
        return this.options.icon.options.popupAnchor;
      },
      _getTooltipAnchor: function() {
        return this.options.icon.options.tooltipAnchor;
      }
    });
    function rh(t, e) {
      return new bi(t, e);
    }
    var oe = Ct.extend({
      // @section
      // @aka Path options
      options: {
        // @option stroke: Boolean = true
        // Whether to draw stroke along the path. Set it to `false` to disable borders on polygons or circles.
        stroke: !0,
        // @option color: String = '#3388ff'
        // Stroke color
        color: "#3388ff",
        // @option weight: Number = 3
        // Stroke width in pixels
        weight: 3,
        // @option opacity: Number = 1.0
        // Stroke opacity
        opacity: 1,
        // @option lineCap: String= 'round'
        // A string that defines [shape to be used at the end](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linecap) of the stroke.
        lineCap: "round",
        // @option lineJoin: String = 'round'
        // A string that defines [shape to be used at the corners](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linejoin) of the stroke.
        lineJoin: "round",
        // @option dashArray: String = null
        // A string that defines the stroke [dash pattern](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dasharray). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
        dashArray: null,
        // @option dashOffset: String = null
        // A string that defines the [distance into the dash pattern to start the dash](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dashoffset). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
        dashOffset: null,
        // @option fill: Boolean = depends
        // Whether to fill the path with color. Set it to `false` to disable filling on polygons or circles.
        fill: !1,
        // @option fillColor: String = *
        // Fill color. Defaults to the value of the [`color`](#path-color) option
        fillColor: null,
        // @option fillOpacity: Number = 0.2
        // Fill opacity.
        fillOpacity: 0.2,
        // @option fillRule: String = 'evenodd'
        // A string that defines [how the inside of a shape](https://developer.mozilla.org/docs/Web/SVG/Attribute/fill-rule) is determined.
        fillRule: "evenodd",
        // className: '',
        // Option inherited from "Interactive layer" abstract class
        interactive: !0,
        // @option bubblingMouseEvents: Boolean = true
        // When `true`, a mouse event on this path will trigger the same event on the map
        // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
        bubblingMouseEvents: !0
      },
      beforeAdd: function(t) {
        this._renderer = t.getRenderer(this);
      },
      onAdd: function() {
        this._renderer._initPath(this), this._reset(), this._renderer._addPath(this);
      },
      onRemove: function() {
        this._renderer._removePath(this);
      },
      // @method redraw(): this
      // Redraws the layer. Sometimes useful after you changed the coordinates that the path uses.
      redraw: function() {
        return this._map && this._renderer._updatePath(this), this;
      },
      // @method setStyle(style: Path options): this
      // Changes the appearance of a Path based on the options in the `Path options` object.
      setStyle: function(t) {
        return U(this, t), this._renderer && (this._renderer._updateStyle(this), this.options.stroke && t && Object.prototype.hasOwnProperty.call(t, "weight") && this._updateBounds()), this;
      },
      // @method bringToFront(): this
      // Brings the layer to the top of all path layers.
      bringToFront: function() {
        return this._renderer && this._renderer._bringToFront(this), this;
      },
      // @method bringToBack(): this
      // Brings the layer to the bottom of all path layers.
      bringToBack: function() {
        return this._renderer && this._renderer._bringToBack(this), this;
      },
      getElement: function() {
        return this._path;
      },
      _reset: function() {
        this._project(), this._update();
      },
      _clickTolerance: function() {
        return (this.options.stroke ? this.options.weight / 2 : 0) + (this._renderer.options.tolerance || 0);
      }
    }), Ti = oe.extend({
      // @section
      // @aka CircleMarker options
      options: {
        fill: !0,
        // @option radius: Number = 10
        // Radius of the circle marker, in pixels
        radius: 10
      },
      initialize: function(t, e) {
        U(this, e), this._latlng = N(t), this._radius = this.options.radius;
      },
      // @method setLatLng(latLng: LatLng): this
      // Sets the position of a circle marker to a new location.
      setLatLng: function(t) {
        var e = this._latlng;
        return this._latlng = N(t), this.redraw(), this.fire("move", { oldLatLng: e, latlng: this._latlng });
      },
      // @method getLatLng(): LatLng
      // Returns the current geographical position of the circle marker
      getLatLng: function() {
        return this._latlng;
      },
      // @method setRadius(radius: Number): this
      // Sets the radius of a circle marker. Units are in pixels.
      setRadius: function(t) {
        return this.options.radius = this._radius = t, this.redraw();
      },
      // @method getRadius(): Number
      // Returns the current radius of the circle
      getRadius: function() {
        return this._radius;
      },
      setStyle: function(t) {
        var e = t && t.radius || this._radius;
        return oe.prototype.setStyle.call(this, t), this.setRadius(e), this;
      },
      _project: function() {
        this._point = this._map.latLngToLayerPoint(this._latlng), this._updateBounds();
      },
      _updateBounds: function() {
        var t = this._radius, e = this._radiusY || t, n = this._clickTolerance(), o = [t + n, e + n];
        this._pxBounds = new J(this._point.subtract(o), this._point.add(o));
      },
      _update: function() {
        this._map && this._updatePath();
      },
      _updatePath: function() {
        this._renderer._updateCircle(this);
      },
      _empty: function() {
        return this._radius && !this._renderer._bounds.intersects(this._pxBounds);
      },
      // Needed by the `Canvas` renderer for interactivity
      _containsPoint: function(t) {
        return t.distanceTo(this._point) <= this._radius + this._clickTolerance();
      }
    });
    function oh(t, e) {
      return new Ti(t, e);
    }
    var Hn = Ti.extend({
      initialize: function(t, e, n) {
        if (typeof e == "number" && (e = u({}, n, { radius: e })), U(this, e), this._latlng = N(t), isNaN(this.options.radius))
          throw new Error("Circle radius cannot be NaN");
        this._mRadius = this.options.radius;
      },
      // @method setRadius(radius: Number): this
      // Sets the radius of a circle. Units are in meters.
      setRadius: function(t) {
        return this._mRadius = t, this.redraw();
      },
      // @method getRadius(): Number
      // Returns the current radius of a circle. Units are in meters.
      getRadius: function() {
        return this._mRadius;
      },
      // @method getBounds(): LatLngBounds
      // Returns the `LatLngBounds` of the path.
      getBounds: function() {
        var t = [this._radius, this._radiusY || this._radius];
        return new _t(
          this._map.layerPointToLatLng(this._point.subtract(t)),
          this._map.layerPointToLatLng(this._point.add(t))
        );
      },
      setStyle: oe.prototype.setStyle,
      _project: function() {
        var t = this._latlng.lng, e = this._latlng.lat, n = this._map, o = n.options.crs;
        if (o.distance === se.distance) {
          var h = Math.PI / 180, l = this._mRadius / se.R / h, f = n.project([e + l, t]), _ = n.project([e - l, t]), m = f.add(_).divideBy(2), p = n.unproject(m).lat, x = Math.acos((Math.cos(l * h) - Math.sin(e * h) * Math.sin(p * h)) / (Math.cos(e * h) * Math.cos(p * h))) / h;
          (isNaN(x) || x === 0) && (x = l / Math.cos(Math.PI / 180 * e)), this._point = m.subtract(n.getPixelOrigin()), this._radius = isNaN(x) ? 0 : m.x - n.project([p, t - x]).x, this._radiusY = m.y - f.y;
        } else {
          var T = o.unproject(o.project(this._latlng).subtract([this._mRadius, 0]));
          this._point = n.latLngToLayerPoint(this._latlng), this._radius = this._point.x - n.latLngToLayerPoint(T).x;
        }
        this._updateBounds();
      }
    });
    function ah(t, e, n) {
      return new Hn(t, e, n);
    }
    var jt = oe.extend({
      // @section
      // @aka Polyline options
      options: {
        // @option smoothFactor: Number = 1.0
        // How much to simplify the polyline on each zoom level. More means
        // better performance and smoother look, and less means more accurate representation.
        smoothFactor: 1,
        // @option noClip: Boolean = false
        // Disable polyline clipping.
        noClip: !1
      },
      initialize: function(t, e) {
        U(this, e), this._setLatLngs(t);
      },
      // @method getLatLngs(): LatLng[]
      // Returns an array of the points in the path, or nested arrays of points in case of multi-polyline.
      getLatLngs: function() {
        return this._latlngs;
      },
      // @method setLatLngs(latlngs: LatLng[]): this
      // Replaces all the points in the polyline with the given array of geographical points.
      setLatLngs: function(t) {
        return this._setLatLngs(t), this.redraw();
      },
      // @method isEmpty(): Boolean
      // Returns `true` if the Polyline has no LatLngs.
      isEmpty: function() {
        return !this._latlngs.length;
      },
      // @method closestLayerPoint(p: Point): Point
      // Returns the point closest to `p` on the Polyline.
      closestLayerPoint: function(t) {
        for (var e = 1 / 0, n = null, o = Je, h, l, f = 0, _ = this._parts.length; f < _; f++)
          for (var m = this._parts[f], p = 1, x = m.length; p < x; p++) {
            h = m[p - 1], l = m[p];
            var T = o(t, h, l, !0);
            T < e && (e = T, n = o(t, h, l));
          }
        return n && (n.distance = Math.sqrt(e)), n;
      },
      // @method getCenter(): LatLng
      // Returns the center ([centroid](https://en.wikipedia.org/wiki/Centroid)) of the polyline.
      getCenter: function() {
        if (!this._map)
          throw new Error("Must add layer to map before using getCenter()");
        return Pr(this._defaultShape(), this._map.options.crs);
      },
      // @method getBounds(): LatLngBounds
      // Returns the `LatLngBounds` of the path.
      getBounds: function() {
        return this._bounds;
      },
      // @method addLatLng(latlng: LatLng, latlngs?: LatLng[]): this
      // Adds a given point to the polyline. By default, adds to the first ring of
      // the polyline in case of a multi-polyline, but can be overridden by passing
      // a specific ring as a LatLng array (that you can earlier access with [`getLatLngs`](#polyline-getlatlngs)).
      addLatLng: function(t, e) {
        return e = e || this._defaultShape(), t = N(t), e.push(t), this._bounds.extend(t), this.redraw();
      },
      _setLatLngs: function(t) {
        this._bounds = new _t(), this._latlngs = this._convertLatLngs(t);
      },
      _defaultShape: function() {
        return Lt(this._latlngs) ? this._latlngs : this._latlngs[0];
      },
      // recursively convert latlngs input into actual LatLng instances; calculate bounds along the way
      _convertLatLngs: function(t) {
        for (var e = [], n = Lt(t), o = 0, h = t.length; o < h; o++)
          n ? (e[o] = N(t[o]), this._bounds.extend(e[o])) : e[o] = this._convertLatLngs(t[o]);
        return e;
      },
      _project: function() {
        var t = new J();
        this._rings = [], this._projectLatlngs(this._latlngs, this._rings, t), this._bounds.isValid() && t.isValid() && (this._rawPxBounds = t, this._updateBounds());
      },
      _updateBounds: function() {
        var t = this._clickTolerance(), e = new O(t, t);
        this._rawPxBounds && (this._pxBounds = new J([
          this._rawPxBounds.min.subtract(e),
          this._rawPxBounds.max.add(e)
        ]));
      },
      // recursively turns latlngs into a set of rings with projected coordinates
      _projectLatlngs: function(t, e, n) {
        var o = t[0] instanceof G, h = t.length, l, f;
        if (o) {
          for (f = [], l = 0; l < h; l++)
            f[l] = this._map.latLngToLayerPoint(t[l]), n.extend(f[l]);
          e.push(f);
        } else
          for (l = 0; l < h; l++)
            this._projectLatlngs(t[l], e, n);
      },
      // clip polyline by renderer bounds so that we have less to render for performance
      _clipPoints: function() {
        var t = this._renderer._bounds;
        if (this._parts = [], !(!this._pxBounds || !this._pxBounds.intersects(t))) {
          if (this.options.noClip) {
            this._parts = this._rings;
            return;
          }
          var e = this._parts, n, o, h, l, f, _, m;
          for (n = 0, h = 0, l = this._rings.length; n < l; n++)
            for (m = this._rings[n], o = 0, f = m.length; o < f - 1; o++)
              _ = wr(m[o], m[o + 1], t, o, !0), _ && (e[h] = e[h] || [], e[h].push(_[0]), (_[1] !== m[o + 1] || o === f - 2) && (e[h].push(_[1]), h++));
        }
      },
      // simplify each clipped part of the polyline for performance
      _simplifyPoints: function() {
        for (var t = this._parts, e = this.options.smoothFactor, n = 0, o = t.length; n < o; n++)
          t[n] = gr(t[n], e);
      },
      _update: function() {
        this._map && (this._clipPoints(), this._simplifyPoints(), this._updatePath());
      },
      _updatePath: function() {
        this._renderer._updatePoly(this);
      },
      // Needed by the `Canvas` renderer for interactivity
      _containsPoint: function(t, e) {
        var n, o, h, l, f, _, m = this._clickTolerance();
        if (!this._pxBounds || !this._pxBounds.contains(t))
          return !1;
        for (n = 0, l = this._parts.length; n < l; n++)
          for (_ = this._parts[n], o = 0, f = _.length, h = f - 1; o < f; h = o++)
            if (!(!e && o === 0) && vr(t, _[h], _[o]) <= m)
              return !0;
        return !1;
      }
    });
    function hh(t, e) {
      return new jt(t, e);
    }
    jt._flat = xr;
    var Se = jt.extend({
      options: {
        fill: !0
      },
      isEmpty: function() {
        return !this._latlngs.length || !this._latlngs[0].length;
      },
      // @method getCenter(): LatLng
      // Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the Polygon.
      getCenter: function() {
        if (!this._map)
          throw new Error("Must add layer to map before using getCenter()");
        return pr(this._defaultShape(), this._map.options.crs);
      },
      _convertLatLngs: function(t) {
        var e = jt.prototype._convertLatLngs.call(this, t), n = e.length;
        return n >= 2 && e[0] instanceof G && e[0].equals(e[n - 1]) && e.pop(), e;
      },
      _setLatLngs: function(t) {
        jt.prototype._setLatLngs.call(this, t), Lt(this._latlngs) && (this._latlngs = [this._latlngs]);
      },
      _defaultShape: function() {
        return Lt(this._latlngs[0]) ? this._latlngs[0] : this._latlngs[0][0];
      },
      _clipPoints: function() {
        var t = this._renderer._bounds, e = this.options.weight, n = new O(e, e);
        if (t = new J(t.min.subtract(n), t.max.add(n)), this._parts = [], !(!this._pxBounds || !this._pxBounds.intersects(t))) {
          if (this.options.noClip) {
            this._parts = this._rings;
            return;
          }
          for (var o = 0, h = this._rings.length, l; o < h; o++)
            l = mr(this._rings[o], t, !0), l.length && this._parts.push(l);
        }
      },
      _updatePath: function() {
        this._renderer._updatePoly(this, !0);
      },
      // Needed by the `Canvas` renderer for interactivity
      _containsPoint: function(t) {
        var e = !1, n, o, h, l, f, _, m, p;
        if (!this._pxBounds || !this._pxBounds.contains(t))
          return !1;
        for (l = 0, m = this._parts.length; l < m; l++)
          for (n = this._parts[l], f = 0, p = n.length, _ = p - 1; f < p; _ = f++)
            o = n[f], h = n[_], o.y > t.y != h.y > t.y && t.x < (h.x - o.x) * (t.y - o.y) / (h.y - o.y) + o.x && (e = !e);
        return e || jt.prototype._containsPoint.call(this, t, !0);
      }
    });
    function uh(t, e) {
      return new Se(t, e);
    }
    var qt = Vt.extend({
      /* @section
       * @aka GeoJSON options
       *
       * @option pointToLayer: Function = *
       * A `Function` defining how GeoJSON points spawn Leaflet layers. It is internally
       * called when data is added, passing the GeoJSON point feature and its `LatLng`.
       * The default is to spawn a default `Marker`:
       * ```js
       * function(geoJsonPoint, latlng) {
       * 	return L.marker(latlng);
       * }
       * ```
       *
       * @option style: Function = *
       * A `Function` defining the `Path options` for styling GeoJSON lines and polygons,
       * called internally when data is added.
       * The default value is to not override any defaults:
       * ```js
       * function (geoJsonFeature) {
       * 	return {}
       * }
       * ```
       *
       * @option onEachFeature: Function = *
       * A `Function` that will be called once for each created `Feature`, after it has
       * been created and styled. Useful for attaching events and popups to features.
       * The default is to do nothing with the newly created layers:
       * ```js
       * function (feature, layer) {}
       * ```
       *
       * @option filter: Function = *
       * A `Function` that will be used to decide whether to include a feature or not.
       * The default is to include all features:
       * ```js
       * function (geoJsonFeature) {
       * 	return true;
       * }
       * ```
       * Note: dynamically changing the `filter` option will have effect only on newly
       * added data. It will _not_ re-evaluate already included features.
       *
       * @option coordsToLatLng: Function = *
       * A `Function` that will be used for converting GeoJSON coordinates to `LatLng`s.
       * The default is the `coordsToLatLng` static method.
       *
       * @option markersInheritOptions: Boolean = false
       * Whether default Markers for "Point" type Features inherit from group options.
       */
      initialize: function(t, e) {
        U(this, e), this._layers = {}, t && this.addData(t);
      },
      // @method addData( <GeoJSON> data ): this
      // Adds a GeoJSON object to the layer.
      addData: function(t) {
        var e = kt(t) ? t : t.features, n, o, h;
        if (e) {
          for (n = 0, o = e.length; n < o; n++)
            h = e[n], (h.geometries || h.geometry || h.features || h.coordinates) && this.addData(h);
          return this;
        }
        var l = this.options;
        if (l.filter && !l.filter(t))
          return this;
        var f = Si(t, l);
        return f ? (f.feature = Ci(t), f.defaultOptions = f.options, this.resetStyle(f), l.onEachFeature && l.onEachFeature(t, f), this.addLayer(f)) : this;
      },
      // @method resetStyle( <Path> layer? ): this
      // Resets the given vector layer's style to the original GeoJSON style, useful for resetting style after hover events.
      // If `layer` is omitted, the style of all features in the current layer is reset.
      resetStyle: function(t) {
        return t === void 0 ? this.eachLayer(this.resetStyle, this) : (t.options = u({}, t.defaultOptions), this._setLayerStyle(t, this.options.style), this);
      },
      // @method setStyle( <Function> style ): this
      // Changes styles of GeoJSON vector layers with the given style function.
      setStyle: function(t) {
        return this.eachLayer(function(e) {
          this._setLayerStyle(e, t);
        }, this);
      },
      _setLayerStyle: function(t, e) {
        t.setStyle && (typeof e == "function" && (e = e(t.feature)), t.setStyle(e));
      }
    });
    function Si(t, e) {
      var n = t.type === "Feature" ? t.geometry : t, o = n ? n.coordinates : null, h = [], l = e && e.pointToLayer, f = e && e.coordsToLatLng || Un, _, m, p, x;
      if (!o && !n)
        return null;
      switch (n.type) {
        case "Point":
          return _ = f(o), br(l, t, _, e);
        case "MultiPoint":
          for (p = 0, x = o.length; p < x; p++)
            _ = f(o[p]), h.push(br(l, t, _, e));
          return new Vt(h);
        case "LineString":
        case "MultiLineString":
          return m = ki(o, n.type === "LineString" ? 0 : 1, f), new jt(m, e);
        case "Polygon":
        case "MultiPolygon":
          return m = ki(o, n.type === "Polygon" ? 1 : 2, f), new Se(m, e);
        case "GeometryCollection":
          for (p = 0, x = n.geometries.length; p < x; p++) {
            var T = Si({
              geometry: n.geometries[p],
              type: "Feature",
              properties: t.properties
            }, e);
            T && h.push(T);
          }
          return new Vt(h);
        case "FeatureCollection":
          for (p = 0, x = n.features.length; p < x; p++) {
            var z = Si(n.features[p], e);
            z && h.push(z);
          }
          return new Vt(h);
        default:
          throw new Error("Invalid GeoJSON object.");
      }
    }
    function br(t, e, n, o) {
      return t ? t(e, n) : new bi(n, o && o.markersInheritOptions && o);
    }
    function Un(t) {
      return new G(t[1], t[0], t[2]);
    }
    function ki(t, e, n) {
      for (var o = [], h = 0, l = t.length, f; h < l; h++)
        f = e ? ki(t[h], e - 1, n) : (n || Un)(t[h]), o.push(f);
      return o;
    }
    function Gn(t, e) {
      return t = N(t), t.alt !== void 0 ? [H(t.lng, e), H(t.lat, e), H(t.alt, e)] : [H(t.lng, e), H(t.lat, e)];
    }
    function Oi(t, e, n, o) {
      for (var h = [], l = 0, f = t.length; l < f; l++)
        h.push(e ? Oi(t[l], Lt(t[l]) ? 0 : e - 1, n, o) : Gn(t[l], o));
      return !e && n && h.length > 0 && h.push(h[0].slice()), h;
    }
    function ke(t, e) {
      return t.feature ? u({}, t.feature, { geometry: e }) : Ci(e);
    }
    function Ci(t) {
      return t.type === "Feature" || t.type === "FeatureCollection" ? t : {
        type: "Feature",
        properties: {},
        geometry: t
      };
    }
    var Vn = {
      toGeoJSON: function(t) {
        return ke(this, {
          type: "Point",
          coordinates: Gn(this.getLatLng(), t)
        });
      }
    };
    bi.include(Vn), Hn.include(Vn), Ti.include(Vn), jt.include({
      toGeoJSON: function(t) {
        var e = !Lt(this._latlngs), n = Oi(this._latlngs, e ? 1 : 0, !1, t);
        return ke(this, {
          type: (e ? "Multi" : "") + "LineString",
          coordinates: n
        });
      }
    }), Se.include({
      toGeoJSON: function(t) {
        var e = !Lt(this._latlngs), n = e && !Lt(this._latlngs[0]), o = Oi(this._latlngs, n ? 2 : e ? 1 : 0, !0, t);
        return e || (o = [o]), ke(this, {
          type: (n ? "Multi" : "") + "Polygon",
          coordinates: o
        });
      }
    }), be.include({
      toMultiPoint: function(t) {
        var e = [];
        return this.eachLayer(function(n) {
          e.push(n.toGeoJSON(t).geometry.coordinates);
        }), ke(this, {
          type: "MultiPoint",
          coordinates: e
        });
      },
      // @method toGeoJSON(precision?: Number|false): Object
      // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
      // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the layer group (as a GeoJSON `FeatureCollection`, `GeometryCollection`, or `MultiPoint`).
      toGeoJSON: function(t) {
        var e = this.feature && this.feature.geometry && this.feature.geometry.type;
        if (e === "MultiPoint")
          return this.toMultiPoint(t);
        var n = e === "GeometryCollection", o = [];
        return this.eachLayer(function(h) {
          if (h.toGeoJSON) {
            var l = h.toGeoJSON(t);
            if (n)
              o.push(l.geometry);
            else {
              var f = Ci(l);
              f.type === "FeatureCollection" ? o.push.apply(o, f.features) : o.push(f);
            }
          }
        }), n ? ke(this, {
          geometries: o,
          type: "GeometryCollection"
        }) : {
          type: "FeatureCollection",
          features: o
        };
      }
    });
    function Tr(t, e) {
      return new qt(t, e);
    }
    var lh = Tr, Di = Ct.extend({
      // @section
      // @aka ImageOverlay options
      options: {
        // @option opacity: Number = 1.0
        // The opacity of the image overlay.
        opacity: 1,
        // @option alt: String = ''
        // Text for the `alt` attribute of the image (useful for accessibility).
        alt: "",
        // @option interactive: Boolean = false
        // If `true`, the image overlay will emit [mouse events](#interactive-layer) when clicked or hovered.
        interactive: !1,
        // @option crossOrigin: Boolean|String = false
        // Whether the crossOrigin attribute will be added to the image.
        // If a String is provided, the image will have its crossOrigin attribute set to the String provided. This is needed if you want to access image pixel data.
        // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
        crossOrigin: !1,
        // @option errorOverlayUrl: String = ''
        // URL to the overlay image to show in place of the overlay that failed to load.
        errorOverlayUrl: "",
        // @option zIndex: Number = 1
        // The explicit [zIndex](https://developer.mozilla.org/docs/Web/CSS/CSS_Positioning/Understanding_z_index) of the overlay layer.
        zIndex: 1,
        // @option className: String = ''
        // A custom class name to assign to the image. Empty by default.
        className: ""
      },
      initialize: function(t, e, n) {
        this._url = t, this._bounds = et(e), U(this, n);
      },
      onAdd: function() {
        this._image || (this._initImage(), this.options.opacity < 1 && this._updateOpacity()), this.options.interactive && (A(this._image, "leaflet-interactive"), this.addInteractiveTarget(this._image)), this.getPane().appendChild(this._image), this._reset();
      },
      onRemove: function() {
        $(this._image), this.options.interactive && this.removeInteractiveTarget(this._image);
      },
      // @method setOpacity(opacity: Number): this
      // Sets the opacity of the overlay.
      setOpacity: function(t) {
        return this.options.opacity = t, this._image && this._updateOpacity(), this;
      },
      setStyle: function(t) {
        return t.opacity && this.setOpacity(t.opacity), this;
      },
      // @method bringToFront(): this
      // Brings the layer to the top of all overlays.
      bringToFront: function() {
        return this._map && Le(this._image), this;
      },
      // @method bringToBack(): this
      // Brings the layer to the bottom of all overlays.
      bringToBack: function() {
        return this._map && Me(this._image), this;
      },
      // @method setUrl(url: String): this
      // Changes the URL of the image.
      setUrl: function(t) {
        return this._url = t, this._image && (this._image.src = t), this;
      },
      // @method setBounds(bounds: LatLngBounds): this
      // Update the bounds that this ImageOverlay covers
      setBounds: function(t) {
        return this._bounds = et(t), this._map && this._reset(), this;
      },
      getEvents: function() {
        var t = {
          zoom: this._reset,
          viewreset: this._reset
        };
        return this._zoomAnimated && (t.zoomanim = this._animateZoom), t;
      },
      // @method setZIndex(value: Number): this
      // Changes the [zIndex](#imageoverlay-zindex) of the image overlay.
      setZIndex: function(t) {
        return this.options.zIndex = t, this._updateZIndex(), this;
      },
      // @method getBounds(): LatLngBounds
      // Get the bounds that this ImageOverlay covers
      getBounds: function() {
        return this._bounds;
      },
      // @method getElement(): HTMLElement
      // Returns the instance of [`HTMLImageElement`](https://developer.mozilla.org/docs/Web/API/HTMLImageElement)
      // used by this overlay.
      getElement: function() {
        return this._image;
      },
      _initImage: function() {
        var t = this._url.tagName === "IMG", e = this._image = t ? this._url : B("img");
        if (A(e, "leaflet-image-layer"), this._zoomAnimated && A(e, "leaflet-zoom-animated"), this.options.className && A(e, this.options.className), e.onselectstart = D, e.onmousemove = D, e.onload = d(this.fire, this, "load"), e.onerror = d(this._overlayOnError, this, "error"), (this.options.crossOrigin || this.options.crossOrigin === "") && (e.crossOrigin = this.options.crossOrigin === !0 ? "" : this.options.crossOrigin), this.options.zIndex && this._updateZIndex(), t) {
          this._url = e.src;
          return;
        }
        e.src = this._url, e.alt = this.options.alt;
      },
      _animateZoom: function(t) {
        var e = this._map.getZoomScale(t.zoom), n = this._map._latLngBoundsToNewLayerBounds(this._bounds, t.zoom, t.center).min;
        ce(this._image, n, e);
      },
      _reset: function() {
        var t = this._image, e = new J(
          this._map.latLngToLayerPoint(this._bounds.getNorthWest()),
          this._map.latLngToLayerPoint(this._bounds.getSouthEast())
        ), n = e.getSize();
        it(t, e.min), t.style.width = n.x + "px", t.style.height = n.y + "px";
      },
      _updateOpacity: function() {
        Pt(this._image, this.options.opacity);
      },
      _updateZIndex: function() {
        this._image && this.options.zIndex !== void 0 && this.options.zIndex !== null && (this._image.style.zIndex = this.options.zIndex);
      },
      _overlayOnError: function() {
        this.fire("error");
        var t = this.options.errorOverlayUrl;
        t && this._url !== t && (this._url = t, this._image.src = t);
      },
      // @method getCenter(): LatLng
      // Returns the center of the ImageOverlay.
      getCenter: function() {
        return this._bounds.getCenter();
      }
    }), ch = function(t, e, n) {
      return new Di(t, e, n);
    }, Sr = Di.extend({
      // @section
      // @aka VideoOverlay options
      options: {
        // @option autoplay: Boolean = true
        // Whether the video starts playing automatically when loaded.
        // On some browsers autoplay will only work with `muted: true`
        autoplay: !0,
        // @option loop: Boolean = true
        // Whether the video will loop back to the beginning when played.
        loop: !0,
        // @option keepAspectRatio: Boolean = true
        // Whether the video will save aspect ratio after the projection.
        // Relevant for supported browsers. See [browser compatibility](https://developer.mozilla.org/en-US/docs/Web/CSS/object-fit)
        keepAspectRatio: !0,
        // @option muted: Boolean = false
        // Whether the video starts on mute when loaded.
        muted: !1,
        // @option playsInline: Boolean = true
        // Mobile browsers will play the video right where it is instead of open it up in fullscreen mode.
        playsInline: !0
      },
      _initImage: function() {
        var t = this._url.tagName === "VIDEO", e = this._image = t ? this._url : B("video");
        if (A(e, "leaflet-image-layer"), this._zoomAnimated && A(e, "leaflet-zoom-animated"), this.options.className && A(e, this.options.className), e.onselectstart = D, e.onmousemove = D, e.onloadeddata = d(this.fire, this, "load"), t) {
          for (var n = e.getElementsByTagName("source"), o = [], h = 0; h < n.length; h++)
            o.push(n[h].src);
          this._url = n.length > 0 ? o : [e.src];
          return;
        }
        kt(this._url) || (this._url = [this._url]), !this.options.keepAspectRatio && Object.prototype.hasOwnProperty.call(e.style, "objectFit") && (e.style.objectFit = "fill"), e.autoplay = !!this.options.autoplay, e.loop = !!this.options.loop, e.muted = !!this.options.muted, e.playsInline = !!this.options.playsInline;
        for (var l = 0; l < this._url.length; l++) {
          var f = B("source");
          f.src = this._url[l], e.appendChild(f);
        }
      }
      // @method getElement(): HTMLVideoElement
      // Returns the instance of [`HTMLVideoElement`](https://developer.mozilla.org/docs/Web/API/HTMLVideoElement)
      // used by this overlay.
    });
    function fh(t, e, n) {
      return new Sr(t, e, n);
    }
    var kr = Di.extend({
      _initImage: function() {
        var t = this._image = this._url;
        A(t, "leaflet-image-layer"), this._zoomAnimated && A(t, "leaflet-zoom-animated"), this.options.className && A(t, this.options.className), t.onselectstart = D, t.onmousemove = D;
      }
      // @method getElement(): SVGElement
      // Returns the instance of [`SVGElement`](https://developer.mozilla.org/docs/Web/API/SVGElement)
      // used by this overlay.
    });
    function dh(t, e, n) {
      return new kr(t, e, n);
    }
    var Bt = Ct.extend({
      // @section
      // @aka DivOverlay options
      options: {
        // @option interactive: Boolean = false
        // If true, the popup/tooltip will listen to the mouse events.
        interactive: !1,
        // @option offset: Point = Point(0, 0)
        // The offset of the overlay position.
        offset: [0, 0],
        // @option className: String = ''
        // A custom CSS class name to assign to the overlay.
        className: "",
        // @option pane: String = undefined
        // `Map pane` where the overlay will be added.
        pane: void 0,
        // @option content: String|HTMLElement|Function = ''
        // Sets the HTML content of the overlay while initializing. If a function is passed the source layer will be
        // passed to the function. The function should return a `String` or `HTMLElement` to be used in the overlay.
        content: ""
      },
      initialize: function(t, e) {
        t && (t instanceof G || kt(t)) ? (this._latlng = N(t), U(this, e)) : (U(this, t), this._source = e), this.options.content && (this._content = this.options.content);
      },
      // @method openOn(map: Map): this
      // Adds the overlay to the map.
      // Alternative to `map.openPopup(popup)`/`.openTooltip(tooltip)`.
      openOn: function(t) {
        return t = arguments.length ? t : this._source._map, t.hasLayer(this) || t.addLayer(this), this;
      },
      // @method close(): this
      // Closes the overlay.
      // Alternative to `map.closePopup(popup)`/`.closeTooltip(tooltip)`
      // and `layer.closePopup()`/`.closeTooltip()`.
      close: function() {
        return this._map && this._map.removeLayer(this), this;
      },
      // @method toggle(layer?: Layer): this
      // Opens or closes the overlay bound to layer depending on its current state.
      // Argument may be omitted only for overlay bound to layer.
      // Alternative to `layer.togglePopup()`/`.toggleTooltip()`.
      toggle: function(t) {
        return this._map ? this.close() : (arguments.length ? this._source = t : t = this._source, this._prepareOpen(), this.openOn(t._map)), this;
      },
      onAdd: function(t) {
        this._zoomAnimated = t._zoomAnimated, this._container || this._initLayout(), t._fadeAnimated && Pt(this._container, 0), clearTimeout(this._removeTimeout), this.getPane().appendChild(this._container), this.update(), t._fadeAnimated && Pt(this._container, 1), this.bringToFront(), this.options.interactive && (A(this._container, "leaflet-interactive"), this.addInteractiveTarget(this._container));
      },
      onRemove: function(t) {
        t._fadeAnimated ? (Pt(this._container, 0), this._removeTimeout = setTimeout(d($, void 0, this._container), 200)) : $(this._container), this.options.interactive && (Q(this._container, "leaflet-interactive"), this.removeInteractiveTarget(this._container));
      },
      // @namespace DivOverlay
      // @method getLatLng: LatLng
      // Returns the geographical point of the overlay.
      getLatLng: function() {
        return this._latlng;
      },
      // @method setLatLng(latlng: LatLng): this
      // Sets the geographical point where the overlay will open.
      setLatLng: function(t) {
        return this._latlng = N(t), this._map && (this._updatePosition(), this._adjustPan()), this;
      },
      // @method getContent: String|HTMLElement
      // Returns the content of the overlay.
      getContent: function() {
        return this._content;
      },
      // @method setContent(htmlContent: String|HTMLElement|Function): this
      // Sets the HTML content of the overlay. If a function is passed the source layer will be passed to the function.
      // The function should return a `String` or `HTMLElement` to be used in the overlay.
      setContent: function(t) {
        return this._content = t, this.update(), this;
      },
      // @method getElement: String|HTMLElement
      // Returns the HTML container of the overlay.
      getElement: function() {
        return this._container;
      },
      // @method update: null
      // Updates the overlay content, layout and position. Useful for updating the overlay after something inside changed, e.g. image loaded.
      update: function() {
        this._map && (this._container.style.visibility = "hidden", this._updateContent(), this._updateLayout(), this._updatePosition(), this._container.style.visibility = "", this._adjustPan());
      },
      getEvents: function() {
        var t = {
          zoom: this._updatePosition,
          viewreset: this._updatePosition
        };
        return this._zoomAnimated && (t.zoomanim = this._animateZoom), t;
      },
      // @method isOpen: Boolean
      // Returns `true` when the overlay is visible on the map.
      isOpen: function() {
        return !!this._map && this._map.hasLayer(this);
      },
      // @method bringToFront: this
      // Brings this overlay in front of other overlays (in the same map pane).
      bringToFront: function() {
        return this._map && Le(this._container), this;
      },
      // @method bringToBack: this
      // Brings this overlay to the back of other overlays (in the same map pane).
      bringToBack: function() {
        return this._map && Me(this._container), this;
      },
      // prepare bound overlay to open: update latlng pos / content source (for FeatureGroup)
      _prepareOpen: function(t) {
        var e = this._source;
        if (!e._map)
          return !1;
        if (e instanceof Vt) {
          e = null;
          var n = this._source._layers;
          for (var o in n)
            if (n[o]._map) {
              e = n[o];
              break;
            }
          if (!e)
            return !1;
          this._source = e;
        }
        if (!t)
          if (e.getCenter)
            t = e.getCenter();
          else if (e.getLatLng)
            t = e.getLatLng();
          else if (e.getBounds)
            t = e.getBounds().getCenter();
          else
            throw new Error("Unable to get source layer LatLng.");
        return this.setLatLng(t), this._map && this.update(), !0;
      },
      _updateContent: function() {
        if (this._content) {
          var t = this._contentNode, e = typeof this._content == "function" ? this._content(this._source || this) : this._content;
          if (typeof e == "string")
            t.innerHTML = e;
          else {
            for (; t.hasChildNodes(); )
              t.removeChild(t.firstChild);
            t.appendChild(e);
          }
          this.fire("contentupdate");
        }
      },
      _updatePosition: function() {
        if (this._map) {
          var t = this._map.latLngToLayerPoint(this._latlng), e = S(this.options.offset), n = this._getAnchor();
          this._zoomAnimated ? it(this._container, t.add(n)) : e = e.add(t).add(n);
          var o = this._containerBottom = -e.y, h = this._containerLeft = -Math.round(this._containerWidth / 2) + e.x;
          this._container.style.bottom = o + "px", this._container.style.left = h + "px";
        }
      },
      _getAnchor: function() {
        return [0, 0];
      }
    });
    R.include({
      _initOverlay: function(t, e, n, o) {
        var h = e;
        return h instanceof t || (h = new t(o).setContent(e)), n && h.setLatLng(n), h;
      }
    }), Ct.include({
      _initOverlay: function(t, e, n, o) {
        var h = n;
        return h instanceof t ? (U(h, o), h._source = this) : (h = e && !o ? e : new t(o, this), h.setContent(n)), h;
      }
    });
    var Ei = Bt.extend({
      // @section
      // @aka Popup options
      options: {
        // @option pane: String = 'popupPane'
        // `Map pane` where the popup will be added.
        pane: "popupPane",
        // @option offset: Point = Point(0, 7)
        // The offset of the popup position.
        offset: [0, 7],
        // @option maxWidth: Number = 300
        // Max width of the popup, in pixels.
        maxWidth: 300,
        // @option minWidth: Number = 50
        // Min width of the popup, in pixels.
        minWidth: 50,
        // @option maxHeight: Number = null
        // If set, creates a scrollable container of the given height
        // inside a popup if its content exceeds it.
        // The scrollable container can be styled using the
        // `leaflet-popup-scrolled` CSS class selector.
        maxHeight: null,
        // @option autoPan: Boolean = true
        // Set it to `false` if you don't want the map to do panning animation
        // to fit the opened popup.
        autoPan: !0,
        // @option autoPanPaddingTopLeft: Point = null
        // The margin between the popup and the top left corner of the map
        // view after autopanning was performed.
        autoPanPaddingTopLeft: null,
        // @option autoPanPaddingBottomRight: Point = null
        // The margin between the popup and the bottom right corner of the map
        // view after autopanning was performed.
        autoPanPaddingBottomRight: null,
        // @option autoPanPadding: Point = Point(5, 5)
        // Equivalent of setting both top left and bottom right autopan padding to the same value.
        autoPanPadding: [5, 5],
        // @option keepInView: Boolean = false
        // Set it to `true` if you want to prevent users from panning the popup
        // off of the screen while it is open.
        keepInView: !1,
        // @option closeButton: Boolean = true
        // Controls the presence of a close button in the popup.
        closeButton: !0,
        // @option autoClose: Boolean = true
        // Set it to `false` if you want to override the default behavior of
        // the popup closing when another popup is opened.
        autoClose: !0,
        // @option closeOnEscapeKey: Boolean = true
        // Set it to `false` if you want to override the default behavior of
        // the ESC key for closing of the popup.
        closeOnEscapeKey: !0,
        // @option closeOnClick: Boolean = *
        // Set it if you want to override the default behavior of the popup closing when user clicks
        // on the map. Defaults to the map's [`closePopupOnClick`](#map-closepopuponclick) option.
        // @option className: String = ''
        // A custom CSS class name to assign to the popup.
        className: ""
      },
      // @namespace Popup
      // @method openOn(map: Map): this
      // Alternative to `map.openPopup(popup)`.
      // Adds the popup to the map and closes the previous one.
      openOn: function(t) {
        return t = arguments.length ? t : this._source._map, !t.hasLayer(this) && t._popup && t._popup.options.autoClose && t.removeLayer(t._popup), t._popup = this, Bt.prototype.openOn.call(this, t);
      },
      onAdd: function(t) {
        Bt.prototype.onAdd.call(this, t), t.fire("popupopen", { popup: this }), this._source && (this._source.fire("popupopen", { popup: this }, !0), this._source instanceof oe || this._source.on("preclick", de));
      },
      onRemove: function(t) {
        Bt.prototype.onRemove.call(this, t), t.fire("popupclose", { popup: this }), this._source && (this._source.fire("popupclose", { popup: this }, !0), this._source instanceof oe || this._source.off("preclick", de));
      },
      getEvents: function() {
        var t = Bt.prototype.getEvents.call(this);
        return (this.options.closeOnClick !== void 0 ? this.options.closeOnClick : this._map.options.closePopupOnClick) && (t.preclick = this.close), this.options.keepInView && (t.moveend = this._adjustPan), t;
      },
      _initLayout: function() {
        var t = "leaflet-popup", e = this._container = B(
          "div",
          t + " " + (this.options.className || "") + " leaflet-zoom-animated"
        ), n = this._wrapper = B("div", t + "-content-wrapper", e);
        if (this._contentNode = B("div", t + "-content", n), Ke(e), In(this._contentNode), C(e, "contextmenu", de), this._tipContainer = B("div", t + "-tip-container", e), this._tip = B("div", t + "-tip", this._tipContainer), this.options.closeButton) {
          var o = this._closeButton = B("a", t + "-close-button", e);
          o.setAttribute("role", "button"), o.setAttribute("aria-label", "Close popup"), o.href = "#close", o.innerHTML = '<span aria-hidden="true">&#215;</span>', C(o, "click", function(h) {
            at(h), this.close();
          }, this);
        }
      },
      _updateLayout: function() {
        var t = this._contentNode, e = t.style;
        e.width = "", e.whiteSpace = "nowrap";
        var n = t.offsetWidth;
        n = Math.min(n, this.options.maxWidth), n = Math.max(n, this.options.minWidth), e.width = n + 1 + "px", e.whiteSpace = "", e.height = "";
        var o = t.offsetHeight, h = this.options.maxHeight, l = "leaflet-popup-scrolled";
        h && o > h ? (e.height = h + "px", A(t, l)) : Q(t, l), this._containerWidth = this._container.offsetWidth;
      },
      _animateZoom: function(t) {
        var e = this._map._latLngToNewLayerPoint(this._latlng, t.zoom, t.center), n = this._getAnchor();
        it(this._container, e.add(n));
      },
      _adjustPan: function() {
        if (this.options.autoPan) {
          if (this._map._panAnim && this._map._panAnim.stop(), this._autopanning) {
            this._autopanning = !1;
            return;
          }
          var t = this._map, e = parseInt(Ge(this._container, "marginBottom"), 10) || 0, n = this._container.offsetHeight + e, o = this._containerWidth, h = new O(this._containerLeft, -n - this._containerBottom);
          h._add(fe(this._container));
          var l = t.layerPointToContainerPoint(h), f = S(this.options.autoPanPadding), _ = S(this.options.autoPanPaddingTopLeft || f), m = S(this.options.autoPanPaddingBottomRight || f), p = t.getSize(), x = 0, T = 0;
          l.x + o + m.x > p.x && (x = l.x + o - p.x + m.x), l.x - x - _.x < 0 && (x = l.x - _.x), l.y + n + m.y > p.y && (T = l.y + n - p.y + m.y), l.y - T - _.y < 0 && (T = l.y - _.y), (x || T) && (this.options.keepInView && (this._autopanning = !0), t.fire("autopanstart").panBy([x, T]));
        }
      },
      _getAnchor: function() {
        return S(this._source && this._source._getPopupAnchor ? this._source._getPopupAnchor() : [0, 0]);
      }
    }), _h = function(t, e) {
      return new Ei(t, e);
    };
    R.mergeOptions({
      closePopupOnClick: !0
    }), R.include({
      // @method openPopup(popup: Popup): this
      // Opens the specified popup while closing the previously opened (to make sure only one is opened at one time for usability).
      // @alternative
      // @method openPopup(content: String|HTMLElement, latlng: LatLng, options?: Popup options): this
      // Creates a popup with the specified content and options and opens it in the given point on a map.
      openPopup: function(t, e, n) {
        return this._initOverlay(Ei, t, e, n).openOn(this), this;
      },
      // @method closePopup(popup?: Popup): this
      // Closes the popup previously opened with [openPopup](#map-openpopup) (or the given one).
      closePopup: function(t) {
        return t = arguments.length ? t : this._popup, t && t.close(), this;
      }
    }), Ct.include({
      // @method bindPopup(content: String|HTMLElement|Function|Popup, options?: Popup options): this
      // Binds a popup to the layer with the passed `content` and sets up the
      // necessary event listeners. If a `Function` is passed it will receive
      // the layer as the first argument and should return a `String` or `HTMLElement`.
      bindPopup: function(t, e) {
        return this._popup = this._initOverlay(Ei, this._popup, t, e), this._popupHandlersAdded || (this.on({
          click: this._openPopup,
          keypress: this._onKeyPress,
          remove: this.closePopup,
          move: this._movePopup
        }), this._popupHandlersAdded = !0), this;
      },
      // @method unbindPopup(): this
      // Removes the popup previously bound with `bindPopup`.
      unbindPopup: function() {
        return this._popup && (this.off({
          click: this._openPopup,
          keypress: this._onKeyPress,
          remove: this.closePopup,
          move: this._movePopup
        }), this._popupHandlersAdded = !1, this._popup = null), this;
      },
      // @method openPopup(latlng?: LatLng): this
      // Opens the bound popup at the specified `latlng` or at the default popup anchor if no `latlng` is passed.
      openPopup: function(t) {
        return this._popup && (this instanceof Vt || (this._popup._source = this), this._popup._prepareOpen(t || this._latlng) && this._popup.openOn(this._map)), this;
      },
      // @method closePopup(): this
      // Closes the popup bound to this layer if it is open.
      closePopup: function() {
        return this._popup && this._popup.close(), this;
      },
      // @method togglePopup(): this
      // Opens or closes the popup bound to this layer depending on its current state.
      togglePopup: function() {
        return this._popup && this._popup.toggle(this), this;
      },
      // @method isPopupOpen(): boolean
      // Returns `true` if the popup bound to this layer is currently open.
      isPopupOpen: function() {
        return this._popup ? this._popup.isOpen() : !1;
      },
      // @method setPopupContent(content: String|HTMLElement|Popup): this
      // Sets the content of the popup bound to this layer.
      setPopupContent: function(t) {
        return this._popup && this._popup.setContent(t), this;
      },
      // @method getPopup(): Popup
      // Returns the popup bound to this layer.
      getPopup: function() {
        return this._popup;
      },
      _openPopup: function(t) {
        if (!(!this._popup || !this._map)) {
          _e(t);
          var e = t.layer || t.target;
          if (this._popup._source === e && !(e instanceof oe)) {
            this._map.hasLayer(this._popup) ? this.closePopup() : this.openPopup(t.latlng);
            return;
          }
          this._popup._source = e, this.openPopup(t.latlng);
        }
      },
      _movePopup: function(t) {
        this._popup.setLatLng(t.latlng);
      },
      _onKeyPress: function(t) {
        t.originalEvent.keyCode === 13 && this._openPopup(t);
      }
    });
    var Ai = Bt.extend({
      // @section
      // @aka Tooltip options
      options: {
        // @option pane: String = 'tooltipPane'
        // `Map pane` where the tooltip will be added.
        pane: "tooltipPane",
        // @option offset: Point = Point(0, 0)
        // Optional offset of the tooltip position.
        offset: [0, 0],
        // @option direction: String = 'auto'
        // Direction where to open the tooltip. Possible values are: `right`, `left`,
        // `top`, `bottom`, `center`, `auto`.
        // `auto` will dynamically switch between `right` and `left` according to the tooltip
        // position on the map.
        direction: "auto",
        // @option permanent: Boolean = false
        // Whether to open the tooltip permanently or only on mouseover.
        permanent: !1,
        // @option sticky: Boolean = false
        // If true, the tooltip will follow the mouse instead of being fixed at the feature center.
        sticky: !1,
        // @option opacity: Number = 0.9
        // Tooltip container opacity.
        opacity: 0.9
      },
      onAdd: function(t) {
        Bt.prototype.onAdd.call(this, t), this.setOpacity(this.options.opacity), t.fire("tooltipopen", { tooltip: this }), this._source && (this.addEventParent(this._source), this._source.fire("tooltipopen", { tooltip: this }, !0));
      },
      onRemove: function(t) {
        Bt.prototype.onRemove.call(this, t), t.fire("tooltipclose", { tooltip: this }), this._source && (this.removeEventParent(this._source), this._source.fire("tooltipclose", { tooltip: this }, !0));
      },
      getEvents: function() {
        var t = Bt.prototype.getEvents.call(this);
        return this.options.permanent || (t.preclick = this.close), t;
      },
      _initLayout: function() {
        var t = "leaflet-tooltip", e = t + " " + (this.options.className || "") + " leaflet-zoom-" + (this._zoomAnimated ? "animated" : "hide");
        this._contentNode = this._container = B("div", e), this._container.setAttribute("role", "tooltip"), this._container.setAttribute("id", "leaflet-tooltip-" + g(this));
      },
      _updateLayout: function() {
      },
      _adjustPan: function() {
      },
      _setPosition: function(t) {
        var e, n, o = this._map, h = this._container, l = o.latLngToContainerPoint(o.getCenter()), f = o.layerPointToContainerPoint(t), _ = this.options.direction, m = h.offsetWidth, p = h.offsetHeight, x = S(this.options.offset), T = this._getAnchor();
        _ === "top" ? (e = m / 2, n = p) : _ === "bottom" ? (e = m / 2, n = 0) : _ === "center" ? (e = m / 2, n = p / 2) : _ === "right" ? (e = 0, n = p / 2) : _ === "left" ? (e = m, n = p / 2) : f.x < l.x ? (_ = "right", e = 0, n = p / 2) : (_ = "left", e = m + (x.x + T.x) * 2, n = p / 2), t = t.subtract(S(e, n, !0)).add(x).add(T), Q(h, "leaflet-tooltip-right"), Q(h, "leaflet-tooltip-left"), Q(h, "leaflet-tooltip-top"), Q(h, "leaflet-tooltip-bottom"), A(h, "leaflet-tooltip-" + _), it(h, t);
      },
      _updatePosition: function() {
        var t = this._map.latLngToLayerPoint(this._latlng);
        this._setPosition(t);
      },
      setOpacity: function(t) {
        this.options.opacity = t, this._container && Pt(this._container, t);
      },
      _animateZoom: function(t) {
        var e = this._map._latLngToNewLayerPoint(this._latlng, t.zoom, t.center);
        this._setPosition(e);
      },
      _getAnchor: function() {
        return S(this._source && this._source._getTooltipAnchor && !this.options.sticky ? this._source._getTooltipAnchor() : [0, 0]);
      }
    }), mh = function(t, e) {
      return new Ai(t, e);
    };
    R.include({
      // @method openTooltip(tooltip: Tooltip): this
      // Opens the specified tooltip.
      // @alternative
      // @method openTooltip(content: String|HTMLElement, latlng: LatLng, options?: Tooltip options): this
      // Creates a tooltip with the specified content and options and open it.
      openTooltip: function(t, e, n) {
        return this._initOverlay(Ai, t, e, n).openOn(this), this;
      },
      // @method closeTooltip(tooltip: Tooltip): this
      // Closes the tooltip given as parameter.
      closeTooltip: function(t) {
        return t.close(), this;
      }
    }), Ct.include({
      // @method bindTooltip(content: String|HTMLElement|Function|Tooltip, options?: Tooltip options): this
      // Binds a tooltip to the layer with the passed `content` and sets up the
      // necessary event listeners. If a `Function` is passed it will receive
      // the layer as the first argument and should return a `String` or `HTMLElement`.
      bindTooltip: function(t, e) {
        return this._tooltip && this.isTooltipOpen() && this.unbindTooltip(), this._tooltip = this._initOverlay(Ai, this._tooltip, t, e), this._initTooltipInteractions(), this._tooltip.options.permanent && this._map && this._map.hasLayer(this) && this.openTooltip(), this;
      },
      // @method unbindTooltip(): this
      // Removes the tooltip previously bound with `bindTooltip`.
      unbindTooltip: function() {
        return this._tooltip && (this._initTooltipInteractions(!0), this.closeTooltip(), this._tooltip = null), this;
      },
      _initTooltipInteractions: function(t) {
        if (!(!t && this._tooltipHandlersAdded)) {
          var e = t ? "off" : "on", n = {
            remove: this.closeTooltip,
            move: this._moveTooltip
          };
          this._tooltip.options.permanent ? n.add = this._openTooltip : (n.mouseover = this._openTooltip, n.mouseout = this.closeTooltip, n.click = this._openTooltip, this._map ? this._addFocusListeners() : n.add = this._addFocusListeners), this._tooltip.options.sticky && (n.mousemove = this._moveTooltip), this[e](n), this._tooltipHandlersAdded = !t;
        }
      },
      // @method openTooltip(latlng?: LatLng): this
      // Opens the bound tooltip at the specified `latlng` or at the default tooltip anchor if no `latlng` is passed.
      openTooltip: function(t) {
        return this._tooltip && (this instanceof Vt || (this._tooltip._source = this), this._tooltip._prepareOpen(t) && (this._tooltip.openOn(this._map), this.getElement ? this._setAriaDescribedByOnLayer(this) : this.eachLayer && this.eachLayer(this._setAriaDescribedByOnLayer, this))), this;
      },
      // @method closeTooltip(): this
      // Closes the tooltip bound to this layer if it is open.
      closeTooltip: function() {
        if (this._tooltip)
          return this._tooltip.close();
      },
      // @method toggleTooltip(): this
      // Opens or closes the tooltip bound to this layer depending on its current state.
      toggleTooltip: function() {
        return this._tooltip && this._tooltip.toggle(this), this;
      },
      // @method isTooltipOpen(): boolean
      // Returns `true` if the tooltip bound to this layer is currently open.
      isTooltipOpen: function() {
        return this._tooltip.isOpen();
      },
      // @method setTooltipContent(content: String|HTMLElement|Tooltip): this
      // Sets the content of the tooltip bound to this layer.
      setTooltipContent: function(t) {
        return this._tooltip && this._tooltip.setContent(t), this;
      },
      // @method getTooltip(): Tooltip
      // Returns the tooltip bound to this layer.
      getTooltip: function() {
        return this._tooltip;
      },
      _addFocusListeners: function() {
        this.getElement ? this._addFocusListenersOnLayer(this) : this.eachLayer && this.eachLayer(this._addFocusListenersOnLayer, this);
      },
      _addFocusListenersOnLayer: function(t) {
        var e = typeof t.getElement == "function" && t.getElement();
        e && (C(e, "focus", function() {
          this._tooltip._source = t, this.openTooltip();
        }, this), C(e, "blur", this.closeTooltip, this));
      },
      _setAriaDescribedByOnLayer: function(t) {
        var e = typeof t.getElement == "function" && t.getElement();
        e && e.setAttribute("aria-describedby", this._tooltip._container.id);
      },
      _openTooltip: function(t) {
        if (!(!this._tooltip || !this._map)) {
          if (this._map.dragging && this._map.dragging.moving() && !this._openOnceFlag) {
            this._openOnceFlag = !0;
            var e = this;
            this._map.once("moveend", function() {
              e._openOnceFlag = !1, e._openTooltip(t);
            });
            return;
          }
          this._tooltip._source = t.layer || t.target, this.openTooltip(this._tooltip.options.sticky ? t.latlng : void 0);
        }
      },
      _moveTooltip: function(t) {
        var e = t.latlng, n, o;
        this._tooltip.options.sticky && t.originalEvent && (n = this._map.mouseEventToContainerPoint(t.originalEvent), o = this._map.containerPointToLayerPoint(n), e = this._map.layerPointToLatLng(o)), this._tooltip.setLatLng(e);
      }
    });
    var Or = Te.extend({
      options: {
        // @section
        // @aka DivIcon options
        iconSize: [12, 12],
        // also can be set through CSS
        // iconAnchor: (Point),
        // popupAnchor: (Point),
        // @option html: String|HTMLElement = ''
        // Custom HTML code to put inside the div element, empty by default. Alternatively,
        // an instance of `HTMLElement`.
        html: !1,
        // @option bgPos: Point = [0, 0]
        // Optional relative position of the background, in pixels
        bgPos: null,
        className: "leaflet-div-icon"
      },
      createIcon: function(t) {
        var e = t && t.tagName === "DIV" ? t : document.createElement("div"), n = this.options;
        if (n.html instanceof Element ? (yi(e), e.appendChild(n.html)) : e.innerHTML = n.html !== !1 ? n.html : "", n.bgPos) {
          var o = S(n.bgPos);
          e.style.backgroundPosition = -o.x + "px " + -o.y + "px";
        }
        return this._setIconStyles(e, "icon"), e;
      },
      createShadow: function() {
        return null;
      }
    });
    function ph(t) {
      return new Or(t);
    }
    Te.Default = $e;
    var Qe = Ct.extend({
      // @section
      // @aka GridLayer options
      options: {
        // @option tileSize: Number|Point = 256
        // Width and height of tiles in the grid. Use a number if width and height are equal, or `L.point(width, height)` otherwise.
        tileSize: 256,
        // @option opacity: Number = 1.0
        // Opacity of the tiles. Can be used in the `createTile()` function.
        opacity: 1,
        // @option updateWhenIdle: Boolean = (depends)
        // Load new tiles only when panning ends.
        // `true` by default on mobile browsers, in order to avoid too many requests and keep smooth navigation.
        // `false` otherwise in order to display new tiles _during_ panning, since it is easy to pan outside the
        // [`keepBuffer`](#gridlayer-keepbuffer) option in desktop browsers.
        updateWhenIdle: M.mobile,
        // @option updateWhenZooming: Boolean = true
        // By default, a smooth zoom animation (during a [touch zoom](#map-touchzoom) or a [`flyTo()`](#map-flyto)) will update grid layers every integer zoom level. Setting this option to `false` will update the grid layer only when the smooth animation ends.
        updateWhenZooming: !0,
        // @option updateInterval: Number = 200
        // Tiles will not update more than once every `updateInterval` milliseconds when panning.
        updateInterval: 200,
        // @option zIndex: Number = 1
        // The explicit zIndex of the tile layer.
        zIndex: 1,
        // @option bounds: LatLngBounds = undefined
        // If set, tiles will only be loaded inside the set `LatLngBounds`.
        bounds: null,
        // @option minZoom: Number = 0
        // The minimum zoom level down to which this layer will be displayed (inclusive).
        minZoom: 0,
        // @option maxZoom: Number = undefined
        // The maximum zoom level up to which this layer will be displayed (inclusive).
        maxZoom: void 0,
        // @option maxNativeZoom: Number = undefined
        // Maximum zoom number the tile source has available. If it is specified,
        // the tiles on all zoom levels higher than `maxNativeZoom` will be loaded
        // from `maxNativeZoom` level and auto-scaled.
        maxNativeZoom: void 0,
        // @option minNativeZoom: Number = undefined
        // Minimum zoom number the tile source has available. If it is specified,
        // the tiles on all zoom levels lower than `minNativeZoom` will be loaded
        // from `minNativeZoom` level and auto-scaled.
        minNativeZoom: void 0,
        // @option noWrap: Boolean = false
        // Whether the layer is wrapped around the antimeridian. If `true`, the
        // GridLayer will only be displayed once at low zoom levels. Has no
        // effect when the [map CRS](#map-crs) doesn't wrap around. Can be used
        // in combination with [`bounds`](#gridlayer-bounds) to prevent requesting
        // tiles outside the CRS limits.
        noWrap: !1,
        // @option pane: String = 'tilePane'
        // `Map pane` where the grid layer will be added.
        pane: "tilePane",
        // @option className: String = ''
        // A custom class name to assign to the tile layer. Empty by default.
        className: "",
        // @option keepBuffer: Number = 2
        // When panning the map, keep this many rows and columns of tiles before unloading them.
        keepBuffer: 2
      },
      initialize: function(t) {
        U(this, t);
      },
      onAdd: function() {
        this._initContainer(), this._levels = {}, this._tiles = {}, this._resetView();
      },
      beforeAdd: function(t) {
        t._addZoomLimit(this);
      },
      onRemove: function(t) {
        this._removeAllTiles(), $(this._container), t._removeZoomLimit(this), this._container = null, this._tileZoom = void 0;
      },
      // @method bringToFront: this
      // Brings the tile layer to the top of all tile layers.
      bringToFront: function() {
        return this._map && (Le(this._container), this._setAutoZIndex(Math.max)), this;
      },
      // @method bringToBack: this
      // Brings the tile layer to the bottom of all tile layers.
      bringToBack: function() {
        return this._map && (Me(this._container), this._setAutoZIndex(Math.min)), this;
      },
      // @method getContainer: HTMLElement
      // Returns the HTML element that contains the tiles for this layer.
      getContainer: function() {
        return this._container;
      },
      // @method setOpacity(opacity: Number): this
      // Changes the [opacity](#gridlayer-opacity) of the grid layer.
      setOpacity: function(t) {
        return this.options.opacity = t, this._updateOpacity(), this;
      },
      // @method setZIndex(zIndex: Number): this
      // Changes the [zIndex](#gridlayer-zindex) of the grid layer.
      setZIndex: function(t) {
        return this.options.zIndex = t, this._updateZIndex(), this;
      },
      // @method isLoading: Boolean
      // Returns `true` if any tile in the grid layer has not finished loading.
      isLoading: function() {
        return this._loading;
      },
      // @method redraw: this
      // Causes the layer to clear all the tiles and request them again.
      redraw: function() {
        if (this._map) {
          this._removeAllTiles();
          var t = this._clampZoom(this._map.getZoom());
          t !== this._tileZoom && (this._tileZoom = t, this._updateLevels()), this._update();
        }
        return this;
      },
      getEvents: function() {
        var t = {
          viewprereset: this._invalidateAll,
          viewreset: this._resetView,
          zoom: this._resetView,
          moveend: this._onMoveEnd
        };
        return this.options.updateWhenIdle || (this._onMove || (this._onMove = k(this._onMoveEnd, this.options.updateInterval, this)), t.move = this._onMove), this._zoomAnimated && (t.zoomanim = this._animateZoom), t;
      },
      // @section Extension methods
      // Layers extending `GridLayer` shall reimplement the following method.
      // @method createTile(coords: Object, done?: Function): HTMLElement
      // Called only internally, must be overridden by classes extending `GridLayer`.
      // Returns the `HTMLElement` corresponding to the given `coords`. If the `done` callback
      // is specified, it must be called when the tile has finished loading and drawing.
      createTile: function() {
        return document.createElement("div");
      },
      // @section
      // @method getTileSize: Point
      // Normalizes the [tileSize option](#gridlayer-tilesize) into a point. Used by the `createTile()` method.
      getTileSize: function() {
        var t = this.options.tileSize;
        return t instanceof O ? t : new O(t, t);
      },
      _updateZIndex: function() {
        this._container && this.options.zIndex !== void 0 && this.options.zIndex !== null && (this._container.style.zIndex = this.options.zIndex);
      },
      _setAutoZIndex: function(t) {
        for (var e = this.getPane().children, n = -t(-1 / 0, 1 / 0), o = 0, h = e.length, l; o < h; o++)
          l = e[o].style.zIndex, e[o] !== this._container && l && (n = t(n, +l));
        isFinite(n) && (this.options.zIndex = n + t(-1, 1), this._updateZIndex());
      },
      _updateOpacity: function() {
        if (this._map && !M.ielt9) {
          Pt(this._container, this.options.opacity);
          var t = +/* @__PURE__ */ new Date(), e = !1, n = !1;
          for (var o in this._tiles) {
            var h = this._tiles[o];
            if (!(!h.current || !h.loaded)) {
              var l = Math.min(1, (t - h.loaded) / 200);
              Pt(h.el, l), l < 1 ? e = !0 : (h.active ? n = !0 : this._onOpaqueTile(h), h.active = !0);
            }
          }
          n && !this._noPrune && this._pruneTiles(), e && (xt(this._fadeFrame), this._fadeFrame = ft(this._updateOpacity, this));
        }
      },
      _onOpaqueTile: D,
      _initContainer: function() {
        this._container || (this._container = B("div", "leaflet-layer " + (this.options.className || "")), this._updateZIndex(), this.options.opacity < 1 && this._updateOpacity(), this.getPane().appendChild(this._container));
      },
      _updateLevels: function() {
        var t = this._tileZoom, e = this.options.maxZoom;
        if (t !== void 0) {
          for (var n in this._levels)
            n = Number(n), this._levels[n].el.children.length || n === t ? (this._levels[n].el.style.zIndex = e - Math.abs(t - n), this._onUpdateLevel(n)) : ($(this._levels[n].el), this._removeTilesAtZoom(n), this._onRemoveLevel(n), delete this._levels[n]);
          var o = this._levels[t], h = this._map;
          return o || (o = this._levels[t] = {}, o.el = B("div", "leaflet-tile-container leaflet-zoom-animated", this._container), o.el.style.zIndex = e, o.origin = h.project(h.unproject(h.getPixelOrigin()), t).round(), o.zoom = t, this._setZoomTransform(o, h.getCenter(), h.getZoom()), D(o.el.offsetWidth), this._onCreateLevel(o)), this._level = o, o;
        }
      },
      _onUpdateLevel: D,
      _onRemoveLevel: D,
      _onCreateLevel: D,
      _pruneTiles: function() {
        if (this._map) {
          var t, e, n = this._map.getZoom();
          if (n > this.options.maxZoom || n < this.options.minZoom) {
            this._removeAllTiles();
            return;
          }
          for (t in this._tiles)
            e = this._tiles[t], e.retain = e.current;
          for (t in this._tiles)
            if (e = this._tiles[t], e.current && !e.active) {
              var o = e.coords;
              this._retainParent(o.x, o.y, o.z, o.z - 5) || this._retainChildren(o.x, o.y, o.z, o.z + 2);
            }
          for (t in this._tiles)
            this._tiles[t].retain || this._removeTile(t);
        }
      },
      _removeTilesAtZoom: function(t) {
        for (var e in this._tiles)
          this._tiles[e].coords.z === t && this._removeTile(e);
      },
      _removeAllTiles: function() {
        for (var t in this._tiles)
          this._removeTile(t);
      },
      _invalidateAll: function() {
        for (var t in this._levels)
          $(this._levels[t].el), this._onRemoveLevel(Number(t)), delete this._levels[t];
        this._removeAllTiles(), this._tileZoom = void 0;
      },
      _retainParent: function(t, e, n, o) {
        var h = Math.floor(t / 2), l = Math.floor(e / 2), f = n - 1, _ = new O(+h, +l);
        _.z = +f;
        var m = this._tileCoordsToKey(_), p = this._tiles[m];
        return p && p.active ? (p.retain = !0, !0) : (p && p.loaded && (p.retain = !0), f > o ? this._retainParent(h, l, f, o) : !1);
      },
      _retainChildren: function(t, e, n, o) {
        for (var h = 2 * t; h < 2 * t + 2; h++)
          for (var l = 2 * e; l < 2 * e + 2; l++) {
            var f = new O(h, l);
            f.z = n + 1;
            var _ = this._tileCoordsToKey(f), m = this._tiles[_];
            if (m && m.active) {
              m.retain = !0;
              continue;
            } else
              m && m.loaded && (m.retain = !0);
            n + 1 < o && this._retainChildren(h, l, n + 1, o);
          }
      },
      _resetView: function(t) {
        var e = t && (t.pinch || t.flyTo);
        this._setView(this._map.getCenter(), this._map.getZoom(), e, e);
      },
      _animateZoom: function(t) {
        this._setView(t.center, t.zoom, !0, t.noUpdate);
      },
      _clampZoom: function(t) {
        var e = this.options;
        return e.minNativeZoom !== void 0 && t < e.minNativeZoom ? e.minNativeZoom : e.maxNativeZoom !== void 0 && e.maxNativeZoom < t ? e.maxNativeZoom : t;
      },
      _setView: function(t, e, n, o) {
        var h = Math.round(e);
        this.options.maxZoom !== void 0 && h > this.options.maxZoom || this.options.minZoom !== void 0 && h < this.options.minZoom ? h = void 0 : h = this._clampZoom(h);
        var l = this.options.updateWhenZooming && h !== this._tileZoom;
        (!o || l) && (this._tileZoom = h, this._abortLoading && this._abortLoading(), this._updateLevels(), this._resetGrid(), h !== void 0 && this._update(t), n || this._pruneTiles(), this._noPrune = !!n), this._setZoomTransforms(t, e);
      },
      _setZoomTransforms: function(t, e) {
        for (var n in this._levels)
          this._setZoomTransform(this._levels[n], t, e);
      },
      _setZoomTransform: function(t, e, n) {
        var o = this._map.getZoomScale(n, t.zoom), h = t.origin.multiplyBy(o).subtract(this._map._getNewPixelOrigin(e, n)).round();
        M.any3d ? ce(t.el, h, o) : it(t.el, h);
      },
      _resetGrid: function() {
        var t = this._map, e = t.options.crs, n = this._tileSize = this.getTileSize(), o = this._tileZoom, h = this._map.getPixelWorldBounds(this._tileZoom);
        h && (this._globalTileRange = this._pxBoundsToTileRange(h)), this._wrapX = e.wrapLng && !this.options.noWrap && [
          Math.floor(t.project([0, e.wrapLng[0]], o).x / n.x),
          Math.ceil(t.project([0, e.wrapLng[1]], o).x / n.y)
        ], this._wrapY = e.wrapLat && !this.options.noWrap && [
          Math.floor(t.project([e.wrapLat[0], 0], o).y / n.x),
          Math.ceil(t.project([e.wrapLat[1], 0], o).y / n.y)
        ];
      },
      _onMoveEnd: function() {
        !this._map || this._map._animatingZoom || this._update();
      },
      _getTiledPixelBounds: function(t) {
        var e = this._map, n = e._animatingZoom ? Math.max(e._animateToZoom, e.getZoom()) : e.getZoom(), o = e.getZoomScale(n, this._tileZoom), h = e.project(t, this._tileZoom).floor(), l = e.getSize().divideBy(o * 2);
        return new J(h.subtract(l), h.add(l));
      },
      // Private method to load tiles in the grid's active zoom level according to map bounds
      _update: function(t) {
        var e = this._map;
        if (e) {
          var n = this._clampZoom(e.getZoom());
          if (t === void 0 && (t = e.getCenter()), this._tileZoom !== void 0) {
            var o = this._getTiledPixelBounds(t), h = this._pxBoundsToTileRange(o), l = h.getCenter(), f = [], _ = this.options.keepBuffer, m = new J(
              h.getBottomLeft().subtract([_, -_]),
              h.getTopRight().add([_, -_])
            );
            if (!(isFinite(h.min.x) && isFinite(h.min.y) && isFinite(h.max.x) && isFinite(h.max.y)))
              throw new Error("Attempted to load an infinite number of tiles");
            for (var p in this._tiles) {
              var x = this._tiles[p].coords;
              (x.z !== this._tileZoom || !m.contains(new O(x.x, x.y))) && (this._tiles[p].current = !1);
            }
            if (Math.abs(n - this._tileZoom) > 1) {
              this._setView(t, n);
              return;
            }
            for (var T = h.min.y; T <= h.max.y; T++)
              for (var z = h.min.x; z <= h.max.x; z++) {
                var ct = new O(z, T);
                if (ct.z = this._tileZoom, !!this._isValidTile(ct)) {
                  var ot = this._tiles[this._tileCoordsToKey(ct)];
                  ot ? ot.current = !0 : f.push(ct);
                }
              }
            if (f.sort(function(mt, Ce) {
              return mt.distanceTo(l) - Ce.distanceTo(l);
            }), f.length !== 0) {
              this._loading || (this._loading = !0, this.fire("loading"));
              var Mt = document.createDocumentFragment();
              for (z = 0; z < f.length; z++)
                this._addTile(f[z], Mt);
              this._level.el.appendChild(Mt);
            }
          }
        }
      },
      _isValidTile: function(t) {
        var e = this._map.options.crs;
        if (!e.infinite) {
          var n = this._globalTileRange;
          if (!e.wrapLng && (t.x < n.min.x || t.x > n.max.x) || !e.wrapLat && (t.y < n.min.y || t.y > n.max.y))
            return !1;
        }
        if (!this.options.bounds)
          return !0;
        var o = this._tileCoordsToBounds(t);
        return et(this.options.bounds).overlaps(o);
      },
      _keyToBounds: function(t) {
        return this._tileCoordsToBounds(this._keyToTileCoords(t));
      },
      _tileCoordsToNwSe: function(t) {
        var e = this._map, n = this.getTileSize(), o = t.scaleBy(n), h = o.add(n), l = e.unproject(o, t.z), f = e.unproject(h, t.z);
        return [l, f];
      },
      // converts tile coordinates to its geographical bounds
      _tileCoordsToBounds: function(t) {
        var e = this._tileCoordsToNwSe(t), n = new _t(e[0], e[1]);
        return this.options.noWrap || (n = this._map.wrapLatLngBounds(n)), n;
      },
      // converts tile coordinates to key for the tile cache
      _tileCoordsToKey: function(t) {
        return t.x + ":" + t.y + ":" + t.z;
      },
      // converts tile cache key to coordinates
      _keyToTileCoords: function(t) {
        var e = t.split(":"), n = new O(+e[0], +e[1]);
        return n.z = +e[2], n;
      },
      _removeTile: function(t) {
        var e = this._tiles[t];
        e && ($(e.el), delete this._tiles[t], this.fire("tileunload", {
          tile: e.el,
          coords: this._keyToTileCoords(t)
        }));
      },
      _initTile: function(t) {
        A(t, "leaflet-tile");
        var e = this.getTileSize();
        t.style.width = e.x + "px", t.style.height = e.y + "px", t.onselectstart = D, t.onmousemove = D, M.ielt9 && this.options.opacity < 1 && Pt(t, this.options.opacity);
      },
      _addTile: function(t, e) {
        var n = this._getTilePos(t), o = this._tileCoordsToKey(t), h = this.createTile(this._wrapCoords(t), d(this._tileReady, this, t));
        this._initTile(h), this.createTile.length < 2 && ft(d(this._tileReady, this, t, null, h)), it(h, n), this._tiles[o] = {
          el: h,
          coords: t,
          current: !0
        }, e.appendChild(h), this.fire("tileloadstart", {
          tile: h,
          coords: t
        });
      },
      _tileReady: function(t, e, n) {
        e && this.fire("tileerror", {
          error: e,
          tile: n,
          coords: t
        });
        var o = this._tileCoordsToKey(t);
        n = this._tiles[o], n && (n.loaded = +/* @__PURE__ */ new Date(), this._map._fadeAnimated ? (Pt(n.el, 0), xt(this._fadeFrame), this._fadeFrame = ft(this._updateOpacity, this)) : (n.active = !0, this._pruneTiles()), e || (A(n.el, "leaflet-tile-loaded"), this.fire("tileload", {
          tile: n.el,
          coords: t
        })), this._noTilesToLoad() && (this._loading = !1, this.fire("load"), M.ielt9 || !this._map._fadeAnimated ? ft(this._pruneTiles, this) : setTimeout(d(this._pruneTiles, this), 250)));
      },
      _getTilePos: function(t) {
        return t.scaleBy(this.getTileSize()).subtract(this._level.origin);
      },
      _wrapCoords: function(t) {
        var e = new O(
          this._wrapX ? F(t.x, this._wrapX) : t.x,
          this._wrapY ? F(t.y, this._wrapY) : t.y
        );
        return e.z = t.z, e;
      },
      _pxBoundsToTileRange: function(t) {
        var e = this.getTileSize();
        return new J(
          t.min.unscaleBy(e).floor(),
          t.max.unscaleBy(e).ceil().subtract([1, 1])
        );
      },
      _noTilesToLoad: function() {
        for (var t in this._tiles)
          if (!this._tiles[t].loaded)
            return !1;
        return !0;
      }
    });
    function gh(t) {
      return new Qe(t);
    }
    var Oe = Qe.extend({
      // @section
      // @aka TileLayer options
      options: {
        // @option minZoom: Number = 0
        // The minimum zoom level down to which this layer will be displayed (inclusive).
        minZoom: 0,
        // @option maxZoom: Number = 18
        // The maximum zoom level up to which this layer will be displayed (inclusive).
        maxZoom: 18,
        // @option subdomains: String|String[] = 'abc'
        // Subdomains of the tile service. Can be passed in the form of one string (where each letter is a subdomain name) or an array of strings.
        subdomains: "abc",
        // @option errorTileUrl: String = ''
        // URL to the tile image to show in place of the tile that failed to load.
        errorTileUrl: "",
        // @option zoomOffset: Number = 0
        // The zoom number used in tile URLs will be offset with this value.
        zoomOffset: 0,
        // @option tms: Boolean = false
        // If `true`, inverses Y axis numbering for tiles (turn this on for [TMS](https://en.wikipedia.org/wiki/Tile_Map_Service) services).
        tms: !1,
        // @option zoomReverse: Boolean = false
        // If set to true, the zoom number used in tile URLs will be reversed (`maxZoom - zoom` instead of `zoom`)
        zoomReverse: !1,
        // @option detectRetina: Boolean = false
        // If `true` and user is on a retina display, it will request four tiles of half the specified size and a bigger zoom level in place of one to utilize the high resolution.
        detectRetina: !1,
        // @option crossOrigin: Boolean|String = false
        // Whether the crossOrigin attribute will be added to the tiles.
        // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
        // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
        crossOrigin: !1,
        // @option referrerPolicy: Boolean|String = false
        // Whether the referrerPolicy attribute will be added to the tiles.
        // If a String is provided, all tiles will have their referrerPolicy attribute set to the String provided.
        // This may be needed if your map's rendering context has a strict default but your tile provider expects a valid referrer
        // (e.g. to validate an API token).
        // Refer to [HTMLImageElement.referrerPolicy](https://developer.mozilla.org/en-US/docs/Web/API/HTMLImageElement/referrerPolicy) for valid String values.
        referrerPolicy: !1
      },
      initialize: function(t, e) {
        this._url = t, e = U(this, e), e.detectRetina && M.retina && e.maxZoom > 0 ? (e.tileSize = Math.floor(e.tileSize / 2), e.zoomReverse ? (e.zoomOffset--, e.minZoom = Math.min(e.maxZoom, e.minZoom + 1)) : (e.zoomOffset++, e.maxZoom = Math.max(e.minZoom, e.maxZoom - 1)), e.minZoom = Math.max(0, e.minZoom)) : e.zoomReverse ? e.minZoom = Math.min(e.maxZoom, e.minZoom) : e.maxZoom = Math.max(e.minZoom, e.maxZoom), typeof e.subdomains == "string" && (e.subdomains = e.subdomains.split("")), this.on("tileunload", this._onTileRemove);
      },
      // @method setUrl(url: String, noRedraw?: Boolean): this
      // Updates the layer's URL template and redraws it (unless `noRedraw` is set to `true`).
      // If the URL does not change, the layer will not be redrawn unless
      // the noRedraw parameter is set to false.
      setUrl: function(t, e) {
        return this._url === t && e === void 0 && (e = !0), this._url = t, e || this.redraw(), this;
      },
      // @method createTile(coords: Object, done?: Function): HTMLElement
      // Called only internally, overrides GridLayer's [`createTile()`](#gridlayer-createtile)
      // to return an `<img>` HTML element with the appropriate image URL given `coords`. The `done`
      // callback is called when the tile has been loaded.
      createTile: function(t, e) {
        var n = document.createElement("img");
        return C(n, "load", d(this._tileOnLoad, this, e, n)), C(n, "error", d(this._tileOnError, this, e, n)), (this.options.crossOrigin || this.options.crossOrigin === "") && (n.crossOrigin = this.options.crossOrigin === !0 ? "" : this.options.crossOrigin), typeof this.options.referrerPolicy == "string" && (n.referrerPolicy = this.options.referrerPolicy), n.alt = "", n.src = this.getTileUrl(t), n;
      },
      // @section Extension methods
      // @uninheritable
      // Layers extending `TileLayer` might reimplement the following method.
      // @method getTileUrl(coords: Object): String
      // Called only internally, returns the URL for a tile given its coordinates.
      // Classes extending `TileLayer` can override this function to provide custom tile URL naming schemes.
      getTileUrl: function(t) {
        var e = {
          r: M.retina ? "@2x" : "",
          s: this._getSubdomain(t),
          x: t.x,
          y: t.y,
          z: this._getZoomForUrl()
        };
        if (this._map && !this._map.options.crs.infinite) {
          var n = this._globalTileRange.max.y - t.y;
          this.options.tms && (e.y = n), e["-y"] = n;
        }
        return le(this._url, u(e, this.options));
      },
      _tileOnLoad: function(t, e) {
        M.ielt9 ? setTimeout(d(t, this, null, e), 0) : t(null, e);
      },
      _tileOnError: function(t, e, n) {
        var o = this.options.errorTileUrl;
        o && e.getAttribute("src") !== o && (e.src = o), t(n, e);
      },
      _onTileRemove: function(t) {
        t.tile.onload = null;
      },
      _getZoomForUrl: function() {
        var t = this._tileZoom, e = this.options.maxZoom, n = this.options.zoomReverse, o = this.options.zoomOffset;
        return n && (t = e - t), t + o;
      },
      _getSubdomain: function(t) {
        var e = Math.abs(t.x + t.y) % this.options.subdomains.length;
        return this.options.subdomains[e];
      },
      // stops loading all tiles in the background layer
      _abortLoading: function() {
        var t, e;
        for (t in this._tiles)
          if (this._tiles[t].coords.z !== this._tileZoom && (e = this._tiles[t].el, e.onload = D, e.onerror = D, !e.complete)) {
            e.src = pi;
            var n = this._tiles[t].coords;
            $(e), delete this._tiles[t], this.fire("tileabort", {
              tile: e,
              coords: n
            });
          }
      },
      _removeTile: function(t) {
        var e = this._tiles[t];
        if (e)
          return e.el.setAttribute("src", pi), Qe.prototype._removeTile.call(this, t);
      },
      _tileReady: function(t, e, n) {
        if (!(!this._map || n && n.getAttribute("src") === pi))
          return Qe.prototype._tileReady.call(this, t, e, n);
      }
    });
    function Cr(t, e) {
      return new Oe(t, e);
    }
    var Dr = Oe.extend({
      // @section
      // @aka TileLayer.WMS options
      // If any custom options not documented here are used, they will be sent to the
      // WMS server as extra parameters in each request URL. This can be useful for
      // [non-standard vendor WMS parameters](https://docs.geoserver.org/stable/en/user/services/wms/vendor.html).
      defaultWmsParams: {
        service: "WMS",
        request: "GetMap",
        // @option layers: String = ''
        // **(required)** Comma-separated list of WMS layers to show.
        layers: "",
        // @option styles: String = ''
        // Comma-separated list of WMS styles.
        styles: "",
        // @option format: String = 'image/jpeg'
        // WMS image format (use `'image/png'` for layers with transparency).
        format: "image/jpeg",
        // @option transparent: Boolean = false
        // If `true`, the WMS service will return images with transparency.
        transparent: !1,
        // @option version: String = '1.1.1'
        // Version of the WMS service to use
        version: "1.1.1"
      },
      options: {
        // @option crs: CRS = null
        // Coordinate Reference System to use for the WMS requests, defaults to
        // map CRS. Don't change this if you're not sure what it means.
        crs: null,
        // @option uppercase: Boolean = false
        // If `true`, WMS request parameter keys will be uppercase.
        uppercase: !1
      },
      initialize: function(t, e) {
        this._url = t;
        var n = u({}, this.defaultWmsParams);
        for (var o in e)
          o in this.options || (n[o] = e[o]);
        e = U(this, e);
        var h = e.detectRetina && M.retina ? 2 : 1, l = this.getTileSize();
        n.width = l.x * h, n.height = l.y * h, this.wmsParams = n;
      },
      onAdd: function(t) {
        this._crs = this.options.crs || t.options.crs, this._wmsVersion = parseFloat(this.wmsParams.version);
        var e = this._wmsVersion >= 1.3 ? "crs" : "srs";
        this.wmsParams[e] = this._crs.code, Oe.prototype.onAdd.call(this, t);
      },
      getTileUrl: function(t) {
        var e = this._tileCoordsToNwSe(t), n = this._crs, o = dt(n.project(e[0]), n.project(e[1])), h = o.min, l = o.max, f = (this._wmsVersion >= 1.3 && this._crs === Lr ? [h.y, h.x, l.y, l.x] : [h.x, h.y, l.x, l.y]).join(","), _ = Oe.prototype.getTileUrl.call(this, t);
        return _ + _i(this.wmsParams, _, this.options.uppercase) + (this.options.uppercase ? "&BBOX=" : "&bbox=") + f;
      },
      // @method setParams(params: Object, noRedraw?: Boolean): this
      // Merges an object with the new parameters and re-requests tiles on the current screen (unless `noRedraw` was set to true).
      setParams: function(t, e) {
        return u(this.wmsParams, t), e || this.redraw(), this;
      }
    });
    function vh(t, e) {
      return new Dr(t, e);
    }
    Oe.WMS = Dr, Cr.wms = vh;
    var Kt = Ct.extend({
      // @section
      // @aka Renderer options
      options: {
        // @option padding: Number = 0.1
        // How much to extend the clip area around the map view (relative to its size)
        // e.g. 0.1 would be 10% of map view in each direction
        padding: 0.1
      },
      initialize: function(t) {
        U(this, t), g(this), this._layers = this._layers || {};
      },
      onAdd: function() {
        this._container || (this._initContainer(), A(this._container, "leaflet-zoom-animated")), this.getPane().appendChild(this._container), this._update(), this.on("update", this._updatePaths, this);
      },
      onRemove: function() {
        this.off("update", this._updatePaths, this), this._destroyContainer();
      },
      getEvents: function() {
        var t = {
          viewreset: this._reset,
          zoom: this._onZoom,
          moveend: this._update,
          zoomend: this._onZoomEnd
        };
        return this._zoomAnimated && (t.zoomanim = this._onAnimZoom), t;
      },
      _onAnimZoom: function(t) {
        this._updateTransform(t.center, t.zoom);
      },
      _onZoom: function() {
        this._updateTransform(this._map.getCenter(), this._map.getZoom());
      },
      _updateTransform: function(t, e) {
        var n = this._map.getZoomScale(e, this._zoom), o = this._map.getSize().multiplyBy(0.5 + this.options.padding), h = this._map.project(this._center, e), l = o.multiplyBy(-n).add(h).subtract(this._map._getNewPixelOrigin(t, e));
        M.any3d ? ce(this._container, l, n) : it(this._container, l);
      },
      _reset: function() {
        this._update(), this._updateTransform(this._center, this._zoom);
        for (var t in this._layers)
          this._layers[t]._reset();
      },
      _onZoomEnd: function() {
        for (var t in this._layers)
          this._layers[t]._project();
      },
      _updatePaths: function() {
        for (var t in this._layers)
          this._layers[t]._update();
      },
      _update: function() {
        var t = this.options.padding, e = this._map.getSize(), n = this._map.containerPointToLayerPoint(e.multiplyBy(-t)).round();
        this._bounds = new J(n, n.add(e.multiplyBy(1 + t * 2)).round()), this._center = this._map.getCenter(), this._zoom = this._map.getZoom();
      }
    }), Er = Kt.extend({
      // @section
      // @aka Canvas options
      options: {
        // @option tolerance: Number = 0
        // How much to extend the click tolerance around a path/object on the map.
        tolerance: 0
      },
      getEvents: function() {
        var t = Kt.prototype.getEvents.call(this);
        return t.viewprereset = this._onViewPreReset, t;
      },
      _onViewPreReset: function() {
        this._postponeUpdatePaths = !0;
      },
      onAdd: function() {
        Kt.prototype.onAdd.call(this), this._draw();
      },
      _initContainer: function() {
        var t = this._container = document.createElement("canvas");
        C(t, "mousemove", this._onMouseMove, this), C(t, "click dblclick mousedown mouseup contextmenu", this._onClick, this), C(t, "mouseout", this._handleMouseOut, this), t._leaflet_disable_events = !0, this._ctx = t.getContext("2d");
      },
      _destroyContainer: function() {
        xt(this._redrawRequest), delete this._ctx, $(this._container), j(this._container), delete this._container;
      },
      _updatePaths: function() {
        if (!this._postponeUpdatePaths) {
          var t;
          this._redrawBounds = null;
          for (var e in this._layers)
            t = this._layers[e], t._update();
          this._redraw();
        }
      },
      _update: function() {
        if (!(this._map._animatingZoom && this._bounds)) {
          Kt.prototype._update.call(this);
          var t = this._bounds, e = this._container, n = t.getSize(), o = M.retina ? 2 : 1;
          it(e, t.min), e.width = o * n.x, e.height = o * n.y, e.style.width = n.x + "px", e.style.height = n.y + "px", M.retina && this._ctx.scale(2, 2), this._ctx.translate(-t.min.x, -t.min.y), this.fire("update");
        }
      },
      _reset: function() {
        Kt.prototype._reset.call(this), this._postponeUpdatePaths && (this._postponeUpdatePaths = !1, this._updatePaths());
      },
      _initPath: function(t) {
        this._updateDashArray(t), this._layers[g(t)] = t;
        var e = t._order = {
          layer: t,
          prev: this._drawLast,
          next: null
        };
        this._drawLast && (this._drawLast.next = e), this._drawLast = e, this._drawFirst = this._drawFirst || this._drawLast;
      },
      _addPath: function(t) {
        this._requestRedraw(t);
      },
      _removePath: function(t) {
        var e = t._order, n = e.next, o = e.prev;
        n ? n.prev = o : this._drawLast = o, o ? o.next = n : this._drawFirst = n, delete t._order, delete this._layers[g(t)], this._requestRedraw(t);
      },
      _updatePath: function(t) {
        this._extendRedrawBounds(t), t._project(), t._update(), this._requestRedraw(t);
      },
      _updateStyle: function(t) {
        this._updateDashArray(t), this._requestRedraw(t);
      },
      _updateDashArray: function(t) {
        if (typeof t.options.dashArray == "string") {
          var e = t.options.dashArray.split(/[, ]+/), n = [], o, h;
          for (h = 0; h < e.length; h++) {
            if (o = Number(e[h]), isNaN(o))
              return;
            n.push(o);
          }
          t.options._dashArray = n;
        } else
          t.options._dashArray = t.options.dashArray;
      },
      _requestRedraw: function(t) {
        this._map && (this._extendRedrawBounds(t), this._redrawRequest = this._redrawRequest || ft(this._redraw, this));
      },
      _extendRedrawBounds: function(t) {
        if (t._pxBounds) {
          var e = (t.options.weight || 0) + 1;
          this._redrawBounds = this._redrawBounds || new J(), this._redrawBounds.extend(t._pxBounds.min.subtract([e, e])), this._redrawBounds.extend(t._pxBounds.max.add([e, e]));
        }
      },
      _redraw: function() {
        this._redrawRequest = null, this._redrawBounds && (this._redrawBounds.min._floor(), this._redrawBounds.max._ceil()), this._clear(), this._draw(), this._redrawBounds = null;
      },
      _clear: function() {
        var t = this._redrawBounds;
        if (t) {
          var e = t.getSize();
          this._ctx.clearRect(t.min.x, t.min.y, e.x, e.y);
        } else
          this._ctx.save(), this._ctx.setTransform(1, 0, 0, 1, 0, 0), this._ctx.clearRect(0, 0, this._container.width, this._container.height), this._ctx.restore();
      },
      _draw: function() {
        var t, e = this._redrawBounds;
        if (this._ctx.save(), e) {
          var n = e.getSize();
          this._ctx.beginPath(), this._ctx.rect(e.min.x, e.min.y, n.x, n.y), this._ctx.clip();
        }
        this._drawing = !0;
        for (var o = this._drawFirst; o; o = o.next)
          t = o.layer, (!e || t._pxBounds && t._pxBounds.intersects(e)) && t._updatePath();
        this._drawing = !1, this._ctx.restore();
      },
      _updatePoly: function(t, e) {
        if (this._drawing) {
          var n, o, h, l, f = t._parts, _ = f.length, m = this._ctx;
          if (_) {
            for (m.beginPath(), n = 0; n < _; n++) {
              for (o = 0, h = f[n].length; o < h; o++)
                l = f[n][o], m[o ? "lineTo" : "moveTo"](l.x, l.y);
              e && m.closePath();
            }
            this._fillStroke(m, t);
          }
        }
      },
      _updateCircle: function(t) {
        if (!(!this._drawing || t._empty())) {
          var e = t._point, n = this._ctx, o = Math.max(Math.round(t._radius), 1), h = (Math.max(Math.round(t._radiusY), 1) || o) / o;
          h !== 1 && (n.save(), n.scale(1, h)), n.beginPath(), n.arc(e.x, e.y / h, o, 0, Math.PI * 2, !1), h !== 1 && n.restore(), this._fillStroke(n, t);
        }
      },
      _fillStroke: function(t, e) {
        var n = e.options;
        n.fill && (t.globalAlpha = n.fillOpacity, t.fillStyle = n.fillColor || n.color, t.fill(n.fillRule || "evenodd")), n.stroke && n.weight !== 0 && (t.setLineDash && t.setLineDash(e.options && e.options._dashArray || []), t.globalAlpha = n.opacity, t.lineWidth = n.weight, t.strokeStyle = n.color, t.lineCap = n.lineCap, t.lineJoin = n.lineJoin, t.stroke());
      },
      // Canvas obviously doesn't have mouse events for individual drawn objects,
      // so we emulate that by calculating what's under the mouse on mousemove/click manually
      _onClick: function(t) {
        for (var e = this._map.mouseEventToLayerPoint(t), n, o, h = this._drawFirst; h; h = h.next)
          n = h.layer, n.options.interactive && n._containsPoint(e) && (!(t.type === "click" || t.type === "preclick") || !this._map._draggableMoved(n)) && (o = n);
        this._fireEvent(o ? [o] : !1, t);
      },
      _onMouseMove: function(t) {
        if (!(!this._map || this._map.dragging.moving() || this._map._animatingZoom)) {
          var e = this._map.mouseEventToLayerPoint(t);
          this._handleMouseHover(t, e);
        }
      },
      _handleMouseOut: function(t) {
        var e = this._hoveredLayer;
        e && (Q(this._container, "leaflet-interactive"), this._fireEvent([e], t, "mouseout"), this._hoveredLayer = null, this._mouseHoverThrottled = !1);
      },
      _handleMouseHover: function(t, e) {
        if (!this._mouseHoverThrottled) {
          for (var n, o, h = this._drawFirst; h; h = h.next)
            n = h.layer, n.options.interactive && n._containsPoint(e) && (o = n);
          o !== this._hoveredLayer && (this._handleMouseOut(t), o && (A(this._container, "leaflet-interactive"), this._fireEvent([o], t, "mouseover"), this._hoveredLayer = o)), this._fireEvent(this._hoveredLayer ? [this._hoveredLayer] : !1, t), this._mouseHoverThrottled = !0, setTimeout(d(function() {
            this._mouseHoverThrottled = !1;
          }, this), 32);
        }
      },
      _fireEvent: function(t, e, n) {
        this._map._fireDOMEvent(e, n || e.type, t);
      },
      _bringToFront: function(t) {
        var e = t._order;
        if (e) {
          var n = e.next, o = e.prev;
          if (n)
            n.prev = o;
          else
            return;
          o ? o.next = n : n && (this._drawFirst = n), e.prev = this._drawLast, this._drawLast.next = e, e.next = null, this._drawLast = e, this._requestRedraw(t);
        }
      },
      _bringToBack: function(t) {
        var e = t._order;
        if (e) {
          var n = e.next, o = e.prev;
          if (o)
            o.next = n;
          else
            return;
          n ? n.prev = o : o && (this._drawLast = o), e.prev = null, e.next = this._drawFirst, this._drawFirst.prev = e, this._drawFirst = e, this._requestRedraw(t);
        }
      }
    });
    function Ar(t) {
      return M.canvas ? new Er(t) : null;
    }
    var ti = function() {
      try {
        return document.namespaces.add("lvml", "urn:schemas-microsoft-com:vml"), function(t) {
          return document.createElement("<lvml:" + t + ' class="lvml">');
        };
      } catch {
      }
      return function(t) {
        return document.createElement("<" + t + ' xmlns="urn:schemas-microsoft.com:vml" class="lvml">');
      };
    }(), yh = {
      _initContainer: function() {
        this._container = B("div", "leaflet-vml-container");
      },
      _update: function() {
        this._map._animatingZoom || (Kt.prototype._update.call(this), this.fire("update"));
      },
      _initPath: function(t) {
        var e = t._container = ti("shape");
        A(e, "leaflet-vml-shape " + (this.options.className || "")), e.coordsize = "1 1", t._path = ti("path"), e.appendChild(t._path), this._updateStyle(t), this._layers[g(t)] = t;
      },
      _addPath: function(t) {
        var e = t._container;
        this._container.appendChild(e), t.options.interactive && t.addInteractiveTarget(e);
      },
      _removePath: function(t) {
        var e = t._container;
        $(e), t.removeInteractiveTarget(e), delete this._layers[g(t)];
      },
      _updateStyle: function(t) {
        var e = t._stroke, n = t._fill, o = t.options, h = t._container;
        h.stroked = !!o.stroke, h.filled = !!o.fill, o.stroke ? (e || (e = t._stroke = ti("stroke")), h.appendChild(e), e.weight = o.weight + "px", e.color = o.color, e.opacity = o.opacity, o.dashArray ? e.dashStyle = kt(o.dashArray) ? o.dashArray.join(" ") : o.dashArray.replace(/( *, *)/g, " ") : e.dashStyle = "", e.endcap = o.lineCap.replace("butt", "flat"), e.joinstyle = o.lineJoin) : e && (h.removeChild(e), t._stroke = null), o.fill ? (n || (n = t._fill = ti("fill")), h.appendChild(n), n.color = o.fillColor || o.color, n.opacity = o.fillOpacity) : n && (h.removeChild(n), t._fill = null);
      },
      _updateCircle: function(t) {
        var e = t._point.round(), n = Math.round(t._radius), o = Math.round(t._radiusY || n);
        this._setPath(t, t._empty() ? "M0 0" : "AL " + e.x + "," + e.y + " " + n + "," + o + " 0," + 65535 * 360);
      },
      _setPath: function(t, e) {
        t._path.v = e;
      },
      _bringToFront: function(t) {
        Le(t._container);
      },
      _bringToBack: function(t) {
        Me(t._container);
      }
    }, zi = M.vml ? ti : Rs, ei = Kt.extend({
      _initContainer: function() {
        this._container = zi("svg"), this._container.setAttribute("pointer-events", "none"), this._rootGroup = zi("g"), this._container.appendChild(this._rootGroup);
      },
      _destroyContainer: function() {
        $(this._container), j(this._container), delete this._container, delete this._rootGroup, delete this._svgSize;
      },
      _update: function() {
        if (!(this._map._animatingZoom && this._bounds)) {
          Kt.prototype._update.call(this);
          var t = this._bounds, e = t.getSize(), n = this._container;
          (!this._svgSize || !this._svgSize.equals(e)) && (this._svgSize = e, n.setAttribute("width", e.x), n.setAttribute("height", e.y)), it(n, t.min), n.setAttribute("viewBox", [t.min.x, t.min.y, e.x, e.y].join(" ")), this.fire("update");
        }
      },
      // methods below are called by vector layers implementations
      _initPath: function(t) {
        var e = t._path = zi("path");
        t.options.className && A(e, t.options.className), t.options.interactive && A(e, "leaflet-interactive"), this._updateStyle(t), this._layers[g(t)] = t;
      },
      _addPath: function(t) {
        this._rootGroup || this._initContainer(), this._rootGroup.appendChild(t._path), t.addInteractiveTarget(t._path);
      },
      _removePath: function(t) {
        $(t._path), t.removeInteractiveTarget(t._path), delete this._layers[g(t)];
      },
      _updatePath: function(t) {
        t._project(), t._update();
      },
      _updateStyle: function(t) {
        var e = t._path, n = t.options;
        e && (n.stroke ? (e.setAttribute("stroke", n.color), e.setAttribute("stroke-opacity", n.opacity), e.setAttribute("stroke-width", n.weight), e.setAttribute("stroke-linecap", n.lineCap), e.setAttribute("stroke-linejoin", n.lineJoin), n.dashArray ? e.setAttribute("stroke-dasharray", n.dashArray) : e.removeAttribute("stroke-dasharray"), n.dashOffset ? e.setAttribute("stroke-dashoffset", n.dashOffset) : e.removeAttribute("stroke-dashoffset")) : e.setAttribute("stroke", "none"), n.fill ? (e.setAttribute("fill", n.fillColor || n.color), e.setAttribute("fill-opacity", n.fillOpacity), e.setAttribute("fill-rule", n.fillRule || "evenodd")) : e.setAttribute("fill", "none"));
      },
      _updatePoly: function(t, e) {
        this._setPath(t, Zs(t._parts, e));
      },
      _updateCircle: function(t) {
        var e = t._point, n = Math.max(Math.round(t._radius), 1), o = Math.max(Math.round(t._radiusY), 1) || n, h = "a" + n + "," + o + " 0 1,0 ", l = t._empty() ? "M0 0" : "M" + (e.x - n) + "," + e.y + h + n * 2 + ",0 " + h + -n * 2 + ",0 ";
        this._setPath(t, l);
      },
      _setPath: function(t, e) {
        t._path.setAttribute("d", e);
      },
      // SVG does not have the concept of zIndex so we resort to changing the DOM order of elements
      _bringToFront: function(t) {
        Le(t._path);
      },
      _bringToBack: function(t) {
        Me(t._path);
      }
    });
    M.vml && ei.include(yh);
    function zr(t) {
      return M.svg || M.vml ? new ei(t) : null;
    }
    R.include({
      // @namespace Map; @method getRenderer(layer: Path): Renderer
      // Returns the instance of `Renderer` that should be used to render the given
      // `Path`. It will ensure that the `renderer` options of the map and paths
      // are respected, and that the renderers do exist on the map.
      getRenderer: function(t) {
        var e = t.options.renderer || this._getPaneRenderer(t.options.pane) || this.options.renderer || this._renderer;
        return e || (e = this._renderer = this._createRenderer()), this.hasLayer(e) || this.addLayer(e), e;
      },
      _getPaneRenderer: function(t) {
        if (t === "overlayPane" || t === void 0)
          return !1;
        var e = this._paneRenderers[t];
        return e === void 0 && (e = this._createRenderer({ pane: t }), this._paneRenderers[t] = e), e;
      },
      _createRenderer: function(t) {
        return this.options.preferCanvas && Ar(t) || zr(t);
      }
    });
    var Ir = Se.extend({
      initialize: function(t, e) {
        Se.prototype.initialize.call(this, this._boundsToLatLngs(t), e);
      },
      // @method setBounds(latLngBounds: LatLngBounds): this
      // Redraws the rectangle with the passed bounds.
      setBounds: function(t) {
        return this.setLatLngs(this._boundsToLatLngs(t));
      },
      _boundsToLatLngs: function(t) {
        return t = et(t), [
          t.getSouthWest(),
          t.getNorthWest(),
          t.getNorthEast(),
          t.getSouthEast()
        ];
      }
    });
    function wh(t, e) {
      return new Ir(t, e);
    }
    ei.create = zi, ei.pointsToPath = Zs, qt.geometryToLayer = Si, qt.coordsToLatLng = Un, qt.coordsToLatLngs = ki, qt.latLngToCoords = Gn, qt.latLngsToCoords = Oi, qt.getFeature = ke, qt.asFeature = Ci, R.mergeOptions({
      // @option boxZoom: Boolean = true
      // Whether the map can be zoomed to a rectangular area specified by
      // dragging the mouse while pressing the shift key.
      boxZoom: !0
    });
    var Nr = Zt.extend({
      initialize: function(t) {
        this._map = t, this._container = t._container, this._pane = t._panes.overlayPane, this._resetStateTimeout = 0, t.on("unload", this._destroy, this);
      },
      addHooks: function() {
        C(this._container, "mousedown", this._onMouseDown, this);
      },
      removeHooks: function() {
        j(this._container, "mousedown", this._onMouseDown, this);
      },
      moved: function() {
        return this._moved;
      },
      _destroy: function() {
        $(this._pane), delete this._pane;
      },
      _resetState: function() {
        this._resetStateTimeout = 0, this._moved = !1;
      },
      _clearDeferredResetState: function() {
        this._resetStateTimeout !== 0 && (clearTimeout(this._resetStateTimeout), this._resetStateTimeout = 0);
      },
      _onMouseDown: function(t) {
        if (!t.shiftKey || t.which !== 1 && t.button !== 1)
          return !1;
        this._clearDeferredResetState(), this._resetState(), Ve(), Sn(), this._startPoint = this._map.mouseEventToContainerPoint(t), C(document, {
          contextmenu: _e,
          mousemove: this._onMouseMove,
          mouseup: this._onMouseUp,
          keydown: this._onKeyDown
        }, this);
      },
      _onMouseMove: function(t) {
        this._moved || (this._moved = !0, this._box = B("div", "leaflet-zoom-box", this._container), A(this._container, "leaflet-crosshair"), this._map.fire("boxzoomstart")), this._point = this._map.mouseEventToContainerPoint(t);
        var e = new J(this._point, this._startPoint), n = e.getSize();
        it(this._box, e.min), this._box.style.width = n.x + "px", this._box.style.height = n.y + "px";
      },
      _finish: function() {
        this._moved && ($(this._box), Q(this._container, "leaflet-crosshair")), je(), kn(), j(document, {
          contextmenu: _e,
          mousemove: this._onMouseMove,
          mouseup: this._onMouseUp,
          keydown: this._onKeyDown
        }, this);
      },
      _onMouseUp: function(t) {
        if (!(t.which !== 1 && t.button !== 1) && (this._finish(), !!this._moved)) {
          this._clearDeferredResetState(), this._resetStateTimeout = setTimeout(d(this._resetState, this), 0);
          var e = new _t(
            this._map.containerPointToLatLng(this._startPoint),
            this._map.containerPointToLatLng(this._point)
          );
          this._map.fitBounds(e).fire("boxzoomend", { boxZoomBounds: e });
        }
      },
      _onKeyDown: function(t) {
        t.keyCode === 27 && (this._finish(), this._clearDeferredResetState(), this._resetState());
      }
    });
    R.addInitHook("addHandler", "boxZoom", Nr), R.mergeOptions({
      // @option doubleClickZoom: Boolean|String = true
      // Whether the map can be zoomed in by double clicking on it and
      // zoomed out by double clicking while holding shift. If passed
      // `'center'`, double-click zoom will zoom to the center of the
      //  view regardless of where the mouse was.
      doubleClickZoom: !0
    });
    var Rr = Zt.extend({
      addHooks: function() {
        this._map.on("dblclick", this._onDoubleClick, this);
      },
      removeHooks: function() {
        this._map.off("dblclick", this._onDoubleClick, this);
      },
      _onDoubleClick: function(t) {
        var e = this._map, n = e.getZoom(), o = e.options.zoomDelta, h = t.originalEvent.shiftKey ? n - o : n + o;
        e.options.doubleClickZoom === "center" ? e.setZoom(h) : e.setZoomAround(t.containerPoint, h);
      }
    });
    R.addInitHook("addHandler", "doubleClickZoom", Rr), R.mergeOptions({
      // @option dragging: Boolean = true
      // Whether the map is draggable with mouse/touch or not.
      dragging: !0,
      // @section Panning Inertia Options
      // @option inertia: Boolean = *
      // If enabled, panning of the map will have an inertia effect where
      // the map builds momentum while dragging and continues moving in
      // the same direction for some time. Feels especially nice on touch
      // devices. Enabled by default.
      inertia: !0,
      // @option inertiaDeceleration: Number = 3000
      // The rate with which the inertial movement slows down, in pixels/second².
      inertiaDeceleration: 3400,
      // px/s^2
      // @option inertiaMaxSpeed: Number = Infinity
      // Max speed of the inertial movement, in pixels/second.
      inertiaMaxSpeed: 1 / 0,
      // px/s
      // @option easeLinearity: Number = 0.2
      easeLinearity: 0.2,
      // TODO refactor, move to CRS
      // @option worldCopyJump: Boolean = false
      // With this option enabled, the map tracks when you pan to another "copy"
      // of the world and seamlessly jumps to the original one so that all overlays
      // like markers and vector layers are still visible.
      worldCopyJump: !1,
      // @option maxBoundsViscosity: Number = 0.0
      // If `maxBounds` is set, this option will control how solid the bounds
      // are when dragging the map around. The default value of `0.0` allows the
      // user to drag outside the bounds at normal speed, higher values will
      // slow down map dragging outside bounds, and `1.0` makes the bounds fully
      // solid, preventing the user from dragging outside the bounds.
      maxBoundsViscosity: 0
    });
    var Zr = Zt.extend({
      addHooks: function() {
        if (!this._draggable) {
          var t = this._map;
          this._draggable = new re(t._mapPane, t._container), this._draggable.on({
            dragstart: this._onDragStart,
            drag: this._onDrag,
            dragend: this._onDragEnd
          }, this), this._draggable.on("predrag", this._onPreDragLimit, this), t.options.worldCopyJump && (this._draggable.on("predrag", this._onPreDragWrap, this), t.on("zoomend", this._onZoomEnd, this), t.whenReady(this._onZoomEnd, this));
        }
        A(this._map._container, "leaflet-grab leaflet-touch-drag"), this._draggable.enable(), this._positions = [], this._times = [];
      },
      removeHooks: function() {
        Q(this._map._container, "leaflet-grab"), Q(this._map._container, "leaflet-touch-drag"), this._draggable.disable();
      },
      moved: function() {
        return this._draggable && this._draggable._moved;
      },
      moving: function() {
        return this._draggable && this._draggable._moving;
      },
      _onDragStart: function() {
        var t = this._map;
        if (t._stop(), this._map.options.maxBounds && this._map.options.maxBoundsViscosity) {
          var e = et(this._map.options.maxBounds);
          this._offsetLimit = dt(
            this._map.latLngToContainerPoint(e.getNorthWest()).multiplyBy(-1),
            this._map.latLngToContainerPoint(e.getSouthEast()).multiplyBy(-1).add(this._map.getSize())
          ), this._viscosity = Math.min(1, Math.max(0, this._map.options.maxBoundsViscosity));
        } else
          this._offsetLimit = null;
        t.fire("movestart").fire("dragstart"), t.options.inertia && (this._positions = [], this._times = []);
      },
      _onDrag: function(t) {
        if (this._map.options.inertia) {
          var e = this._lastTime = +/* @__PURE__ */ new Date(), n = this._lastPos = this._draggable._absPos || this._draggable._newPos;
          this._positions.push(n), this._times.push(e), this._prunePositions(e);
        }
        this._map.fire("move", t).fire("drag", t);
      },
      _prunePositions: function(t) {
        for (; this._positions.length > 1 && t - this._times[0] > 50; )
          this._positions.shift(), this._times.shift();
      },
      _onZoomEnd: function() {
        var t = this._map.getSize().divideBy(2), e = this._map.latLngToLayerPoint([0, 0]);
        this._initialWorldOffset = e.subtract(t).x, this._worldWidth = this._map.getPixelWorldBounds().getSize().x;
      },
      _viscousLimit: function(t, e) {
        return t - (t - e) * this._viscosity;
      },
      _onPreDragLimit: function() {
        if (!(!this._viscosity || !this._offsetLimit)) {
          var t = this._draggable._newPos.subtract(this._draggable._startPos), e = this._offsetLimit;
          t.x < e.min.x && (t.x = this._viscousLimit(t.x, e.min.x)), t.y < e.min.y && (t.y = this._viscousLimit(t.y, e.min.y)), t.x > e.max.x && (t.x = this._viscousLimit(t.x, e.max.x)), t.y > e.max.y && (t.y = this._viscousLimit(t.y, e.max.y)), this._draggable._newPos = this._draggable._startPos.add(t);
        }
      },
      _onPreDragWrap: function() {
        var t = this._worldWidth, e = Math.round(t / 2), n = this._initialWorldOffset, o = this._draggable._newPos.x, h = (o - e + n) % t + e - n, l = (o + e + n) % t - e - n, f = Math.abs(h + n) < Math.abs(l + n) ? h : l;
        this._draggable._absPos = this._draggable._newPos.clone(), this._draggable._newPos.x = f;
      },
      _onDragEnd: function(t) {
        var e = this._map, n = e.options, o = !n.inertia || t.noInertia || this._times.length < 2;
        if (e.fire("dragend", t), o)
          e.fire("moveend");
        else {
          this._prunePositions(+/* @__PURE__ */ new Date());
          var h = this._lastPos.subtract(this._positions[0]), l = (this._lastTime - this._times[0]) / 1e3, f = n.easeLinearity, _ = h.multiplyBy(f / l), m = _.distanceTo([0, 0]), p = Math.min(n.inertiaMaxSpeed, m), x = _.multiplyBy(p / m), T = p / (n.inertiaDeceleration * f), z = x.multiplyBy(-T / 2).round();
          !z.x && !z.y ? e.fire("moveend") : (z = e._limitOffset(z, e.options.maxBounds), ft(function() {
            e.panBy(z, {
              duration: T,
              easeLinearity: f,
              noMoveStart: !0,
              animate: !0
            });
          }));
        }
      }
    });
    R.addInitHook("addHandler", "dragging", Zr), R.mergeOptions({
      // @option keyboard: Boolean = true
      // Makes the map focusable and allows users to navigate the map with keyboard
      // arrows and `+`/`-` keys.
      keyboard: !0,
      // @option keyboardPanDelta: Number = 80
      // Amount of pixels to pan when pressing an arrow key.
      keyboardPanDelta: 80
    });
    var Br = Zt.extend({
      keyCodes: {
        left: [37],
        right: [39],
        down: [40],
        up: [38],
        zoomIn: [187, 107, 61, 171],
        zoomOut: [189, 109, 54, 173]
      },
      initialize: function(t) {
        this._map = t, this._setPanDelta(t.options.keyboardPanDelta), this._setZoomDelta(t.options.zoomDelta);
      },
      addHooks: function() {
        var t = this._map._container;
        t.tabIndex <= 0 && (t.tabIndex = "0"), C(t, {
          focus: this._onFocus,
          blur: this._onBlur,
          mousedown: this._onMouseDown
        }, this), this._map.on({
          focus: this._addHooks,
          blur: this._removeHooks
        }, this);
      },
      removeHooks: function() {
        this._removeHooks(), j(this._map._container, {
          focus: this._onFocus,
          blur: this._onBlur,
          mousedown: this._onMouseDown
        }, this), this._map.off({
          focus: this._addHooks,
          blur: this._removeHooks
        }, this);
      },
      _onMouseDown: function() {
        if (!this._focused) {
          var t = document.body, e = document.documentElement, n = t.scrollTop || e.scrollTop, o = t.scrollLeft || e.scrollLeft;
          this._map._container.focus(), window.scrollTo(o, n);
        }
      },
      _onFocus: function() {
        this._focused = !0, this._map.fire("focus");
      },
      _onBlur: function() {
        this._focused = !1, this._map.fire("blur");
      },
      _setPanDelta: function(t) {
        var e = this._panKeys = {}, n = this.keyCodes, o, h;
        for (o = 0, h = n.left.length; o < h; o++)
          e[n.left[o]] = [-1 * t, 0];
        for (o = 0, h = n.right.length; o < h; o++)
          e[n.right[o]] = [t, 0];
        for (o = 0, h = n.down.length; o < h; o++)
          e[n.down[o]] = [0, t];
        for (o = 0, h = n.up.length; o < h; o++)
          e[n.up[o]] = [0, -1 * t];
      },
      _setZoomDelta: function(t) {
        var e = this._zoomKeys = {}, n = this.keyCodes, o, h;
        for (o = 0, h = n.zoomIn.length; o < h; o++)
          e[n.zoomIn[o]] = t;
        for (o = 0, h = n.zoomOut.length; o < h; o++)
          e[n.zoomOut[o]] = -t;
      },
      _addHooks: function() {
        C(document, "keydown", this._onKeyDown, this);
      },
      _removeHooks: function() {
        j(document, "keydown", this._onKeyDown, this);
      },
      _onKeyDown: function(t) {
        if (!(t.altKey || t.ctrlKey || t.metaKey)) {
          var e = t.keyCode, n = this._map, o;
          if (e in this._panKeys) {
            if (!n._panAnim || !n._panAnim._inProgress)
              if (o = this._panKeys[e], t.shiftKey && (o = S(o).multiplyBy(3)), n.options.maxBounds && (o = n._limitOffset(S(o), n.options.maxBounds)), n.options.worldCopyJump) {
                var h = n.wrapLatLng(n.unproject(n.project(n.getCenter()).add(o)));
                n.panTo(h);
              } else
                n.panBy(o);
          } else if (e in this._zoomKeys)
            n.setZoom(n.getZoom() + (t.shiftKey ? 3 : 1) * this._zoomKeys[e]);
          else if (e === 27 && n._popup && n._popup.options.closeOnEscapeKey)
            n.closePopup();
          else
            return;
          _e(t);
        }
      }
    });
    R.addInitHook("addHandler", "keyboard", Br), R.mergeOptions({
      // @section Mouse wheel options
      // @option scrollWheelZoom: Boolean|String = true
      // Whether the map can be zoomed by using the mouse wheel. If passed `'center'`,
      // it will zoom to the center of the view regardless of where the mouse was.
      scrollWheelZoom: !0,
      // @option wheelDebounceTime: Number = 40
      // Limits the rate at which a wheel can fire (in milliseconds). By default
      // user can't zoom via wheel more often than once per 40 ms.
      wheelDebounceTime: 40,
      // @option wheelPxPerZoomLevel: Number = 60
      // How many scroll pixels (as reported by [L.DomEvent.getWheelDelta](#domevent-getwheeldelta))
      // mean a change of one full zoom level. Smaller values will make wheel-zooming
      // faster (and vice versa).
      wheelPxPerZoomLevel: 60
    });
    var Yr = Zt.extend({
      addHooks: function() {
        C(this._map._container, "wheel", this._onWheelScroll, this), this._delta = 0;
      },
      removeHooks: function() {
        j(this._map._container, "wheel", this._onWheelScroll, this);
      },
      _onWheelScroll: function(t) {
        var e = lr(t), n = this._map.options.wheelDebounceTime;
        this._delta += e, this._lastMousePos = this._map.mouseEventToContainerPoint(t), this._startTime || (this._startTime = +/* @__PURE__ */ new Date());
        var o = Math.max(n - (+/* @__PURE__ */ new Date() - this._startTime), 0);
        clearTimeout(this._timer), this._timer = setTimeout(d(this._performZoom, this), o), _e(t);
      },
      _performZoom: function() {
        var t = this._map, e = t.getZoom(), n = this._map.options.zoomSnap || 0;
        t._stop();
        var o = this._delta / (this._map.options.wheelPxPerZoomLevel * 4), h = 4 * Math.log(2 / (1 + Math.exp(-Math.abs(o)))) / Math.LN2, l = n ? Math.ceil(h / n) * n : h, f = t._limitZoom(e + (this._delta > 0 ? l : -l)) - e;
        this._delta = 0, this._startTime = null, f && (t.options.scrollWheelZoom === "center" ? t.setZoom(e + f) : t.setZoomAround(this._lastMousePos, e + f));
      }
    });
    R.addInitHook("addHandler", "scrollWheelZoom", Yr);
    var xh = 600;
    R.mergeOptions({
      // @section Touch interaction options
      // @option tapHold: Boolean
      // Enables simulation of `contextmenu` event, default is `true` for mobile Safari.
      tapHold: M.touchNative && M.safari && M.mobile,
      // @option tapTolerance: Number = 15
      // The max number of pixels a user can shift his finger during touch
      // for it to be considered a valid tap.
      tapTolerance: 15
    });
    var Wr = Zt.extend({
      addHooks: function() {
        C(this._map._container, "touchstart", this._onDown, this);
      },
      removeHooks: function() {
        j(this._map._container, "touchstart", this._onDown, this);
      },
      _onDown: function(t) {
        if (clearTimeout(this._holdTimeout), t.touches.length === 1) {
          var e = t.touches[0];
          this._startPos = this._newPos = new O(e.clientX, e.clientY), this._holdTimeout = setTimeout(d(function() {
            this._cancel(), this._isTapValid() && (C(document, "touchend", at), C(document, "touchend touchcancel", this._cancelClickPrevent), this._simulateEvent("contextmenu", e));
          }, this), xh), C(document, "touchend touchcancel contextmenu", this._cancel, this), C(document, "touchmove", this._onMove, this);
        }
      },
      _cancelClickPrevent: function t() {
        j(document, "touchend", at), j(document, "touchend touchcancel", t);
      },
      _cancel: function() {
        clearTimeout(this._holdTimeout), j(document, "touchend touchcancel contextmenu", this._cancel, this), j(document, "touchmove", this._onMove, this);
      },
      _onMove: function(t) {
        var e = t.touches[0];
        this._newPos = new O(e.clientX, e.clientY);
      },
      _isTapValid: function() {
        return this._newPos.distanceTo(this._startPos) <= this._map.options.tapTolerance;
      },
      _simulateEvent: function(t, e) {
        var n = new MouseEvent(t, {
          bubbles: !0,
          cancelable: !0,
          view: window,
          // detail: 1,
          screenX: e.screenX,
          screenY: e.screenY,
          clientX: e.clientX,
          clientY: e.clientY
          // button: 2,
          // buttons: 2
        });
        n._simulated = !0, e.target.dispatchEvent(n);
      }
    });
    R.addInitHook("addHandler", "tapHold", Wr), R.mergeOptions({
      // @section Touch interaction options
      // @option touchZoom: Boolean|String = *
      // Whether the map can be zoomed by touch-dragging with two fingers. If
      // passed `'center'`, it will zoom to the center of the view regardless of
      // where the touch events (fingers) were. Enabled for touch-capable web
      // browsers.
      touchZoom: M.touch,
      // @option bounceAtZoomLimits: Boolean = true
      // Set it to false if you don't want the map to zoom beyond min/max zoom
      // and then bounce back when pinch-zooming.
      bounceAtZoomLimits: !0
    });
    var Fr = Zt.extend({
      addHooks: function() {
        A(this._map._container, "leaflet-touch-zoom"), C(this._map._container, "touchstart", this._onTouchStart, this);
      },
      removeHooks: function() {
        Q(this._map._container, "leaflet-touch-zoom"), j(this._map._container, "touchstart", this._onTouchStart, this);
      },
      _onTouchStart: function(t) {
        var e = this._map;
        if (!(!t.touches || t.touches.length !== 2 || e._animatingZoom || this._zooming)) {
          var n = e.mouseEventToContainerPoint(t.touches[0]), o = e.mouseEventToContainerPoint(t.touches[1]);
          this._centerPoint = e.getSize()._divideBy(2), this._startLatLng = e.containerPointToLatLng(this._centerPoint), e.options.touchZoom !== "center" && (this._pinchStartLatLng = e.containerPointToLatLng(n.add(o)._divideBy(2))), this._startDist = n.distanceTo(o), this._startZoom = e.getZoom(), this._moved = !1, this._zooming = !0, e._stop(), C(document, "touchmove", this._onTouchMove, this), C(document, "touchend touchcancel", this._onTouchEnd, this), at(t);
        }
      },
      _onTouchMove: function(t) {
        if (!(!t.touches || t.touches.length !== 2 || !this._zooming)) {
          var e = this._map, n = e.mouseEventToContainerPoint(t.touches[0]), o = e.mouseEventToContainerPoint(t.touches[1]), h = n.distanceTo(o) / this._startDist;
          if (this._zoom = e.getScaleZoom(h, this._startZoom), !e.options.bounceAtZoomLimits && (this._zoom < e.getMinZoom() && h < 1 || this._zoom > e.getMaxZoom() && h > 1) && (this._zoom = e._limitZoom(this._zoom)), e.options.touchZoom === "center") {
            if (this._center = this._startLatLng, h === 1)
              return;
          } else {
            var l = n._add(o)._divideBy(2)._subtract(this._centerPoint);
            if (h === 1 && l.x === 0 && l.y === 0)
              return;
            this._center = e.unproject(e.project(this._pinchStartLatLng, this._zoom).subtract(l), this._zoom);
          }
          this._moved || (e._moveStart(!0, !1), this._moved = !0), xt(this._animRequest);
          var f = d(e._move, e, this._center, this._zoom, { pinch: !0, round: !1 }, void 0);
          this._animRequest = ft(f, this, !0), at(t);
        }
      },
      _onTouchEnd: function() {
        if (!this._moved || !this._zooming) {
          this._zooming = !1;
          return;
        }
        this._zooming = !1, xt(this._animRequest), j(document, "touchmove", this._onTouchMove, this), j(document, "touchend touchcancel", this._onTouchEnd, this), this._map.options.zoomAnimation ? this._map._animateZoom(this._center, this._map._limitZoom(this._zoom), !0, this._map.options.zoomSnap) : this._map._resetView(this._center, this._map._limitZoom(this._zoom));
      }
    });
    R.addInitHook("addHandler", "touchZoom", Fr), R.BoxZoom = Nr, R.DoubleClickZoom = Rr, R.Drag = Zr, R.Keyboard = Br, R.ScrollWheelZoom = Yr, R.TapHold = Wr, R.TouchZoom = Fr, r.Bounds = J, r.Browser = M, r.CRS = Gt, r.Canvas = Er, r.Circle = Hn, r.CircleMarker = Ti, r.Class = Ut, r.Control = Ot, r.DivIcon = Or, r.DivOverlay = Bt, r.DomEvent = Ba, r.DomUtil = Ra, r.Draggable = re, r.Evented = We, r.FeatureGroup = Vt, r.GeoJSON = qt, r.GridLayer = Qe, r.Handler = Zt, r.Icon = Te, r.ImageOverlay = Di, r.LatLng = G, r.LatLngBounds = _t, r.Layer = Ct, r.LayerGroup = be, r.LineUtil = $a, r.Map = R, r.Marker = bi, r.Mixin = Va, r.Path = oe, r.Point = O, r.PolyUtil = ja, r.Polygon = Se, r.Polyline = jt, r.Popup = Ei, r.PosAnimation = cr, r.Projection = Qa, r.Rectangle = Ir, r.Renderer = Kt, r.SVG = ei, r.SVGOverlay = kr, r.TileLayer = Oe, r.Tooltip = Ai, r.Transformation = mn, r.Util = ra, r.VideoOverlay = Sr, r.bind = d, r.bounds = dt, r.canvas = Ar, r.circle = ah, r.circleMarker = oh, r.control = Xe, r.divIcon = ph, r.extend = u, r.featureGroup = nh, r.geoJSON = Tr, r.geoJson = lh, r.gridLayer = gh, r.icon = sh, r.imageOverlay = ch, r.latLng = N, r.latLngBounds = et, r.layerGroup = ih, r.map = Ya, r.marker = rh, r.point = S, r.polygon = uh, r.polyline = hh, r.popup = _h, r.rectangle = wh, r.setOptions = U, r.stamp = g, r.svg = zr, r.svgOverlay = dh, r.tileLayer = Cr, r.tooltip = mh, r.transformation = Fe, r.version = a, r.videoOverlay = fh;
    var Ph = window.L;
    r.noConflict = function() {
      return window.L = Ph, this;
    }, window.L = r;
  });
})(os, os.exports);
var Ye = os.exports;
const un = /* @__PURE__ */ Ko(Ye);
var Xo = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(i) {
  (function() {
    var s = {}.hasOwnProperty;
    function r() {
      for (var a = [], u = 0; u < arguments.length; u++) {
        var c = arguments[u];
        if (c) {
          var d = typeof c;
          if (d === "string" || d === "number")
            a.push(c);
          else if (Array.isArray(c)) {
            if (c.length) {
              var y = r.apply(null, c);
              y && a.push(y);
            }
          } else if (d === "object") {
            if (c.toString !== Object.prototype.toString && !c.toString.toString().includes("[native code]")) {
              a.push(c.toString());
              continue;
            }
            for (var g in c)
              s.call(c, g) && c[g] && a.push(g);
          }
        }
      }
      return a.join(" ");
    }
    i.exports ? (r.default = r, i.exports = r) : window.classNames = r;
  })();
})(Xo);
var Bf = Xo.exports;
const ze = /* @__PURE__ */ Ko(Bf);
function Jo(i, s) {
  const r = ve(s);
  we(function() {
    s !== r.current && i.attributionControl != null && (r.current != null && i.attributionControl.removeAttribution(r.current), s != null && i.attributionControl.addAttribution(s)), r.current = s;
  }, [
    i,
    s
  ]);
}
const Yf = 1;
function Wf(i) {
  return Object.freeze({
    __version: Yf,
    map: i
  });
}
function $o(i, s) {
  return Object.freeze({
    ...i,
    ...s
  });
}
const Qo = Qr(null), ta = Qo.Provider;
function ea() {
  const i = to(Qo);
  if (i == null)
    throw new Error("No context provided: useLeafletContext() can only be used in a descendant of <MapContainer>");
  return i;
}
function Ff(i) {
  function s(r, a) {
    const { instance: u, context: c } = i(r).current;
    return Ki(a, () => u), r.children == null ? null : /* @__PURE__ */ $n.createElement(ta, {
      value: c
    }, r.children);
  }
  return /* @__PURE__ */ qi(s);
}
function Hf(i) {
  function s(r, a) {
    const [u, c] = Wi(!1), { instance: d } = i(r, c).current;
    Ki(a, () => d), we(function() {
      u && d.update();
    }, [
      d,
      u,
      r.children
    ]);
    const y = d._contentNode;
    return y ? /* @__PURE__ */ zh(r.children, y) : null;
  }
  return /* @__PURE__ */ qi(s);
}
function Uf(i) {
  function s(r, a) {
    const { instance: u } = i(r).current;
    return Ki(a, () => u), null;
  }
  return /* @__PURE__ */ qi(s);
}
function ia(i, s) {
  const r = ve();
  we(function() {
    return s != null && i.instance.on(s), r.current = s, function() {
      r.current != null && i.instance.off(r.current), r.current = null;
    };
  }, [
    i,
    s
  ]);
}
function Os(i, s) {
  const r = i.pane ?? s.pane;
  return r ? {
    ...i,
    pane: r
  } : i;
}
function Gf(i, s) {
  return function(a, u) {
    const c = ea(), d = i(Os(a, c), c);
    return Jo(c.map, a.attribution), ia(d.current, a.eventHandlers), s(d.current, c, a, u), d;
  };
}
function ln(i, s, r) {
  return Object.freeze({
    instance: i,
    context: s,
    container: r
  });
}
function Cs(i, s) {
  return s == null ? function(a, u) {
    const c = ve();
    return c.current || (c.current = i(a, u)), c;
  } : function(a, u) {
    const c = ve();
    c.current || (c.current = i(a, u));
    const d = ve(a), { instance: y } = c.current;
    return we(function() {
      d.current !== a && (s(y, a, d.current), d.current = a);
    }, [
      y,
      a,
      u
    ]), c;
  };
}
function Vf(i, s) {
  we(function() {
    return (s.layerContainer ?? s.map).addLayer(i.instance), function() {
      var c;
      (c = s.layerContainer) == null || c.removeLayer(i.instance), s.map.removeLayer(i.instance);
    };
  }, [
    s,
    i
  ]);
}
function na(i) {
  return function(r) {
    const a = ea(), u = i(Os(r, a), a);
    return Jo(a.map, r.attribution), ia(u.current, r.eventHandlers), Vf(u.current, a), u;
  };
}
function sa(i, s) {
  const r = Cs(i, s), a = na(r);
  return Ff(a);
}
function jf(i, s) {
  const r = Cs(i), a = Gf(r, s);
  return Hf(a);
}
function qf(i, s) {
  const r = Cs(i, s), a = na(r);
  return Uf(a);
}
function Kf(i, s, r) {
  const { opacity: a, zIndex: u } = s;
  a != null && a !== r.opacity && i.setOpacity(a), u != null && u !== r.zIndex && i.setZIndex(u);
}
const Xf = sa(function({ children: s, ...r }, a) {
  const u = new Ye.LayerGroup([], r);
  return ln(u, $o(a, {
    layerContainer: u
  }));
});
function as() {
  return as = Object.assign || function(i) {
    for (var s = 1; s < arguments.length; s++) {
      var r = arguments[s];
      for (var a in r)
        Object.prototype.hasOwnProperty.call(r, a) && (i[a] = r[a]);
    }
    return i;
  }, as.apply(this, arguments);
}
function Jf({ bounds: i, boundsOptions: s, center: r, children: a, className: u, id: c, placeholder: d, style: y, whenReady: g, zoom: k, ...F }, D) {
  const [H] = Wi({
    className: u,
    id: c,
    style: y
  }), [rt, wt] = Wi(null);
  Ki(D, () => (rt == null ? void 0 : rt.map) ?? null, [
    rt
  ]);
  const U = Dh((mi) => {
    if (mi !== null && rt === null) {
      const le = new Ye.Map(mi, F);
      r != null && k != null ? le.setView(r, k) : i != null && le.fitBounds(i, s), g != null && le.whenReady(g), wt(Wf(le));
    }
  }, []);
  we(() => () => {
    rt == null || rt.map.remove();
  }, [
    rt
  ]);
  const _i = rt ? /* @__PURE__ */ $n.createElement(ta, {
    value: rt
  }, a) : d ?? null;
  return /* @__PURE__ */ $n.createElement("div", as({}, H, {
    ref: U
  }), _i);
}
const $f = /* @__PURE__ */ qi(Jf), Jr = sa(function({ position: s, ...r }, a) {
  const u = new Ye.Marker(s, r);
  return ln(u, $o(a, {
    overlayContainer: u
  }));
}, function(s, r, a) {
  r.position !== a.position && s.setLatLng(r.position), r.icon != null && r.icon !== a.icon && s.setIcon(r.icon), r.zIndexOffset != null && r.zIndexOffset !== a.zIndexOffset && s.setZIndexOffset(r.zIndexOffset), r.opacity != null && r.opacity !== a.opacity && s.setOpacity(r.opacity), s.dragging != null && r.draggable !== a.draggable && (r.draggable === !0 ? s.dragging.enable() : s.dragging.disable());
}), $r = jf(function(s, r) {
  const a = new Ye.Popup(s, r.overlayContainer);
  return ln(a, r);
}, function(s, r, { position: a }, u) {
  we(function() {
    const { instance: d } = s;
    function y(k) {
      k.popup === d && (d.update(), u(!0));
    }
    function g(k) {
      k.popup === d && u(!1);
    }
    return r.map.on({
      popupopen: y,
      popupclose: g
    }), r.overlayContainer == null ? (a != null && d.setLatLng(a), d.openOn(r.map)) : r.overlayContainer.bindPopup(d), function() {
      var F;
      r.map.off({
        popupopen: y,
        popupclose: g
      }), (F = r.overlayContainer) == null || F.unbindPopup(), r.map.removeLayer(d);
    };
  }, [
    s,
    r,
    u,
    a
  ]);
}), Qf = qf(function({ url: s, ...r }, a) {
  const u = new Ye.TileLayer(s, Os(r, a));
  return ln(u, a);
}, function(s, r, a) {
  Kf(s, r, a);
  const { url: u } = r;
  u != null && u !== a.url && s.setUrl(u);
}), td = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAApCAYAAADAk4LOAAAFgUlEQVR4Aa1XA5BjWRTN2oW17d3YaZtr2962HUzbDNpjszW24mRt28p47v7zq/bXZtrp/lWnXr337j3nPCe85NcypgSFdugCpW5YoDAMRaIMqRi6aKq5E3YqDQO3qAwjVWrD8Ncq/RBpykd8oZUb/kaJutow8r1aP9II0WmLKLIsJyv1w/kqw9Ch2MYdB++12Onxee/QMwvf4/Dk/Lfp/i4nxTXtOoQ4pW5Aj7wpici1A9erdAN2OH64x8OSP9j3Ft3b7aWkTg/Fm91siTra0f9on5sQr9INejH6CUUUpavjFNq1B+Oadhxmnfa8RfEmN8VNAsQhPqF55xHkMzz3jSmChWU6f7/XZKNH+9+hBLOHYozuKQPxyMPUKkrX/K0uWnfFaJGS1QPRtZsOPtr3NsW0uyh6NNCOkU3Yz+bXbT3I8G3xE5EXLXtCXbbqwCO9zPQYPRTZ5vIDXD7U+w7rFDEoUUf7ibHIR4y6bLVPXrz8JVZEql13trxwue/uDivd3fkWRbS6/IA2bID4uk0UpF1N8qLlbBlXs4Ee7HLTfV1j54APvODnSfOWBqtKVvjgLKzF5YdEk5ewRkGlK0i33Eofffc7HT56jD7/6U+qH3Cx7SBLNntH5YIPvODnyfIXZYRVDPqgHtLs5ABHD3YzLuespb7t79FY34DjMwrVrcTuwlT55YMPvOBnRrJ4VXTdNnYug5ucHLBjEpt30701A3Ts+HEa73u6dT3FNWwflY86eMHPk+Yu+i6pzUpRrW7SNDg5JHR4KapmM5Wv2E8Tfcb1HoqqHMHU+uWDD7zg54mz5/2BSnizi9T1Dg4QQXLToGNCkb6tb1NU+QAlGr1++eADrzhn/u8Q2YZhQVlZ5+CAOtqfbhmaUCS1ezNFVm2imDbPmPng5wmz+gwh+oHDce0eUtQ6OGDIyR0uUhUsoO3vfDmmgOezH0mZN59x7MBi++WDL1g/eEiU3avlidO671bkLfwbw5XV2P8Pzo0ydy4t2/0eu33xYSOMOD8hTf4CrBtGMSoXfPLchX+J0ruSePw3LZeK0juPJbYzrhkH0io7B3k164hiGvawhOKMLkrQLyVpZg8rHFW7E2uHOL888IBPlNZ1FPzstSJM694fWr6RwpvcJK60+0HCILTBzZLFNdtAzJaohze60T8qBzyh5ZuOg5e7uwQppofEmf2++DYvmySqGBuKaicF1blQjhuHdvCIMvp8whTTfZzI7RldpwtSzL+F1+wkdZ2TBOW2gIF88PBTzD/gpeREAMEbxnJcaJHNHrpzji0gQCS6hdkEeYt9DF/2qPcEC8RM28Hwmr3sdNyht00byAut2k3gufWNtgtOEOFGUwcXWNDbdNbpgBGxEvKkOQsxivJx33iow0Vw5S6SVTrpVq11ysA2Rp7gTfPfktc6zhtXBBC+adRLshf6sG2RfHPZ5EAc4sVZ83yCN00Fk/4kggu40ZTvIEm5g24qtU4KjBrx/BTTH8ifVASAG7gKrnWxJDcU7x8X6Ecczhm3o6YicvsLXWfh3Ch1W0k8x0nXF+0fFxgt4phz8QvypiwCCFKMqXCnqXExjq10beH+UUA7+nG6mdG/Pu0f3LgFcGrl2s0kNNjpmoJ9o4B29CMO8dMT4Q5ox8uitF6fqsrJOr8qnwNbRzv6hSnG5wP+64C7h9lp30hKNtKdWjtdkbuPA19nJ7Tz3zR/ibgARbhb4AlhavcBebmTHcFl2fvYEnW0ox9xMxKBS8btJ+KiEbq9zA4RthQXDhPa0T9TEe69gWupwc6uBUphquXgf+/FrIjweHQS4/pduMe5ERUMHUd9xv8ZR98CxkS4F2n3EUrUZ10EYNw7BWm9x1GiPssi3GgiGRDKWRYZfXlON+dfNbM+GgIwYdwAAAAASUVORK5CYII=", ed = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAApCAQAAAACach9AAACMUlEQVR4Ae3ShY7jQBAE0Aoz/f9/HTMzhg1zrdKUrJbdx+Kd2nD8VNudfsL/Th///dyQN2TH6f3y/BGpC379rV+S+qqetBOxImNQXL8JCAr2V4iMQXHGNJxeCfZXhSRBcQMfvkOWUdtfzlLgAENmZDcmo2TVmt8OSM2eXxBp3DjHSMFutqS7SbmemzBiR+xpKCNUIRkdkkYxhAkyGoBvyQFEJEefwSmmvBfJuJ6aKqKWnAkvGZOaZXTUgFqYULWNSHUckZuR1HIIimUExutRxwzOLROIG4vKmCKQt364mIlhSyzAf1m9lHZHJZrlAOMMztRRiKimp/rpdJDc9Awry5xTZCte7FHtuS8wJgeYGrex28xNTd086Dik7vUMscQOa8y4DoGtCCSkAKlNwpgNtphjrC6MIHUkR6YWxxs6Sc5xqn222mmCRFzIt8lEdKx+ikCtg91qS2WpwVfBelJCiQJwvzixfI9cxZQWgiSJelKnwBElKYtDOb2MFbhmUigbReQBV0Cg4+qMXSxXSyGUn4UbF8l+7qdSGnTC0XLCmahIgUHLhLOhpVCtw4CzYXvLQWQbJNmxoCsOKAxSgBJno75avolkRw8iIAFcsdc02e9iyCd8tHwmeSSoKTowIgvscSGZUOA7PuCN5b2BX9mQM7S0wYhMNU74zgsPBj3HU7wguAfnxxjFQGBE6pwN+GjME9zHY7zGp8wVxMShYX9NXvEWD3HbwJf4giO4CFIQxXScH1/TM+04kkBiAAAAAElFTkSuQmCC", id = un.icon({
  // Explicitly indicate where icon images are located
  iconUrl: td,
  shadowUrl: ed,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34]
});
un.Marker.prototype.options.icon = id;
const nd = 16, sd = "https://{s}.tile.osm.org/{z}/{x}/{y}.png", rd = ({
  center: i,
  zoom: s = nd,
  mapThemeUrl: r = sd,
  markerIcon: a,
  locationName: u,
  children: c,
  renderMarkerPopup: d,
  ...y
}) => {
  const { pois: g, mapRef: k } = hs(), F = () => ({
    ...a && {
      icon: new un.Icon(a)
    }
  }), D = (H) => d ? d(H) : /* @__PURE__ */ Dt(Ah, { children: H.name });
  return /* @__PURE__ */ si($f, { ...y, ref: k, center: i, zoom: s, children: [
    /* @__PURE__ */ Dt(Qf, { url: r }),
    c,
    /* @__PURE__ */ si(Xf, { children: [
      /* @__PURE__ */ Dt(Jr, { ...F(), position: i, children: u && /* @__PURE__ */ Dt($r, { children: u }) }),
      g.map((H) => /* @__PURE__ */ Dt(Jr, { position: H.position, children: /* @__PURE__ */ Dt($r, { children: D(H) }) }, H.id))
    ] })
  ] });
}, od = ({
  className: i = "z-[999] absolute top-2 right-2",
  ...s
}) => {
  const { currentPoi: r } = hs();
  if (!r)
    return null;
  const a = {
    ...(r == null ? void 0 : r.summary) ?? {},
    unit: "m"
  }, { distance: u } = Nf(a), { minutes: c } = qo(a.duration);
  return /* @__PURE__ */ si(
    "div",
    {
      ...s,
      className: ze(
        i,
        "bg-gray-100 py-2 px-3 shadow-md rounded-2xl leading-none inline-flex text-gray-600  gap-2"
      ),
      children: [
        /* @__PURE__ */ si("span", { children: [
          "Duración: ",
          c
        ] }),
        /* @__PURE__ */ si("span", { children: [
          "Distancia: ",
          u
        ] })
      ]
    }
  );
}, ad = (i) => {
  const { pois: s, handlePoiClick: r } = hs();
  return s.map(({ id: a, name: u }) => /* @__PURE__ */ Dt(
    "button",
    {
      ...i,
      className: "bg-white border border-indigo-500 text-indigo-800 hover:ring-2 py-2 px-4 rounded-md shadow-md",
      onClick: () => r(a),
      children: u
    },
    a
  ));
};
const Ds = ({ pois: i = [], children: s, className: r, routeColor: a = "blue", ...u }) => {
  const [c, d] = Wi(null), y = ve(null), g = ve(null), k = (F) => {
    var rt, wt;
    if (!(y != null && y.current))
      return;
    y.current.invalidateSize(), g != null && g.current && y.current.removeLayer(g.current);
    const D = i.find((U) => U.id === F);
    if (!((rt = D == null ? void 0 : D.routeCoordinates) != null && rt.length))
      return;
    const { routeCoordinates: H } = D;
    d(D), g.current = un.polyline(Rf(H), {
      color: a,
      dashArray: "5, 5",
      dashOffset: "5"
    }).addTo(y.current), y.current.fitBounds((wt = g == null ? void 0 : g.current) == null ? void 0 : wt.getBounds());
  };
  return /* @__PURE__ */ Dt(eo.Provider, { value: { currentPoi: c, pois: i, handlePoiClick: k, mapRef: y }, children: /* @__PURE__ */ Dt("div", { className: ze(r, "MapBoxContainer"), ...u, children: s }) });
};
Ds.Map = rd;
Ds.Summary = od;
Ds.PoisActions = ad;
const cd = ({ isOpen: i = !1, color: s = "white", ...r }) => {
  const [a, u, c] = Eh(() => ({
    white: ["before:bg-white", "bg-white", "after:bg-white"]
  })[s || "white"], [s]), d = {
    button: ze("group w-10 h-6 relative flex items-center justify-center"),
    bars: ze(
      // Middle Bar
      "transform -translate-y-50 -translate-x-50 block h-1 w-full transition-width duration-75 shadow-lg",
      {
        [u]: !i,
        "bg-transparent": i
      },
      // Top Bar
      ze(
        "before:content-[''] before:absolute before:left-0 before:h-full before:w-full before:transition-all before:shadow-lg",
        a,
        {
          "before:-top-2.5": !i,
          "before:top-0 before:-rotate-45": i
        }
      ),
      // Bottom Bar
      ze(
        "after::content-[''] after:absolute after:left-0 after:h-full after:w-full after:transition-all after:shadow-lg",
        c,
        {
          "after:-bottom-2.5": !i,
          "after:rotate-45 after:-bottom-0": i
        }
      )
    )
  };
  return /* @__PURE__ */ Dt("button", { ...r, className: d.button, children: /* @__PURE__ */ Dt("span", { className: d.bars }) });
};
export {
  Ds as MapBox,
  eo as MapBoxContext,
  cd as MenuToggle,
  qo as getDurationInSegments,
  Nf as getHumanizedTimeAndDistanceFromSummary,
  Rf as switchLatLonIndex,
  hs as useMapBoxContext
};
